(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components'), require('react-dom')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components', 'react-dom'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['@all-turtles/mmhmm-ui-kit'] = {}, global.React, global.styled, global.reactDom));
}(this, (function (exports, React, styled, reactDom) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn) {
    var module = { exports: {} };
  	return fn(module, module.exports), module.exports;
  }

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
  Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
  function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
  var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
  var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
  var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

  var reactIs_production_min = {
  	AsyncMode: AsyncMode,
  	ConcurrentMode: ConcurrentMode,
  	ContextConsumer: ContextConsumer,
  	ContextProvider: ContextProvider,
  	Element: Element$1,
  	ForwardRef: ForwardRef,
  	Fragment: Fragment,
  	Lazy: Lazy,
  	Memo: Memo,
  	Portal: Portal,
  	Profiler: Profiler,
  	StrictMode: StrictMode,
  	Suspense: Suspense,
  	isAsyncMode: isAsyncMode,
  	isConcurrentMode: isConcurrentMode,
  	isContextConsumer: isContextConsumer,
  	isContextProvider: isContextProvider,
  	isElement: isElement,
  	isForwardRef: isForwardRef,
  	isFragment: isFragment,
  	isLazy: isLazy,
  	isMemo: isMemo,
  	isPortal: isPortal,
  	isProfiler: isProfiler,
  	isStrictMode: isStrictMode,
  	isSuspense: isSuspense,
  	isValidElementType: isValidElementType,
  	typeOf: typeOf
  };

  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var reactIs_development = createCommonjsModule(function (module, exports) {



  if (process.env.NODE_ENV !== "production") {
    (function() {

  // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
  // nor polyfill, then a plain number is used for performance.
  var hasSymbol = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
  var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
  var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
  var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
  var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
  var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
  var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
  // (unstable) APIs that have been removed. Can we remove the symbols?

  var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
  var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
  var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
  var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
  var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
  var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
  var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
  var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
  var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
  var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
  var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

  function isValidElementType(type) {
    return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
    type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
  }

  function typeOf(object) {
    if (typeof object === 'object' && object !== null) {
      var $$typeof = object.$$typeof;

      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          var type = object.type;

          switch (type) {
            case REACT_ASYNC_MODE_TYPE:
            case REACT_CONCURRENT_MODE_TYPE:
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
              return type;

            default:
              var $$typeofType = type && type.$$typeof;

              switch ($$typeofType) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                case REACT_PROVIDER_TYPE:
                  return $$typeofType;

                default:
                  return $$typeof;
              }

          }

        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }

    return undefined;
  } // AsyncMode is deprecated along with isAsyncMode

  var AsyncMode = REACT_ASYNC_MODE_TYPE;
  var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
  var ContextConsumer = REACT_CONTEXT_TYPE;
  var ContextProvider = REACT_PROVIDER_TYPE;
  var Element = REACT_ELEMENT_TYPE;
  var ForwardRef = REACT_FORWARD_REF_TYPE;
  var Fragment = REACT_FRAGMENT_TYPE;
  var Lazy = REACT_LAZY_TYPE;
  var Memo = REACT_MEMO_TYPE;
  var Portal = REACT_PORTAL_TYPE;
  var Profiler = REACT_PROFILER_TYPE;
  var StrictMode = REACT_STRICT_MODE_TYPE;
  var Suspense = REACT_SUSPENSE_TYPE;
  var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

  function isAsyncMode(object) {
    {
      if (!hasWarnedAboutDeprecatedIsAsyncMode) {
        hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

        console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
      }
    }

    return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
  }
  function isConcurrentMode(object) {
    return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
  }
  function isContextConsumer(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  }
  function isContextProvider(object) {
    return typeOf(object) === REACT_PROVIDER_TYPE;
  }
  function isElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
  function isForwardRef(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  }
  function isFragment(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  }
  function isLazy(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  }
  function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  }
  function isPortal(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  }
  function isProfiler(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  }
  function isStrictMode(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  }
  function isSuspense(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  }

  exports.AsyncMode = AsyncMode;
  exports.ConcurrentMode = ConcurrentMode;
  exports.ContextConsumer = ContextConsumer;
  exports.ContextProvider = ContextProvider;
  exports.Element = Element;
  exports.ForwardRef = ForwardRef;
  exports.Fragment = Fragment;
  exports.Lazy = Lazy;
  exports.Memo = Memo;
  exports.Portal = Portal;
  exports.Profiler = Profiler;
  exports.StrictMode = StrictMode;
  exports.Suspense = Suspense;
  exports.isAsyncMode = isAsyncMode;
  exports.isConcurrentMode = isConcurrentMode;
  exports.isContextConsumer = isContextConsumer;
  exports.isContextProvider = isContextProvider;
  exports.isElement = isElement;
  exports.isForwardRef = isForwardRef;
  exports.isFragment = isFragment;
  exports.isLazy = isLazy;
  exports.isMemo = isMemo;
  exports.isPortal = isPortal;
  exports.isProfiler = isProfiler;
  exports.isStrictMode = isStrictMode;
  exports.isSuspense = isSuspense;
  exports.isValidElementType = isValidElementType;
  exports.typeOf = typeOf;
    })();
  }
  });

  var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
  });

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols) {
  			symbols = getOwnPropertySymbols(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var printWarning = function() {};

  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    printWarning = function(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error(
                (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
                'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
              );
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || 'React class') + ': type specification of ' +
              location + ' `' + typeSpecName + '` is invalid; the type checker ' +
              'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
              'You may have forgotten to pass an argument to the type checker ' +
              'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
              'shape all require an argument).'
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;

            var stack = getStack ? getStack() : '';

            printWarning(
              'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
            );
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };

  var checkPropTypes_1 = checkPropTypes;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */







  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  var printWarning$1 = function() {};

  if (process.env.NODE_ENV !== 'production') {
    printWarning$1 = function(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error(
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              printWarning$1(
                'You are manually calling a React.PropTypes validation ' +
                'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!reactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning$1(
              'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
              'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
            );
          } else {
            printWarning$1('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning$1(
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
          );
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */



  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret_1) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error(
        'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
        'Use PropTypes.checkPropTypes() to call them. ' +
        'Read more at http://fb.me/use-check-prop-types'
      );
      err.name = 'Invariant Violation';
      throw err;
    }  shim.isRequired = shim;
    function getShim() {
      return shim;
    }  // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,

      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,

      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };

    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
  });

  createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory() ;
  }(commonjsGlobal, (function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;

      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };

      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */
      function isValidFocusTarget(el) {
        if (
          el &&
          el !== document &&
          el.nodeName !== 'HTML' &&
          el.nodeName !== 'BODY' &&
          'classList' in el &&
          'contains' in el.classList
        ) {
          return true;
        }
        return false;
      }

      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */
      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;

        if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }

        if (tagName === 'TEXTAREA' && !el.readOnly) {
          return true;
        }

        if (el.isContentEditable) {
          return true;
        }

        return false;
      }

      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */
      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }
        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }

      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }
        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }

      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */
      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }

        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }

        hadKeyboardEvent = true;
      }

      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */
      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }

      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */
      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }

        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }

      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */
      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }

        if (
          e.target.classList.contains('focus-visible') ||
          e.target.hasAttribute('data-focus-visible-added')
        ) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }

      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */
      function onVisibilityChange(e) {
        if (document.visibilityState === 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }

      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */
      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }

      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }

      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */
      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }

        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }

      // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:
      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);

      addInitialPointerMoveListeners();

      // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:
      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true);

      // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
        document.documentElement.setAttribute('data-js-focus-visible', '');
      }
    }

    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

      // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:
      var event;

      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }

      window.dispatchEvent(event);
    }

    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }

  })));
  });

  var breakpoints = {
    small: '500px',
    tablet: '820px',
    desktop: '990px',
    desktopLarge: '1170px'
  };

  var colors = {
    brand: '#4235F2',
    white: '#FFF',
    gray: '#D9D8D9',
    gray10: '#EDEDED',
    gray20: '#4D4D4D',
    gray30: '#3F3F3F',
    gray40: '#979797',
    black: '#000',
    danger: '#E72323',
    success: '#69D272'
  };

  var sizes = {
    xPaddingMobile: '2.5rem',
    // 40px
    xPadding: '3.75rem',
    // 60px
    maxWidth: '63.75rem' // 1020px

  };

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
  var sansSerifFallback = "'-apple-system', 'BlinkMacSystemFont', 'Helvetica Neue', 'Roboto', 'sans-serif'";
  var primaryFont = "'Mulish', ".concat(sansSerifFallback);
  var fontWeights = {
    regular: 400,
    bold: 700,
    extraBold: 800
  };
  styled.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 1.25rem; /* 20px */\n  line-height: 1.5625rem; /* 25px */\n\n  @media (min-width: ", ") {\n    font-size: 1.5625rem; /* 25px */\n    line-height: 1.875rem; /* 30px */\n  }\n"])), breakpoints.tablet);
  var body20 = styled.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 1.125rem; /* 18px */\n  line-height: 1.5625rem; /* 25px */\n\n  @media (min-width: ", ") {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.5625rem; /* 25px */\n  }\n"])), breakpoints.tablet);
  var body30 = styled.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 0.9375rem; /* 15px */\n  line-height: 1.1875rem; /* 19px */\n"])));
  styled.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 0.75rem; /* 12px */\n  line-height: 0.9375rem; /* 19px */\n"])));
  styled.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: 0.9375rem; /* 15px */\n  line-height: 1.875rem; /* 30px */\n"])), fontWeights.bold);
  var caps = styled.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-size: 0.75rem; /* 12px */\n  line-height: 0.9375rem; /* 15px */\n\n  /* letter-spacing should always be 0 for Arabic */\n  [lang='ar'] & {\n    letter-spacing: 0;\n  }\n"])));
  styled.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: ", ";\n\n  @media (min-width: ", ") {\n    ", ";\n  }\n"])), caps, fontWeights.regular, breakpoints.tablet, body30);
  var cta = styled.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  font-size: 0.9375rem; /* 15px */\n  line-height: 0.9375rem; /* 19px */\n  font-weight: ", ";\n\n  /* letter-spacing should always be 0 for Arabic */\n  [lang='ar'] & {\n    letter-spacing: 0;\n  }\n"])), fontWeights.bold);
  var header1 = styled.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 1.875rem; /* 30px */\n  line-height: 2rem;\n  font-weight: ", ";\n  margin: 0;\n\n  @media (min-width: ", ") {\n    font-size: 2.5rem; /* 40px */\n    line-height: 3.125rem; /* 50px */\n  }\n"])), fontWeights.extraBold, breakpoints.tablet);
  var header2 = styled.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: 1.5625rem;\n  line-height: 1.9375rem; /* 31px */\n  font-weight: ", ";\n  margin: 0;\n\n  @media (min-width: ", ") {\n    font-size: 2.5rem;\n    line-height: 3.125rem;\n  }\n"])), fontWeights.extraBold, breakpoints.tablet);
  var header3 = styled.css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-size: 1.375rem;\n  line-height: 1.6875rem;\n  font-weight: ", ";\n  margin: 0;\n\n  @media (min-width: ", ") {\n    font-size: 1.6875rem;\n    line-height: 2.125rem; /* 34px */\n    letter-spacing: 0.01em;\n  }\n\n  /* letter-spacing should always be 0 for Arabic */\n  [lang='ar'] & {\n    letter-spacing: 0;\n  }\n"])), fontWeights.extraBold, breakpoints.tablet);
  var header4 = styled.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: 1.125rem;\n  line-height: 1.5625rem;\n  font-weight: ", ";\n  margin: 0;\n\n  @media (min-width: ", ") {\n    font-size: 1.25rem;\n    line-height: 1.6875rem;\n  }\n"])), fontWeights.bold, breakpoints.tablet);
  var link = styled.css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  transition: all 300ms ease;\n  color: ", ";\n  cursor: pointer;\n  text-decoration: none;\n  border-radius: 4px;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus:not(.focus-visible) {\n    outline: none;\n    box-shadow: none;\n  }\n"])), colors.brand, colors.brand, colors.brand);
  styled.createGlobalStyle(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  body {\n    font-family: ", ";\n\n    > * {\n      ", ";\n    }\n  }\n\n  p {\n    margin: 0;\n  }\n\n  h1 {\n    ", ";\n  }\n\n  h2 {\n    ", ";\n  }\n\n  h3 {\n    ", ";\n  }\n\n  h4 {\n    ", ";\n  }\n\n  a {\n    ", "\n  }\n"])), primaryFont, body20, header1, header2, header3, header4, link);

  var _templateObject$1;
  var GlobalStyle = styled.createGlobalStyle(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  html {\n    margin: 0;\n    padding: 0;\n    max-width: 100vw;\n  }\n\n  body {\n    min-height: 100vh;\n    margin: 0;\n    padding: 0;\n    max-width: 100vw;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  div {\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n  }\n\n  li {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  ::selection {\n    background: ", ";\n    color: ", ";\n  }\n"])), colors.brand, colors.white);

  var AllTurtlesBadge = function AllTurtlesBadge(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? '#EB4646' : _ref$color,
        rest = _objectWithoutProperties(_ref, ["color"]);

    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({}, rest, {
      width: "152",
      height: "23",
      viewBox: "0 0 152 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "badge-title"
    }), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "badge-title"
    }, "An All Turtles Company"), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M31.833 0H31.0566V22.5415H31.833V0Z",
      fill: "#979797"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M4.14077 7.97087C3.51965 6.41807 4.27017 4.52883 5.40889 4.24415L5.38301 4.14062C2.6656 4.14062 1.06104 5.58991 0.931641 7.29799L4.08901 8.07439L4.14077 7.97087Z",
      fill: color
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M10.9475 13.2245V7.99675C10.9475 5.35699 9.21353 4.24414 5.90088 4.1665L5.875 4.24414C6.75492 4.50294 7.0396 5.79695 7.0396 6.75451L7.06548 11.9305C7.0396 14.4668 8.48888 15.4243 10.5075 15.4243H11.9827V15.3726C11.8792 15.269 11.6463 15.1914 11.4133 14.9585C11.2063 14.7514 10.9475 14.5444 10.9475 13.2245Z",
      fill: color
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M0 12.7326C0 15.9676 4.91721 16.4076 6.49589 13.4314L6.47001 13.4055C5.38305 14.3113 3.67497 13.4831 3.67497 11.8786C3.67497 10.4293 4.76193 9.54935 6.52177 9.23879C6.59941 9.23879 6.67705 9.21291 6.75469 9.21291V8.87646C6.67705 8.87646 6.59941 8.90235 6.52177 8.90235C1.8116 9.47171 0 10.6881 0 12.7326Z",
      fill: color
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M17.6751 8.66963L19.4608 8.4367L19.5384 8.12614H17.3645V4.32178H17.1575C16.3552 6.54746 14.2072 8.07438 11.4121 8.46259C11.3862 8.46259 11.3604 8.46259 11.3086 8.46259V8.85079C12.525 8.79903 13.4825 8.77315 13.4825 8.77315V15.5278C13.4566 18.0641 14.9059 19.0216 16.9246 19.0216H18.3997V18.9699C18.2962 18.8664 18.0633 18.7887 17.8304 18.5558C17.5974 18.3229 17.3386 18.1158 17.3386 16.796V8.98019C17.3645 8.79903 17.4939 8.66963 17.6751 8.66963Z",
      fill: color
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M45.6018 12.6038H41.9786L41.2022 14.5448H40.0117L43.2985 6.80664H44.256L47.5169 14.5448H46.3264L45.6018 12.6038ZM45.2395 11.7238L44.3078 9.42053C44.1008 8.92881 43.9455 8.46296 43.7902 8.023H43.7643C43.609 8.46296 43.4538 8.90293 43.2467 9.42053L42.3409 11.7238H45.2395Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M49.3536 9.67921V10.5333C49.7676 9.86037 50.3888 9.47217 51.1134 9.47217C52.278 9.47217 52.9509 10.1709 52.9509 11.3873V14.5447H51.9674V11.7755C51.9674 10.7921 51.6051 10.3521 50.8287 10.3521C49.9747 10.3521 49.4053 11.0509 49.4053 12.1119V14.5188H48.4219V9.67921H49.3536Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M62.5276 12.6038H58.9044L58.128 14.5448H56.9375L60.2243 6.80664H61.1818L64.4427 14.5448H63.2522L62.5276 12.6038ZM62.1653 11.7238L61.2336 9.42053C61.0265 8.92881 60.8713 8.46296 60.716 8.023H60.6901C60.5348 8.46296 60.3795 8.90293 60.1725 9.42053L59.2667 11.7238H62.1653Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M65.2715 6.52197H66.2549V14.5448H65.2715V6.52197Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M67.9609 6.52197H68.9444V14.5448H67.9609V6.52197Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M73.1387 7.7642V6.78076H79.4534V7.7642H76.8395V14.5448H75.7784V7.7642H73.1387Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M82.9479 14.5446V13.7165C82.5338 14.4152 81.8868 14.7517 81.2398 14.7517C80.1529 14.7517 79.5059 14.0529 79.5059 12.7848V9.6792H80.4893V12.4742C80.4893 13.4318 80.8516 13.8459 81.5763 13.8459C82.3527 13.8459 82.9479 13.1471 82.9479 12.086V9.6792H83.9313V14.5446H82.9479Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M85.1719 9.67921H86.0777V10.6368C86.4918 9.80861 87.0094 9.47217 87.6564 9.47217C88.1481 9.47217 88.5104 9.73097 88.7174 10.3003L87.8893 10.7921L87.7858 10.7662C87.6564 10.4815 87.5011 10.378 87.2682 10.378C86.7247 10.378 86.1812 11.0767 86.1812 12.2931V14.5447H85.1978V9.67921H85.1719Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M92.3678 14.5706C92.0831 14.6741 91.7726 14.7259 91.4361 14.7259C90.4786 14.7259 89.9351 14.1824 89.9351 13.2249V10.4816H89.0293V9.65341H89.961V8.17824L90.7891 7.68652H90.9444V9.65341H92.3678V10.4816H90.9444V12.9402C90.9444 13.6131 91.1256 13.8201 91.6691 13.8201C91.8761 13.8201 92.0573 13.7683 92.2643 13.6648L92.3678 13.7166V14.5706Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M93.5312 6.52197H94.5147V14.5448H93.5312V6.52197Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M96.6895 12.2672V12.319C96.6895 13.3024 97.3365 13.8977 98.2164 13.8977C98.8117 13.8977 99.2516 13.613 99.6139 13.0436L99.6916 13.0177L100.442 13.4318C99.9504 14.2859 99.174 14.7258 98.1905 14.7258C96.6636 14.7258 95.6543 13.6389 95.6543 12.0861C95.6543 10.5074 96.6895 9.44629 98.1388 9.44629C99.5622 9.44629 100.546 10.4297 100.546 12.0602C100.546 12.1378 100.546 12.1637 100.546 12.2413H96.6895V12.2672ZM96.7154 11.5685H99.4845C99.4328 10.7662 98.9152 10.2745 98.1388 10.2745C97.3883 10.2745 96.8448 10.7662 96.7154 11.5685Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M101.398 13.6647L102.097 13.173H102.149C102.434 13.6647 102.848 13.9235 103.365 13.9235C103.935 13.9235 104.271 13.6647 104.271 13.2765C104.271 12.966 104.116 12.7331 103.184 12.4225C101.916 11.9567 101.58 11.4908 101.58 10.8179C101.58 10.0674 102.227 9.42041 103.339 9.42041C104.193 9.42041 104.866 9.83449 105.125 10.4556L104.504 10.8697H104.401C104.219 10.4556 103.831 10.2227 103.339 10.2227C102.848 10.2227 102.563 10.4815 102.563 10.7921C102.563 11.0767 102.692 11.2838 103.65 11.6461C104.866 12.1119 105.255 12.526 105.255 13.2765C105.255 14.1047 104.504 14.7258 103.365 14.7258C102.485 14.7517 101.787 14.3635 101.398 13.6647Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M109.371 12.1119C109.371 10.5591 110.406 9.47217 111.907 9.47217C112.865 9.47217 113.693 9.88625 114.211 10.7921L113.46 11.2579L113.383 11.232C112.968 10.585 112.528 10.3262 111.933 10.3262C111.053 10.3262 110.406 10.9991 110.406 12.0861C110.406 13.1989 111.053 13.8718 111.933 13.8718C112.554 13.8718 112.994 13.613 113.383 12.966L113.46 12.9401L114.185 13.4059C113.693 14.3117 112.839 14.7517 111.881 14.7517C110.38 14.7517 109.371 13.6647 109.371 12.1119Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M114.883 12.1119C114.883 10.6368 116.022 9.47217 117.574 9.47217C119.127 9.47217 120.266 10.6109 120.266 12.1119C120.266 13.5871 119.101 14.7517 117.574 14.7517C116.047 14.7517 114.883 13.5871 114.883 12.1119ZM119.257 12.1119C119.257 11.1285 118.558 10.378 117.6 10.378C116.643 10.378 115.944 11.1544 115.944 12.1119C115.944 13.0954 116.669 13.8718 117.6 13.8718C118.532 13.8459 119.257 13.0954 119.257 12.1119Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M129.091 11.3873V14.5447H128.108V11.8014C128.108 10.8179 127.745 10.378 127.047 10.378C126.296 10.378 125.727 11.1544 125.727 12.2155V14.5705H124.743V11.8014C124.743 10.8179 124.381 10.378 123.682 10.378C122.932 10.378 122.362 11.1544 122.362 12.2155V14.5705H121.379V9.67921H122.362V10.5333C122.751 9.86037 123.32 9.47217 124.019 9.47217C124.847 9.47217 125.39 9.88625 125.597 10.6885C126.011 9.86037 126.684 9.47217 127.383 9.47217C128.418 9.47217 129.091 10.145 129.091 11.3873Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M130.127 9.67921H131.11V10.5333C131.524 9.86037 132.171 9.47217 132.948 9.47217C134.268 9.47217 135.199 10.5074 135.199 12.0861C135.199 13.6389 134.216 14.7776 132.896 14.7776C132.197 14.7776 131.499 14.4153 131.136 13.7941V15.3728V16.9774H130.153V9.67921H130.127ZM134.164 12.0861C134.164 10.9991 133.621 10.378 132.689 10.378C131.757 10.378 131.085 11.1026 131.085 12.1378C131.085 13.173 131.732 13.8718 132.663 13.8718C133.595 13.8459 134.164 13.173 134.164 12.0861Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M140.53 13.8977V14.5964C140.272 14.6741 140.091 14.7258 139.806 14.7258C139.314 14.7258 139.029 14.467 138.978 14.0271C138.46 14.5447 137.994 14.7517 137.347 14.7517C136.467 14.7517 135.924 14.2341 135.924 13.4318C135.924 12.526 136.752 11.9049 138.9 11.6202V11.3355C138.9 10.6368 138.615 10.3521 138.072 10.3521C137.528 10.3521 137.063 10.6368 136.7 11.1803H136.623L135.976 10.7403C136.441 9.96389 137.27 9.47217 138.175 9.47217C139.262 9.47217 139.909 10.0674 139.909 11.1544V13.6389C139.909 13.8459 139.987 13.9235 140.142 13.9235C140.246 13.9235 140.298 13.8977 140.453 13.8459L140.53 13.8977ZM137.632 13.9753C138.124 13.9753 138.538 13.7683 138.9 13.4059V12.2672C137.451 12.5001 136.933 12.8366 136.933 13.3542C136.933 13.7683 137.166 13.9753 137.632 13.9753Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M142.418 9.67921V10.5333C142.832 9.86037 143.453 9.47217 144.178 9.47217C145.342 9.47217 146.015 10.1709 146.015 11.3873V14.5447H145.032V11.7755C145.032 10.7921 144.67 10.3521 143.893 10.3521C143.039 10.3521 142.47 11.0509 142.47 12.1119V14.5188H141.486V9.67921H142.418Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M148.527 14.0788L146.561 9.6792H147.699L149.045 13.0954H149.071L150.494 9.6792H151.607L148.295 16.9256H147.182L148.527 14.0788Z",
      fill: "black"
    }));
  };

  var Logo = function Logo(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? '#4235F2' : _ref$color,
        rest = _objectWithoutProperties(_ref, ["color"]);

    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({}, rest, {
      width: "57",
      height: "66",
      viewBox: "0 0 57 66",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "logo-title"
    }), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "logo-title"
    }, "mmhmm logo"), /*#__PURE__*/React__default['default'].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M54.9945 50.2631L50.8098 52.8946C50.6189 53.0145 50.3994 53.0811 50.1741 53.0875C49.9487 53.0938 49.7258 53.0396 49.5285 52.9306C49.3312 52.8216 49.1667 52.6618 49.0521 52.4676C48.9375 52.2735 48.877 52.0522 48.877 51.8268V44.719C48.877 44.6613 48.8579 44.6053 48.8228 44.5595C48.7877 44.5138 48.7385 44.4809 48.6828 44.4659C48.6271 44.451 48.568 44.4549 48.5148 44.4769C48.4615 44.499 48.417 44.538 48.3881 44.5879L43.3809 53.1948C43.2607 53.4016 43.0672 53.5558 42.8387 53.6269C42.6103 53.6979 42.3635 53.6807 42.1471 53.5786L37.3782 51.3347C37.3384 51.3158 37.2944 51.3072 37.2504 51.3098C37.2064 51.3124 37.1637 51.3261 37.1264 51.3496C37.0891 51.3731 37.0584 51.4057 37.037 51.4443C37.0156 51.4828 37.0044 51.5262 37.0043 51.5703V60.1296C37.0043 60.5724 36.8919 61.0079 36.6777 61.3954C36.4635 61.7828 36.1544 62.1096 35.7793 62.345L32.6609 64.3058C31.4147 65.0897 29.9723 65.5056 28.5 65.5056C27.0277 65.5056 25.5853 65.0897 24.3391 64.3058L21.3658 62.4362C20.9908 62.2008 20.6818 61.874 20.4676 61.4866C20.2534 61.0991 20.141 60.6636 20.1411 60.2208V51.6995C20.141 51.6554 20.1297 51.612 20.1084 51.5734C20.087 51.5349 20.0563 51.5023 20.019 51.4788C19.9816 51.4553 19.939 51.4416 19.895 51.439C19.851 51.4364 19.807 51.445 19.7672 51.4639L15.0116 53.702C14.7951 53.8044 14.548 53.8218 14.3193 53.7507C14.0906 53.6796 13.897 53.5253 13.7766 53.3182L8.78311 44.7304C8.75389 44.6808 8.70917 44.6421 8.65583 44.6204C8.60248 44.5987 8.54348 44.5951 8.4879 44.6102C8.43232 44.6253 8.38326 44.6583 8.34827 44.7041C8.31327 44.7498 8.29429 44.8058 8.29425 44.8634V51.9351C8.29418 52.1605 8.23371 52.3818 8.11913 52.5759C8.00455 52.7701 7.84004 52.9299 7.64272 53.039C7.44541 53.148 7.22249 53.2021 6.99715 53.1957C6.77181 53.1894 6.55229 53.1228 6.36142 53.0029L2.0046 50.2631C1.38115 49.8625 0.870005 49.3097 0.519373 48.6568C0.168741 48.004 -0.00981864 47.2726 0.000523523 46.5316V18.9916C-0.0109729 18.2496 0.167045 17.517 0.517738 16.863C0.868431 16.209 1.38019 15.6553 2.0046 15.2543L24.3391 1.20979C25.5831 0.419626 27.0263 0 28.5 0C29.9737 0 31.417 0.419626 32.6609 1.20979L54.9945 15.2543C55.619 15.6552 56.131 16.2089 56.4818 16.8628C56.8327 17.5168 57.0109 18.2495 56.9995 18.9916V46.5316C57.0097 47.2727 56.831 48.0041 56.4802 48.657C56.1294 49.3098 55.6181 49.8626 54.9945 50.2631ZM46.419 16.1739L30.495 6.11742C29.5581 5.52653 28.0383 5.52653 27.1003 6.12122L22.0992 9.28464C21.1612 9.87743 21.1601 10.8369 22.0967 11.4297L26.5161 14.2207C26.5578 14.239 26.5934 14.269 26.6183 14.3072C26.6433 14.3453 26.6566 14.3899 26.6566 14.4355C26.6566 14.481 26.6433 14.5256 26.6183 14.5638C26.5934 14.6019 26.5578 14.6319 26.5161 14.6501L24.6478 15.8319C24.544 15.8899 24.4272 15.9203 24.3083 15.9203C24.1894 15.9203 24.0726 15.8899 23.9688 15.8319L19.5497 13.0409C18.613 12.45 17.0932 12.45 16.1552 13.0447L11.1533 16.2081C10.2153 16.8009 10.2144 17.7604 11.151 18.3532L27.0752 28.4097C28.0119 29.0006 29.5317 29.0006 30.4699 28.4059L35.471 25.2444C36.409 24.6497 36.4101 23.6902 35.4733 23.0974L31.0539 20.3063C31.0122 20.2883 30.9766 20.2585 30.9516 20.2205C30.9266 20.1825 30.9133 20.1381 30.9133 20.0926C30.9133 20.0471 30.9266 20.0027 30.9516 19.9647C30.9766 19.9267 31.0122 19.8968 31.0539 19.8789L32.9224 18.6971C33.0258 18.6384 33.1426 18.6074 33.2616 18.6071C33.3805 18.6068 33.4975 18.6371 33.6012 18.6952L38.0205 21.4862C38.9572 22.079 40.477 22.0771 41.415 21.4843L46.4161 18.3209C47.3547 17.7262 47.3557 16.7667 46.419 16.1739Z",
      fill: color
    }));
  };

  var Twitter = function Twitter(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "34",
      height: "34",
      viewBox: "0 0 34 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "twitter-title"
    }, props), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "twitter-title"
    }, "Twitter"), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M26.4695 10.6723C25.8385 10.9463 25.1744 11.1366 24.4941 11.2384C24.8079 11.183 25.2818 10.623 25.4664 10.3769C25.7633 10.013 25.9869 9.59505 26.1249 9.14612C26.1249 9.1092 26.1249 9.06612 26.1249 9.04151C26.1085 9.03382 26.0906 9.02984 26.0726 9.02984C26.0545 9.02984 26.0366 9.03382 26.0203 9.04151C25.2801 9.44098 24.4923 9.74494 23.6756 9.94612C23.6466 9.95409 23.616 9.9543 23.5868 9.94675C23.5577 9.93919 23.531 9.92412 23.5095 9.90305C23.4482 9.8255 23.3802 9.75343 23.3064 9.68766C22.961 9.41065 22.5749 9.18856 22.1618 9.0292C21.6095 8.80679 21.0146 8.71009 20.4203 8.74612C19.8426 8.78914 19.2796 8.94821 18.7649 9.21381C18.2489 9.48549 17.7927 9.85797 17.4233 10.3092C17.0427 10.7752 16.7696 11.3194 16.6233 11.903C16.498 12.4568 16.4834 13.0298 16.5803 13.5892C16.5803 13.6877 16.5803 13.7 16.5003 13.6877C13.2756 13.2077 10.5987 12.0507 8.42641 9.57689C8.33411 9.47228 8.28487 9.47228 8.20487 9.57689C7.25718 10.9984 7.71872 13.2692 8.90026 14.4077C9.06026 14.5615 9.22641 14.7092 9.39872 14.8446C8.85556 14.8056 8.32593 14.657 7.8418 14.4077C7.74949 14.3523 7.70026 14.4077 7.69411 14.4938C7.67601 14.6471 7.67601 14.802 7.69411 14.9554C7.78932 15.6813 8.07526 16.369 8.5228 16.9484C8.97034 17.5278 9.56349 17.9783 10.2418 18.2538C10.4082 18.3247 10.5814 18.3783 10.7587 18.4138C10.2587 18.5174 9.74491 18.5361 9.23872 18.4692C9.12795 18.4692 9.08487 18.5061 9.12795 18.6107C9.39031 19.2953 9.82304 19.9016 10.3852 20.3722C10.9473 20.8428 11.6202 21.1621 12.3403 21.3C12.4818 21.3 12.6295 21.3 12.7772 21.3615H12.7464C12.3895 21.9092 11.1403 22.3215 10.5556 22.5246C9.48947 22.9044 8.35379 23.0492 7.22641 22.9492C7.04795 22.9492 7.01103 22.9492 6.9618 22.9492C6.91257 22.9492 6.9618 23.023 7.01103 23.0661C7.23872 23.22 7.47257 23.3492 7.70641 23.4784C8.41498 23.8546 9.1618 24.1537 9.93411 24.3707C13.9341 25.4723 18.4387 24.66 21.4418 21.6815C23.811 19.3615 24.6233 16.1307 24.6233 12.8938C24.6233 12.7707 24.771 12.6969 24.8633 12.6292C25.4581 12.1658 25.9826 11.6186 26.4203 11.0046C26.489 10.9148 26.5239 10.8037 26.5187 10.6907V10.6907C26.531 10.623 26.5372 10.6354 26.4695 10.6723Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.4219 24.8131C13.4219 24.7821 13.7758 24.8131 13.4219 24.8131C13.4219 24.7945 13.4653 24.8131 13.4219 24.8131Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.3524 8.76465C20.3397 8.77373 20.3246 8.77861 20.309 8.77861C20.2934 8.77861 20.2783 8.77373 20.2656 8.76465H20.3524Z",
      fill: "black"
    }));
  };

  var Instagram = function Instagram(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "35",
      height: "34",
      viewBox: "0 0 35 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "instagram-title"
    }, props), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "instagram-title"
    }, "Instagram"), /*#__PURE__*/React__default['default'].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4059 21.6596C14.7417 21.6596 12.5507 19.4938 12.5507 16.8044C12.5507 14.1394 14.741 11.9492 17.4059 11.9492C20.0954 11.9492 22.2612 14.1402 22.2612 16.8044C22.2612 19.4931 20.0946 21.6596 17.4059 21.6596ZM17.4059 13.8202C15.7605 13.8202 14.4218 15.1589 14.4218 16.8044C14.4218 18.4499 15.7605 19.7886 17.4059 19.7886C19.0514 19.7886 20.3901 18.4499 20.3901 16.8044C20.3901 15.1589 19.0514 13.8202 17.4059 13.8202Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M21.9732 12.8965C22.6364 12.8965 23.1811 12.3518 23.1811 11.6886C23.1811 11.0255 22.6364 10.4808 21.9732 10.4808C21.3101 10.4808 20.7653 11.0255 20.7653 11.6886C20.7653 12.3518 21.3101 12.8965 21.9732 12.8965Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.877 26.1596C10.6673 26.1596 8.05078 23.543 8.05078 20.3333V13.2755C8.05078 10.0658 10.6673 7.44922 13.877 7.44922H20.9585C24.1452 7.44922 26.7611 10.0664 26.7611 13.2755V20.357C26.7611 23.5437 24.1439 26.1596 20.9349 26.1596H13.877ZM13.877 9.29657C11.6868 9.29657 9.89813 11.0852 9.89813 13.2755V20.357C9.89813 22.5472 11.6868 24.3359 13.877 24.3359H20.9585C23.1488 24.3359 24.9375 22.5472 24.9375 20.357V13.2755C24.9375 11.0852 23.1488 9.29657 20.9585 9.29657H13.877Z",
      fill: "black"
    }));
  };

  var LinkedIn = function LinkedIn(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "34",
      height: "34",
      viewBox: "0 0 34 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "linkedin-title"
    }, props), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "linkedin-title"
    }, "LinkedIn"), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M26.5003 18.0841V24.3541C26.5011 24.391 26.4945 24.4278 26.481 24.4621C26.4674 24.4965 26.4471 24.5278 26.4212 24.5543C26.3954 24.5807 26.3645 24.6017 26.3305 24.616C26.2964 24.6303 26.2598 24.6377 26.2229 24.6377H22.98C22.943 24.6377 22.9065 24.6303 22.8724 24.616C22.8383 24.6017 22.8075 24.5807 22.7816 24.5543C22.7558 24.5278 22.7355 24.4965 22.7219 24.4621C22.7083 24.4278 22.7017 24.391 22.7026 24.3541V18.5034C22.7026 16.9683 22.1539 15.9202 20.779 15.9202C20.35 15.9221 19.9321 16.0571 19.5832 16.3067C19.2342 16.5563 18.9713 16.9081 18.8309 17.3135C18.7268 17.6165 18.6829 17.9369 18.7014 18.2568V24.3541C18.7022 24.391 18.6956 24.4278 18.6821 24.4621C18.6685 24.4965 18.6482 24.5278 18.6223 24.5543C18.5965 24.5807 18.5656 24.6017 18.5316 24.616C18.4975 24.6303 18.4609 24.6377 18.424 24.6377H15.1873C15.1498 24.6385 15.1125 24.6318 15.0778 24.6178C15.043 24.6039 15.0114 24.583 14.9849 24.5565C14.9584 24.53 14.9375 24.4984 14.9235 24.4636C14.9096 24.4288 14.9028 24.3916 14.9037 24.3541C14.9037 22.8005 14.9468 15.2667 14.9037 13.4973C14.9028 13.4598 14.9096 13.4226 14.9235 13.3878C14.9375 13.353 14.9584 13.3214 14.9849 13.2949C15.0114 13.2684 15.043 13.2475 15.0778 13.2336C15.1125 13.2196 15.1498 13.2128 15.1873 13.2137H18.4178C18.4914 13.2137 18.5619 13.2429 18.614 13.2949C18.666 13.347 18.6952 13.4175 18.6952 13.4911V14.8043V14.8413V14.8043C19.0448 14.2124 19.5495 13.7273 20.1547 13.4014C20.7599 13.0754 21.4426 12.921 22.1292 12.9548C24.5953 12.9548 26.5003 14.5885 26.5003 18.0965V18.0841ZM9.28723 24.6685H12.5363C12.5732 24.6685 12.6098 24.6611 12.6439 24.6468C12.6779 24.6325 12.7088 24.6115 12.7346 24.5851C12.7605 24.5587 12.7808 24.5273 12.7944 24.493C12.8079 24.4586 12.8145 24.4219 12.8137 24.3849V13.4911C12.8137 13.4175 12.7845 13.347 12.7324 13.2949C12.6804 13.2429 12.6098 13.2137 12.5363 13.2137H9.28723C9.21307 13.2137 9.14186 13.2427 9.08885 13.2946C9.03583 13.3464 9.00525 13.417 9.00363 13.4911V24.3541C8.99929 24.3938 9.00339 24.4341 9.01569 24.4721C9.02798 24.5102 9.04818 24.5452 9.07496 24.5749C9.10174 24.6046 9.1345 24.6282 9.17108 24.6444C9.20766 24.6605 9.24725 24.6687 9.28723 24.6685V24.6685Z",
      fill: "black"
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M10.7923 11.757C11.9159 11.757 12.8268 10.8461 12.8268 9.72248C12.8268 8.59886 11.9159 7.68799 10.7923 7.68799C9.66869 7.68799 8.75781 8.59886 8.75781 9.72248C8.75781 10.8461 9.66869 11.757 10.7923 11.757Z",
      fill: "black"
    }));
  };

  var Facebook = function Facebook(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "35",
      height: "34",
      viewBox: "0 0 35 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": "facebook-title",
      role: "img"
    }, props), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "facebook-title"
    }, "Facebook"), /*#__PURE__*/React__default['default'].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.8014 24.1207C25.8014 24.5897 25.4213 24.9698 24.9523 24.9698H21.0317V19.0116H23.0316L23.3312 16.6898H21.0317V15.2075C21.0317 14.5352 21.2186 14.0767 22.1825 14.0767L23.4121 14.0763V11.9997C23.1992 11.9712 22.4696 11.9079 21.6205 11.9079C19.8477 11.9079 18.634 12.99 18.634 14.9774V16.6898H16.6291V19.0116H18.634V24.9698H11.2651C10.7961 24.9698 10.416 24.5897 10.416 24.1207V10.4336C10.416 9.96459 10.7961 9.58447 11.2651 9.58447H24.9523C25.4213 9.58447 25.8014 9.96459 25.8014 10.4336V24.1207",
      fill: "black"
    }));
  };

  var YouTube = function YouTube(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "34",
      height: "34",
      viewBox: "0 0 34 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "youtube-title"
    }, props), /*#__PURE__*/React__default['default'].createElement("title", {
      id: "youtube-title"
    }, "YouTube"), /*#__PURE__*/React__default['default'].createElement("g", {
      clipPath: "url(#clip0)"
    }, /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M24.7057 9.47363H10.7109C8.72561 9.47363 7.13086 11.0684 7.13086 13.0537V20.5393C7.13086 22.5246 8.72561 24.1193 10.7109 24.1193H24.7057C26.691 24.1193 28.2857 22.5246 28.2857 20.5393V13.0537C28.2857 11.0684 26.691 9.47363 24.7057 9.47363ZM21.8416 16.9267L15.4952 20.1813C15.4301 20.2138 15.3324 20.1813 15.2673 20.1162C15.2673 20.0836 15.2348 20.0836 15.2348 20.0511V13.5419C15.2348 13.4442 15.2999 13.3791 15.3975 13.3791C15.4301 13.3791 15.4626 13.3791 15.4626 13.4117L21.8091 16.6663C21.8742 16.6988 21.9067 16.7965 21.8742 16.8941C21.9067 16.8941 21.8742 16.9267 21.8416 16.9267Z",
      fill: "black"
    })), /*#__PURE__*/React__default['default'].createElement("defs", null, /*#__PURE__*/React__default['default'].createElement("clipPath", {
      id: "clip0"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      width: "21.1549",
      height: "14.6457",
      fill: "white",
      transform: "translate(7.13086 9.47363)"
    }))));
  };

  var Icons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Twitter: Twitter,
    Instagram: Instagram,
    LinkedIn: LinkedIn,
    Facebook: Facebook,
    YouTube: YouTube
  });

  var SocialIcon = function SocialIcon(_ref) {
    var variant = _ref.variant,
        rest = _objectWithoutProperties(_ref, ["variant"]);

    var Icon = Icons[variant];
    return /*#__PURE__*/React__default['default'].createElement(Icon, rest);
  };

  SocialIcon.propTypes = {
    variant: propTypes.oneOf(['Twitter', 'Instagram', 'LinkedIn', 'Facebook', 'YouTube']).isRequired
  };

  var propTypes$1 = {
    color: propTypes.string
  };
  var defaultProps = {
    color: '#000'
  };

  var Spinner = function Spinner(_ref) {
    var color = _ref.color,
        rest = _objectWithoutProperties(_ref, ["color"]);

    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "24px",
      height: "24px",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      role: "img",
      "aria-label": "Loading"
    }, rest), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(0 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.9s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(36 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.8s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(72 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.7s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(108 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.6s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(144 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.5s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(180 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.4s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(216 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.3s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(252 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.2s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(288 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "-0.1s",
      repeatCount: "indefinite"
    }))), /*#__PURE__*/React__default['default'].createElement("g", {
      transform: "rotate(324 50 50)"
    }, /*#__PURE__*/React__default['default'].createElement("rect", {
      x: "46.5",
      y: "14",
      rx: "19.065",
      ry: "5.74",
      width: "7",
      height: "14",
      fill: color
    }, /*#__PURE__*/React__default['default'].createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      begin: "0s",
      repeatCount: "indefinite"
    }))));
  };

  Spinner.propTypes = propTypes$1;
  Spinner.defaultProps = defaultProps;

  var Globe = function Globe(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M8 0C5.78938 0 3.905 0.782292 2.34688 2.34687C0.782291 3.905 0 5.78938 0 8C0 10.2106 0.782291 12.095 2.34688 13.6531C3.905 15.2177 5.78938 16 8 16C10.2106 16 12.095 15.2177 13.6531 13.6531C15.2177 12.095 16 10.2106 16 8C16 5.78938 15.2177 3.905 13.6531 2.34687C12.095 0.782292 10.2106 0 8 0ZM14.2706 5.95719C14.7014 7.2849 14.7014 8.71479 14.2706 10.0425H12.2081C12.4234 8.68924 12.4234 7.31045 12.2081 5.95719H14.2706ZM13.805 11.1353C13.0892 12.4593 12.0408 13.4252 10.66 14.0331C10.8957 13.7181 11.1055 13.3845 11.2872 13.0356C11.5857 12.4288 11.8183 11.7917 11.9809 11.1353H13.805ZM10.6603 1.97625C12.0411 2.58437 13.0862 3.54406 13.7956 4.85531H11.9809C11.8173 4.20222 11.5847 3.56836 11.2872 2.96438C11.1098 2.61598 10.8999 2.28513 10.6603 1.97625ZM11.2587 5.95719C11.3762 6.63185 11.4366 7.3152 11.4394 8C11.4366 8.6848 11.3762 9.36815 11.2587 10.0428H8.46562V5.95719H11.2587ZM8.67438 1.4725C9.35833 1.75125 9.95375 2.38781 10.4606 3.38219C10.6571 3.78135 10.8407 4.27229 11.0116 4.855H8.46562V1.42531C8.48053 1.43205 8.49678 1.43526 8.51312 1.43469H8.57L8.67438 1.4725ZM8.57 14.5662H8.51312C8.49786 14.5718 8.48184 14.5749 8.46562 14.5756V11.1353H11.0119C10.8408 11.7245 10.6572 12.2185 10.4609 12.6175C9.95427 13.6121 9.35885 14.2486 8.67469 14.5272L8.57 14.5662ZM7.43 1.43469H7.48719C7.50353 1.43528 7.51979 1.43207 7.53469 1.42531V4.85531H4.98844C5.15948 4.27198 5.34313 3.78104 5.53938 3.3825C6.04625 2.38812 6.64167 1.75156 7.32563 1.47281L7.43 1.43469ZM4.7425 10.0428C4.62477 9.36817 4.56393 8.68483 4.56063 8C4.56407 7.31523 4.62448 6.63194 4.74125 5.95719H7.53438V10.0428H4.7425ZM7.32687 14.5275C6.64271 14.2485 6.04729 13.612 5.54062 12.6178C5.33792 12.2186 5.15427 11.7246 4.98969 11.1356H7.53438V14.5747C7.51816 14.574 7.50214 14.5708 7.48687 14.5653H7.42969L7.32687 14.5275ZM2.20438 4.85531C2.91396 3.54406 3.95563 2.58448 5.32938 1.97656C5.09523 2.28714 4.88881 2.61768 4.7125 2.96438C4.41293 3.56748 4.18029 4.20157 4.01875 4.85531H2.20438ZM5.32938 14.0334C3.95438 13.4191 2.91271 12.4531 2.20438 11.1356H4.01906C4.19656 11.8385 4.42781 12.472 4.71281 13.0359C4.89064 13.3849 5.09719 13.7184 5.33031 14.0331L5.32938 14.0334ZM3.79031 5.9575C3.6825 6.63298 3.62868 7.31597 3.62938 8C3.62936 8.68413 3.68338 9.36719 3.79094 10.0428H1.72844C1.29785 8.71508 1.29785 7.28523 1.72844 5.9575H3.79031Z",
      fill: "black"
    }));
  };

  var GlobeAmericas = function GlobeAmericas(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M8 0.5C3.58161 0.5 0 4.08161 0 8.5C0 12.9184 3.58161 16.5 8 16.5C12.4184 16.5 16 12.9184 16 8.5C16 4.08161 12.4184 0.5 8 0.5ZM10.6545 12.0355C10.5287 12.1606 10.3968 12.2919 10.2897 12.3994C10.1932 12.4961 10.1252 12.6155 10.0906 12.7448C10.0419 12.9274 10.0026 13.1119 9.93677 13.289L9.37581 14.8003C8.93194 14.8971 8.47258 14.9516 8 14.9516V14.0684C8.05452 13.6613 7.75355 12.8987 7.27 12.4152C7.07645 12.2216 6.96774 11.959 6.96774 11.6852V10.6526C6.96774 10.2771 6.76548 9.93194 6.43677 9.75032C5.97323 9.49387 5.31387 9.13548 4.86226 8.90806C4.49194 8.72161 4.14935 8.48419 3.84129 8.20645L3.81548 8.18323C3.59518 7.98437 3.39958 7.75974 3.2329 7.51419C2.93032 7.07 2.43742 6.33935 2.1171 5.86452C2.77742 4.39677 3.96742 3.21806 5.44613 2.57774L6.22064 2.96516C6.56387 3.13677 6.96774 2.88742 6.96774 2.50355V2.13903C7.22548 2.09742 7.48774 2.07097 7.75452 2.06097L8.66742 2.97387C8.86903 3.17548 8.86903 3.50226 8.66742 3.70387L8.51613 3.85484L8.18258 4.18839C8.08193 4.28903 8.08193 4.45258 8.18258 4.55323L8.33387 4.70452C8.43452 4.80516 8.43452 4.96871 8.33387 5.06935L8.07581 5.32742C8.02735 5.37578 7.96168 5.40293 7.89323 5.4029H7.60323C7.53613 5.4029 7.47161 5.42903 7.42323 5.47613L7.10323 5.78742C7.064 5.82562 7.03793 5.87529 7.02876 5.92927C7.0196 5.98325 7.02783 6.03874 7.05226 6.08774L7.55516 7.09387C7.64097 7.26548 7.51613 7.46742 7.32452 7.46742H7.14258C7.08032 7.46742 7.02032 7.44484 6.97355 7.40419L6.67419 7.14419C6.60645 7.08543 6.52458 7.0453 6.43663 7.02777C6.34868 7.01023 6.25768 7.0159 6.17258 7.04419L5.1671 7.37935C5.09033 7.40495 5.02357 7.45406 4.97627 7.51971C4.92896 7.58537 4.90352 7.66424 4.90355 7.74516C4.90355 7.89129 4.98613 8.02452 5.11677 8.09L5.47419 8.26871C5.77774 8.42064 6.11258 8.49968 6.45194 8.49968C6.79129 8.49968 7.18064 9.38 7.48419 9.53193H9.63742C9.91129 9.53193 10.1735 9.64064 10.3674 9.83419L10.809 10.2758C10.9935 10.4604 11.0971 10.7107 11.0971 10.9716C11.097 11.1694 11.0579 11.3651 10.9819 11.5477C10.906 11.7303 10.7947 11.896 10.6545 12.0355ZM13.4516 9.08871C13.2648 9.04193 13.1019 8.92742 12.9952 8.7671L12.4152 7.8971C12.3303 7.76999 12.285 7.62058 12.285 7.46774C12.285 7.3149 12.3303 7.1655 12.4152 7.03839L13.0471 6.09064C13.1219 5.97871 13.2245 5.88774 13.3452 5.82774L13.7639 5.61839C14.2 6.48677 14.4516 7.46355 14.4516 8.5C14.4516 8.77968 14.4277 9.05355 14.3929 9.32387L13.4516 9.08871Z",
      fill: "black"
    }));
  };

  var ChevronDown = function ChevronDown(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "10",
      height: "7",
      viewBox: "0 0 10 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M9.06622 0.5C8.81904 0.5 8.58559 0.596125 8.40707 0.76091L5.02897 4.26255L1.56542 0.774642C1.35943 0.596125 1.15345 0.513732 0.920006 0.513732C0.411917 0.513732 -4.64507e-05 0.939428 -4.64507e-05 1.44752C-4.64507e-05 1.69469 0.0960785 1.92814 0.260864 2.09293L4.38356 6.23999C4.58954 6.4185 4.79552 6.5009 5.02897 6.5009C5.27615 6.5009 5.50959 6.40477 5.68811 6.23999L9.71163 2.09293C9.86268 1.94187 9.97254 1.70843 10 1.44752C9.98627 0.911964 9.5743 0.5 9.06622 0.5Z",
      fill: "#4235F2"
    }));
  };

  var SelectCaret = function SelectCaret(props) {
    return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
      width: "14",
      height: "12",
      viewBox: "0 0 14 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M7.792 10.5192C7.40612 11.1807 6.45032 11.1807 6.06444 10.5192L0.805482 1.50387C0.416599 0.837212 0.897471 -1.13918e-06 1.66926 -1.07171e-06L12.1872 -1.52206e-07C12.959 -8.47341e-08 13.4398 0.837214 13.051 1.50387L7.792 10.5192Z",
      fill: "#C4C4C4"
    }));
  };

  var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1;

  var Button = styled__default['default'].button(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  font-family: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  min-width: ", ";\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus:not(.focus-visible) {\n    outline: none;\n    box-shadow: none;\n  }\n"])), primaryFont, function (props) {
    return props.minWidth || 'inherit';
  }); // Base styles common across all the button-type styles

  var ButtonBase = styled__default['default'](Button)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.8125rem; /* 45px */\n  padding: 0 2rem;\n  border: 2px solid transparent;\n  border-radius: 1.40625rem; /* 45 / 2 = 22.5px */\n  font-size: 0.9375rem; /* 15px */\n  line-height: 0.9375rem; /* 19px */\n  font-weight: ", ";\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  transition: all 200ms ease;\n\n  &:disabled {\n    cursor: not-allowed;\n    background-color: ", ";\n    border: 2px solid ", ";\n    color: ", ";\n  }\n\n  /* letter-spacing should always be 0 for Arabic */\n  [lang='ar'] & {\n    letter-spacing: 0;\n  }\n"])), fontWeights.bold, colors.gray, colors.gray, colors.black);
  var LinkBase = styled__default['default'](Button)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  ", ";\n  padding: 0;\n  font-weight: ", ";\n  color: ", ";\n  background-color: transparent;\n  border: 0;\n  border-radius: 4px;\n  transition: all 300ms ease;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n  }\n"])), function (props) {
    return props.small ? body30 : body20;
  }, fontWeights.regular, colors.black, colors.brand, colors.brand);
  var PrimaryButton = styled__default['default'](ButtonBase)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n\n  &:focus {\n    box-shadow: 0 0 0 3px white, 0 0 0 6px ", ";\n  }\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.brand, colors.white, colors.brand, colors.brand, colors.white, colors.black);
  var SecondaryButton = styled__default['default'](ButtonBase)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  &:not(:disabled) {\n    filter: drop-shadow(0px 0px 20px rgba(16, 13, 60, 0.2));\n\n    &:hover {\n      border-color: ", ";\n    }\n  }\n\n  &:focus:not(.focus-visible) {\n    border-color: 2px white;\n  }\n"])), colors.white, colors.brand, colors.white, colors.brand, colors.brand);
  var DangerButton = styled__default['default'](ButtonBase)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n\n  &:focus {\n    box-shadow: 0 0 0 3px white, 0 0 0 6px ", ";\n  }\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.danger, colors.white, colors.danger, colors.danger, colors.white, colors.black);
  var SuccessButton = styled__default['default'](ButtonBase)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n\n  &:focus {\n    box-shadow: 0 0 0 3px white, 0 0 0 6px ", ";\n  }\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.success, colors.white, colors.success, colors.success, colors.white, colors.black);
  var LinkButton = styled__default['default'](LinkBase)(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), colors.brand);
  var LinkSubtle = styled__default['default'](LinkBase)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral([""])));
  var LinkCaps = styled__default['default'](LinkBase)(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  min-height: 19px;\n  font-size: 0.9375rem; /* 15px */\n  line-height: 0.9375rem; /* 19px */\n  font-weight: ", ";\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n\n  &:after {\n    content: '';\n    height: 2px;\n    width: 100%;\n    background-color: ", ";\n    position: absolute;\n    bottom: -0.3rem;\n    left: 0;\n    opacity: ", ";\n    transition: opacity 200ms ease;\n  }\n"])), fontWeights.bold, colors.brand, function (props) {
    return props.selected ? 1 : 0;
  });
  var StyledSpinner = styled__default['default'](Spinner)(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 24px;\n  opacity: 0;\n  transition: all 200ms ease, opacity 250ms ease;\n\n  ", "\n"])), function (props) {
    return props.$visible && styled.css(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n      width: 24px;\n      opacity: 1;\n      margin-right: 10px;\n    "])));
  });

  var propTypes$2 = {
    /** Button text */
    children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,

    /** Type of element rendered */
    as: propTypes.oneOf(['a', 'button']),
    disabled: propTypes.bool,

    /** Combine with `as='a'` to render an external link */
    href: propTypes.string,

    /** Displays spinner and disables Button when true */
    loading: propTypes.bool,

    /**
     * Buttons are the width of their content + 2rem padding on each side by default;
     * pass a valid `min-width` CSS value (unit included) to specify width instead */
    minWidth: propTypes.string,
    onClick: propTypes.func,

    /** For use with `linkCaps` to indicate currently selected element when `true`  */
    selected: propTypes.bool,

    /** For use with `link` variant; will render smaller font size */
    small: propTypes.bool,

    /** Display style */
    variant: propTypes.oneOf(['primary', 'secondary', 'danger', 'success', 'link', 'linkSubtle', 'linkCaps'])
  };
  var defaultProps$1 = {
    as: 'button',
    disabled: false,
    href: null,
    loading: false,
    minWidth: null,
    onClick: null,
    selected: false,
    small: false,
    variant: 'primary'
  };
  var Button$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var as = _ref.as,
        children = _ref.children,
        disabled = _ref.disabled,
        href = _ref.href,
        loading = _ref.loading,
        minWidth = _ref.minWidth,
        onClick = _ref.onClick,
        small = _ref.small,
        variant = _ref.variant,
        rest = _objectWithoutProperties(_ref, ["as", "children", "disabled", "href", "loading", "minWidth", "onClick", "small", "variant"]);

    var variants = {
      primary: PrimaryButton,
      secondary: SecondaryButton,
      danger: DangerButton,
      success: SuccessButton,
      link: LinkButton,
      linkSubtle: LinkSubtle,
      linkCaps: LinkCaps
    };
    return /*#__PURE__*/React__default['default'].createElement(Button, _extends({
      forwardedAs: href || as === 'a' ? 'a' : 'button',
      as: variants[variant] || variants.primary,
      disabled: disabled || loading,
      href: href,
      onClick: onClick,
      variant: variant,
      small: small,
      minWidth: minWidth,
      ref: ref
    }, rest), loading && /*#__PURE__*/React__default['default'].createElement(StyledSpinner, {
      color: colors.gray30,
      $visible: true
    }), children);
  });
  Button$1.propTypes = propTypes$2;
  Button$1.defaultProps = defaultProps$1;

  var _templateObject$3;
  var MaxWidthComponent = styled__default['default'].div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: 100vw;\n  max-width: 100%;\n  padding: 0 ", ";\n  box-sizing: border-box;\n\n  @media (min-width: ", ") {\n    max-width: 90vw;\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n    max-width: calc(", " + (", " * 2));\n  }\n"])), sizes.xPaddingMobile, breakpoints.small, breakpoints.tablet, sizes.xPadding, sizes.maxWidth, sizes.xPadding);

  var MaxWidth = function MaxWidth(_ref) {
    var children = _ref.children,
        rest = _objectWithoutProperties(_ref, ["children"]);

    return /*#__PURE__*/React__default['default'].createElement(MaxWidthComponent, rest, children);
  };

  var _templateObject$4, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2;
  var LegalWrap = styled__default['default'].div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: column;\n  border-top: 1px solid ", ";\n  padding-top: 0.875rem;\n  margin-top: 6.625rem;\n\n  @media (min-width: ", ") {\n    flex-direction: row;\n    align-items: center;\n    margin-top: 6.5625rem;\n  }\n\n  @media (min-width: ", ") {\n    margin-top: 8.75rem;\n  }\n"])), colors.gray40, breakpoints.tablet, breakpoints.desktop);
  var Legal = styled__default['default'].div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  display: flex;\n  margin-bottom: 1.125rem;\n  flex-direction: column;\n  flex-grow: 1;\n\n  @media (min-width: ", ") {\n    margin-bottom: 0;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n"])), breakpoints.tablet);
  var RightInfo = styled__default['default'].div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.5rem;\n\n  @media (min-width: ", ") {\n    flex-direction: row;\n    margin-top: 0;\n  }\n"])), breakpoints.tablet);
  var Copyright = styled__default['default'].p(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  line-height: 1.25rem;\n"])));
  var LegalLinks = styled__default['default'].div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  display: flex;\n  line-height: 1.25rem;\n  align-items: center;\n"])));
  var LegalLink = styled__default['default'].a(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline;\n  transition: color 200ms ease;\n  margin-inline-end: 1rem;\n\n  &:hover {\n    color: ", ";\n  }\n\n  @media (min-width: ", ") {\n    margin-inline-start: 1rem;\n    margin-inline-end: 0;\n  }\n"])), colors.black, colors.brand, breakpoints.tablet);
  var LogoLink = styled__default['default'].a(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  line-height: 1;\n"])));

  var Legal$1 = function Legal$1(_ref) {
    var items = _ref.items;
    var currentYear = new Date().getFullYear();
    return /*#__PURE__*/React__default['default'].createElement(LegalWrap, null, /*#__PURE__*/React__default['default'].createElement(Legal, null, /*#__PURE__*/React__default['default'].createElement(LogoLink, {
      href: "https://www.all-turtles.com/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default['default'].createElement(AllTurtlesBadge, null)), /*#__PURE__*/React__default['default'].createElement(RightInfo, null, /*#__PURE__*/React__default['default'].createElement(Copyright, {
      dir: "ltr"
    }, "\xA9 2020 - ", currentYear, ", mmhmm inc."), /*#__PURE__*/React__default['default'].createElement(LegalLinks, null, items.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement(LegalLink, {
        href: item.url,
        key: item.display
      }, item.display);
    })))));
  };

  var websiteUrl = 'https://mmhmm.app';

  var _templateObject$5, _templateObject2$3, _templateObject3$3;
  var FooterNavColComponent = styled__default['default'].nav(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  flex-basis: calc(50% - 1rem);\n\n  &:not(:first-child) {\n    padding-inline-start: 0.5rem;\n  }\n\n  @media (min-width: ", ") {\n    flex-basis: auto;\n    width: 9.5625rem;\n\n    &:not(:first-child) {\n      padding-inline-start: 2rem;\n    }\n  }\n\n  @media (min-width: ", ") {\n    &:not(:first-child) {\n      padding-inline-start: 1.25rem;\n    }\n  }\n"])), breakpoints.tablet, breakpoints.desktop);
  var Header = styled__default['default'].h3(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  ", ";\n  margin-bottom: 0.625rem;\n"])), cta);
  var Li = styled__default['default'].li(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  margin-bottom: 0.646rem;\n  ", ";\n"])), body30);

  var NavColumn = function NavColumn(_ref) {
    var title = _ref.title,
        items = _ref.items;
    return /*#__PURE__*/React__default['default'].createElement(FooterNavColComponent, {
      "aria-labelledby": "".concat(title, "-nav")
    }, /*#__PURE__*/React__default['default'].createElement(Header, {
      id: "".concat(title, "-nav")
    }, title), /*#__PURE__*/React__default['default'].createElement("ul", null, items.map(function (item) {
      var href = "".concat(websiteUrl).concat(item.url);
      if (item.external || item.mailTo) href = item.url;
      var aAttributes = item.external ? {
        target: '_blank',
        rel: 'noopener noreferrer'
      } : {};
      return /*#__PURE__*/React__default['default'].createElement(Li, {
        key: item.display
      }, /*#__PURE__*/React__default['default'].createElement(Button$1, _extends({
        variant: "linkSubtle",
        small: true,
        href: href
      }, aAttributes), item.display));
    })));
  };

  /*

  Based off glamor's StyleSheet, thanks Sunil ❤️

  high performance StyleSheet for css-in-js systems

  - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance

  // usage

  import { StyleSheet } from '@emotion/sheet'

  let styleSheet = new StyleSheet({ key: '', container: document.head })

  styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet

  styleSheet.flush()
  - empties the stylesheet of all its contents

  */
  // $FlowFixMe
  function sheetForTag(tag) {
    if (tag.sheet) {
      // $FlowFixMe
      return tag.sheet;
    } // this weirdness brought to you by firefox

    /* istanbul ignore next */


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        // $FlowFixMe
        return document.styleSheets[i];
      }
    }
  }

  function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);

    if (options.nonce !== undefined) {
      tag.setAttribute('nonce', options.nonce);
    }

    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
  }

  var StyleSheet = /*#__PURE__*/function () {
    function StyleSheet(options) {
      var _this = this;

      this._insertTag = function (tag) {
        var before;

        if (_this.tags.length === 0) {
          before = _this.prepend ? _this.container.firstChild : _this.before;
        } else {
          before = _this.tags[_this.tags.length - 1].nextSibling;
        }

        _this.container.insertBefore(tag, before);

        _this.tags.push(tag);
      };

      this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
      this.tags = [];
      this.ctr = 0;
      this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

      this.key = options.key;
      this.container = options.container;
      this.prepend = options.prepend;
      this.before = null;
    }

    var _proto = StyleSheet.prototype;

    _proto.hydrate = function hydrate(nodes) {
      nodes.forEach(this._insertTag);
    };

    _proto.insert = function insert(rule) {
      // the max length is how many rules we have per style tag, it's 65000 in speedy mode
      // it's 1 in dev because we insert source maps that map a single rule to a location
      // and you can only have one source map per style tag
      if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
        this._insertTag(createStyleElement(this));
      }

      var tag = this.tags[this.tags.length - 1];

      if (process.env.NODE_ENV !== 'production') {
        var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

        if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
          // this would only cause problem in speedy mode
          // but we don't want enabling speedy to affect the observable behavior
          // so we report this error at all times
          console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
        }
        this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
      }

      if (this.isSpeedy) {
        var sheet = sheetForTag(tag);

        try {
          // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (e) {
          if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
            console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
          }
        }
      } else {
        tag.appendChild(document.createTextNode(rule));
      }

      this.ctr++;
    };

    _proto.flush = function flush() {
      // $FlowFixMe
      this.tags.forEach(function (tag) {
        return tag.parentNode && tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0;

      if (process.env.NODE_ENV !== 'production') {
        this._alreadyInsertedOrderInsensitiveRule = false;
      }
    };

    return StyleSheet;
  }();

  var MS = '-ms-';
  var MOZ = '-moz-';
  var WEBKIT = '-webkit-';

  var COMMENT = 'comm';
  var RULESET = 'rule';
  var DECLARATION = 'decl';
  var IMPORT = '@import';
  var KEYFRAMES = '@keyframes';

  /**
   * @param {number}
   * @return {number}
   */
  var abs = Math.abs;

  /**
   * @param {number}
   * @return {string}
   */
  var from = String.fromCharCode;

  /**
   * @param {string} value
   * @param {number} length
   * @return {number}
   */
  function hash (value, length) {
  	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
  }

  /**
   * @param {string} value
   * @return {string}
   */
  function trim (value) {
  	return value.trim()
  }

  /**
   * @param {string} value
   * @param {RegExp} pattern
   * @return {string?}
   */
  function match (value, pattern) {
  	return (value = pattern.exec(value)) ? value[0] : value
  }

  /**
   * @param {string} value
   * @param {(string|RegExp)} pattern
   * @param {string} replacement
   * @return {string}
   */
  function replace (value, pattern, replacement) {
  	return value.replace(pattern, replacement)
  }

  /**
   * @param {string} value
   * @param {string} value
   * @return {number}
   */
  function indexof (value, search) {
  	return value.indexOf(search)
  }

  /**
   * @param {string} value
   * @param {number} index
   * @return {number}
   */
  function charat (value, index) {
  	return value.charCodeAt(index) | 0
  }

  /**
   * @param {string} value
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */
  function substr (value, begin, end) {
  	return value.slice(begin, end)
  }

  /**
   * @param {string} value
   * @return {number}
   */
  function strlen (value) {
  	return value.length
  }

  /**
   * @param {any[]} value
   * @return {number}
   */
  function sizeof (value) {
  	return value.length
  }

  /**
   * @param {any} value
   * @param {any[]} array
   * @return {any}
   */
  function append (value, array) {
  	return array.push(value), value
  }

  /**
   * @param {string[]} array
   * @param {function} callback
   * @return {string}
   */
  function combine (array, callback) {
  	return array.map(callback).join('')
  }

  var line = 1;
  var column = 1;
  var length = 0;
  var position = 0;
  var character = 0;
  var characters = '';

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {string} type
   * @param {string[]} props
   * @param {object[]} children
   * @param {number} length
   */
  function node (value, root, parent, type, props, children, length) {
  	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {string} type
   */
  function copy (value, root, type) {
  	return node(value, root.root, root.parent, type, root.props, root.children, 0)
  }

  /**
   * @return {number}
   */
  function char () {
  	return character
  }

  /**
   * @return {number}
   */
  function prev () {
  	character = position > 0 ? charat(characters, --position) : 0;

  	if (column--, character === 10)
  		column = 1, line--;

  	return character
  }

  /**
   * @return {number}
   */
  function next () {
  	character = position < length ? charat(characters, position++) : 0;

  	if (column++, character === 10)
  		column = 1, line++;

  	return character
  }

  /**
   * @return {number}
   */
  function peek () {
  	return charat(characters, position)
  }

  /**
   * @return {number}
   */
  function caret () {
  	return position
  }

  /**
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */
  function slice (begin, end) {
  	return substr(characters, begin, end)
  }

  /**
   * @param {number} type
   * @return {number}
   */
  function token (type) {
  	switch (type) {
  		// \0 \t \n \r \s whitespace token
  		case 0: case 9: case 10: case 13: case 32:
  			return 5
  		// ! + , / > @ ~ isolate token
  		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
  		// ; { } breakpoint token
  		case 59: case 123: case 125:
  			return 4
  		// : accompanied token
  		case 58:
  			return 3
  		// " ' ( [ opening delimit token
  		case 34: case 39: case 40: case 91:
  			return 2
  		// ) ] closing delimit token
  		case 41: case 93:
  			return 1
  	}

  	return 0
  }

  /**
   * @param {string} value
   * @return {any[]}
   */
  function alloc (value) {
  	return line = column = 1, length = strlen(characters = value), position = 0, []
  }

  /**
   * @param {any} value
   * @return {any}
   */
  function dealloc (value) {
  	return characters = '', value
  }

  /**
   * @param {number} type
   * @return {string}
   */
  function delimit (type) {
  	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
  }

  /**
   * @param {number} type
   * @return {string}
   */
  function whitespace (type) {
  	while (character = peek())
  		if (character < 33)
  			next();
  		else
  			break

  	return token(type) > 2 || token(character) > 3 ? '' : ' '
  }

  /**
   * @param {number} index
   * @param {number} count
   * @return {string}
   */
  function escaping (index, count) {
  	while (--count && next())
  		// not 0-9 A-F a-f
  		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
  			break

  	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
  }

  /**
   * @param {number} type
   * @return {number}
   */
  function delimiter (type) {
  	while (next())
  		switch (character) {
  			// ] ) " '
  			case type:
  				return position
  			// " '
  			case 34: case 39:
  				return delimiter(type === 34 || type === 39 ? type : character)
  			// (
  			case 40:
  				if (type === 41)
  					delimiter(type);
  				break
  			// \
  			case 92:
  				next();
  				break
  		}

  	return position
  }

  /**
   * @param {number} type
   * @param {number} index
   * @return {number}
   */
  function commenter (type, index) {
  	while (next())
  		// //
  		if (type + character === 47 + 10)
  			break
  		// /*
  		else if (type + character === 42 + 42 && peek() === 47)
  			break

  	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
  }

  /**
   * @param {number} index
   * @return {string}
   */
  function identifier (index) {
  	while (!token(peek()))
  		next();

  	return slice(index, position)
  }

  /**
   * @param {string} value
   * @return {object[]}
   */
  function compile (value) {
  	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {string[]} rule
   * @param {string[]} rules
   * @param {string[]} rulesets
   * @param {number[]} pseudo
   * @param {number[]} points
   * @param {string[]} declarations
   * @return {object}
   */
  function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  	var index = 0;
  	var offset = 0;
  	var length = pseudo;
  	var atrule = 0;
  	var property = 0;
  	var previous = 0;
  	var variable = 1;
  	var scanning = 1;
  	var ampersand = 1;
  	var character = 0;
  	var type = '';
  	var props = rules;
  	var children = rulesets;
  	var reference = rule;
  	var characters = type;

  	while (scanning)
  		switch (previous = character, character = next()) {
  			// " ' [ (
  			case 34: case 39: case 91: case 40:
  				characters += delimit(character);
  				break
  			// \t \n \r \s
  			case 9: case 10: case 13: case 32:
  				characters += whitespace(previous);
  				break
  			// \
  			case 92:
  				characters += escaping(caret() - 1, 7);
  				continue
  			// /
  			case 47:
  				switch (peek()) {
  					case 42: case 47:
  						append(comment(commenter(next(), caret()), root, parent), declarations);
  						break
  					default:
  						characters += '/';
  				}
  				break
  			// {
  			case 123 * variable:
  				points[index++] = strlen(characters) * ampersand;
  			// } ; \0
  			case 125 * variable: case 59: case 0:
  				switch (character) {
  					// \0 }
  					case 0: case 125: scanning = 0;
  					// ;
  					case 59 + offset:
  						if (property > 0 && (strlen(characters) - length))
  							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
  						break
  					// @ ;
  					case 59: characters += ';';
  					// { rule/at-rule
  					default:
  						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

  						if (character === 123)
  							if (offset === 0)
  								parse(characters, root, reference, reference, props, rulesets, length, points, children);
  							else
  								switch (atrule) {
  									// d m s
  									case 100: case 109: case 115:
  										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
  										break
  									default:
  										parse(characters, reference, reference, reference, [''], children, length, points, children);
  								}
  				}

  				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
  				break
  			// :
  			case 58:
  				length = 1 + strlen(characters), property = previous;
  			default:
  				if (variable < 1)
  					if (character == 123)
  						--variable;
  					else if (character == 125 && variable++ == 0 && prev() == 125)
  						continue

  				switch (characters += from(character), character * variable) {
  					// &
  					case 38:
  						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
  						break
  					// ,
  					case 44:
  						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
  						break
  					// @
  					case 64:
  						// -
  						if (peek() === 45)
  							characters += delimit(next());

  						atrule = peek(), offset = strlen(type = characters += identifier(caret())), character++;
  						break
  					// -
  					case 45:
  						if (previous === 45 && strlen(characters) == 2)
  							variable = 0;
  				}
  		}

  	return rulesets
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} index
   * @param {number} offset
   * @param {string[]} rules
   * @param {number[]} points
   * @param {string} type
   * @param {string[]} props
   * @param {string[]} children
   * @param {number} length
   * @return {object}
   */
  function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
  	var post = offset - 1;
  	var rule = offset === 0 ? rules : [''];
  	var size = sizeof(rule);

  	for (var i = 0, j = 0, k = 0; i < index; ++i)
  		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
  			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
  				props[k++] = z;

  	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
  }

  /**
   * @param {number} value
   * @param {object} root
   * @param {object?} parent
   * @return {object}
   */
  function comment (value, root, parent) {
  	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} length
   * @return {object}
   */
  function declaration (value, root, parent, length) {
  	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
  }

  /**
   * @param {string} value
   * @param {number} length
   * @return {string}
   */
  function prefix (value, length) {
  	switch (hash(value, length)) {
  		// color-adjust
  		case 5103:
  			return WEBKIT + 'print-' + value + value
  		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
  		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
  		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
  		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
  		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
  		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
  		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
  		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
  			return WEBKIT + value + value
  		// appearance, user-select, transform, hyphens, text-size-adjust
  		case 5349: case 4246: case 4810: case 6968: case 2756:
  			return WEBKIT + value + MOZ + value + MS + value + value
  		// flex, flex-direction
  		case 6828: case 4268:
  			return WEBKIT + value + MS + value + value
  		// order
  		case 6165:
  			return WEBKIT + value + MS + 'flex-' + value + value
  		// align-items
  		case 5187:
  			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
  		// align-self
  		case 5443:
  			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
  		// align-content
  		case 4675:
  			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
  		// flex-shrink
  		case 5548:
  			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
  		// flex-basis
  		case 5292:
  			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
  		// flex-grow
  		case 6060:
  			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
  		// transition
  		case 4554:
  			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
  		// cursor
  		case 6187:
  			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
  		// background, background-image
  		case 5495: case 3959:
  			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
  		// justify-content
  		case 4968:
  			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
  		// (margin|padding)-inline-(start|end)
  		case 4095: case 3583: case 4068: case 2532:
  			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
  		// (min|max)?(width|height|inline-size|block-size)
  		case 8116: case 7059: case 5753: case 5535:
  		case 5445: case 5701: case 4933: case 4677:
  		case 5533: case 5789: case 5021: case 4765:
  			// stretch, max-content, min-content, fill-available
  			if (strlen(value) - 1 - length > 6)
  				switch (charat(value, length + 1)) {
  					// (m)ax-content, (m)in-content
  					case 109:
  						// -
  						if (charat(value, length + 4) !== 45)
  							break
  					// (f)ill-available, (f)it-content
  					case 102:
  						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
  					// (s)tretch
  					case 115:
  						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
  				}
  			break
  		// position: sticky
  		case 4949:
  			// (s)ticky?
  			if (charat(value, length + 1) !== 115)
  				break
  		// display: (flex|inline-flex)
  		case 6444:
  			switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
  				// stic(k)y
  				case 107:
  					return replace(value, ':', ':' + WEBKIT) + value
  				// (inline-)?fl(e)x
  				case 101:
  					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
  			}
  			break
  		// writing-mode
  		case 5936:
  			switch (charat(value, length + 11)) {
  				// vertical-l(r)
  				case 114:
  					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
  				// vertical-r(l)
  				case 108:
  					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
  				// horizontal(-)tb
  				case 45:
  					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
  			}

  			return WEBKIT + value + MS + value + value
  	}

  	return value
  }

  /**
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */
  function serialize (children, callback) {
  	var output = '';
  	var length = sizeof(children);

  	for (var i = 0; i < length; i++)
  		output += callback(children[i], i, children, callback) || '';

  	return output
  }

  /**
   * @param {object} element
   * @param {number} index
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */
  function stringify (element, index, children, callback) {
  	switch (element.type) {
  		case IMPORT: case DECLARATION: return element.return = element.return || element.value
  		case COMMENT: return ''
  		case RULESET: element.value = element.props.join(',');
  	}

  	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
  }

  /**
   * @param {function[]} collection
   * @return {function}
   */
  function middleware (collection) {
  	var length = sizeof(collection);

  	return function (element, index, children, callback) {
  		var output = '';

  		for (var i = 0; i < length; i++)
  			output += collection[i](element, index, children, callback) || '';

  		return output
  	}
  }

  /**
   * @param {function} callback
   * @return {function}
   */
  function rulesheet (callback) {
  	return function (element) {
  		if (!element.root)
  			if (element = element.return)
  				callback(element);
  	}
  }

  /**
   * @param {object} element
   * @param {number} index
   * @param {object[]} children
   * @param {function} callback
   */
  function prefixer (element, index, children, callback) {
  	if (!element.return)
  		switch (element.type) {
  			case DECLARATION: element.return = prefix(element.value, element.length);
  				break
  			case KEYFRAMES:
  				return serialize([copy(replace(element.value, '@', '@' + WEBKIT), element, '')], callback)
  			case RULESET:
  				if (element.length)
  					return combine(element.props, function (value) {
  						switch (match(value, /(::plac\w+|:read-\w+)/)) {
  							// :read-(only|write)
  							case ':read-only': case ':read-write':
  								return serialize([copy(replace(value, /:(read-\w+)/, ':' + MOZ + '$1'), element, '')], callback)
  							// :placeholder
  							case '::placeholder':
  								return serialize([
  									copy(replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1'), element, ''),
  									copy(replace(value, /:(plac\w+)/, ':' + MOZ + '$1'), element, ''),
  									copy(replace(value, /:(plac\w+)/, MS + 'input-$1'), element, '')
  								], callback)
  						}

  						return ''
  					})
  		}
  }

  var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // $FlowFixMe
        return cache.get(arg);
      }

      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var last = function last(arr) {
    return arr.length ? arr[arr.length - 1] : null;
  }; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


  var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;

    while (true) {
      previous = character;
      character = peek(); // &\f

      if (previous === 38 && character === 12) {
        points[index] = 1;
      }

      if (token(character)) {
        break;
      }

      next();
    }

    return slice(begin, position);
  };

  var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;

    do {
      switch (token(character)) {
        case 0:
          // &\f
          if (character === 38 && peek() === 12) {
            // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
          }

          parsed[index] += identifierWithPointTracking(position - 1, points, index);
          break;

        case 2:
          parsed[index] += delimit(character);
          break;

        case 4:
          // comma
          if (character === 44) {
            // colon
            parsed[++index] = peek() === 58 ? '&\f' : '';
            points[index] = parsed[index].length;
            break;
          }

        // fallthrough

        default:
          parsed[index] += from(character);
      }
    } while (character = next());

    return parsed;
  };

  var getRules = function getRules(value, points) {
    return dealloc(toRules(alloc(value), points));
  }; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


  var fixedElements = /* #__PURE__ */new WeakMap();
  var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
    !element.length) {
      return;
    }

    var value = element.value,
        parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;

    while (parent.type !== 'rule') {
      parent = parent.parent;
      if (!parent) return;
    } // short-circuit for the simplest case


    if (element.props.length === 1 && value.charCodeAt(0) !== 58
    /* colon */
    && !fixedElements.get(parent)) {
      return;
    } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


    if (isImplicitRule) {
      return;
    }

    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;

    for (var i = 0, k = 0; i < rules.length; i++) {
      for (var j = 0; j < parentRules.length; j++, k++) {
        element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
      }
    }
  };
  var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
      var value = element.value;

      if ( // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98) {
        // this ignores label
        element["return"] = '';
        element.value = '';
      }
    }
  };
  var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

  var isIgnoringComment = function isIgnoringComment(element) {
    return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
  };

  var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function (element, index, children) {
      if (element.type !== 'rule') return;
      var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

      if (unsafePseudoClasses && cache.compat !== true) {
        var prevElement = index > 0 ? children[index - 1] : null;

        if (prevElement && isIgnoringComment(last(prevElement.children))) {
          return;
        }

        unsafePseudoClasses.forEach(function (unsafePseudoClass) {
          console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
        });
      }
    };
  };

  var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
  };

  var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for (var i = index - 1; i >= 0; i--) {
      if (!isImportRule(children[i])) {
        return true;
      }
    }

    return false;
  }; // use this to remove incorrect elements from further processing
  // so they don't get handed to the `sheet` (or anything else)
  // as that could potentially lead to additional logs which in turn could be overhelming to the user


  var nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
  };

  var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) {
      return;
    }

    if (element.parent) {
      console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
      nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
      console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
      nullifyElement(element);
    }
  };

  var isBrowser = typeof document !== 'undefined';
  var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
    return memoize(function () {
      var cache = {};
      return function (name) {
        return cache[name];
      };
    });
  });
  var defaultStylisPlugins = [prefixer];

  var createCache = function createCache(options) {
    var key = options.key;

    if (process.env.NODE_ENV !== 'production' && !key) {
      throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
    }

    if (isBrowser && key === 'css') {
      var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
      // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
      // note this very very intentionally targets all style elements regardless of the key to ensure
      // that creating a cache works inside of render of a React component

      Array.prototype.forEach.call(ssrStyles, function (node) {
        // we want to only move elements which have a space in the data-emotion attribute value
        // because that indicates that it is an Emotion 11 server-side rendered style elements
        // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
        // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
        // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
        // will not result in the Emotion 10 styles being destroyed
        var dataEmotionAttribute = node.getAttribute('data-emotion');

        if (dataEmotionAttribute.indexOf(' ') === -1) {
          return;
        }
        document.head.appendChild(node);
        node.setAttribute('data-s', '');
      });
    }

    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe
      if (/[^a-z-]/.test(key)) {
        throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
      }
    }

    var inserted = {}; // $FlowFixMe

    var container;
    var nodesToHydrate = [];

    if (isBrowser) {
      container = options.container || document.head;
      Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }

        nodesToHydrate.push(node);
      });
    }

    var _insert;

    var omnipresentPlugins = [compat, removeLabel];

    if (process.env.NODE_ENV !== 'production') {
      omnipresentPlugins.push(createUnsafeSelectorsAlarm({
        get compat() {
          return cache.compat;
        }

      }), incorrectImportAlarm);
    }

    if (isBrowser) {
      var currentSheet;
      var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
        if (!element.root) {
          if (element["return"]) {
            currentSheet.insert(element["return"]);
          } else if (element.value && element.type !== COMMENT) {
            // insert empty rule in non-production environments
            // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
            currentSheet.insert(element.value + "{}");
          }
        }
      } : rulesheet(function (rule) {
        currentSheet.insert(rule);
      })];
      var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

      var stylis = function stylis(styles) {
        return serialize(compile(styles), serializer);
      };

      _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;

        if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
          currentSheet = {
            insert: function insert(rule) {
              sheet.insert(rule + serialized.map);
            }
          };
        }

        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

        if (shouldCache) {
          cache.inserted[serialized.name] = true;
        }
      };
    } else {
      var _finalizingPlugins = [stringify];

      var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

      var _stylis = function _stylis(styles) {
        return serialize(compile(styles), _serializer);
      }; // $FlowFixMe


      var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

      var getRules = function getRules(selector, serialized) {
        var name = serialized.name;

        if (serverStylisCache[name] === undefined) {
          serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        }

        return serverStylisCache[name];
      };

      _insert = function _insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        var rules = getRules(selector, serialized);

        if (cache.compat === undefined) {
          // in regular mode, we don't set the styles on the inserted cache
          // since we don't need to and that would be wasting memory
          // we return them so that they are rendered in a style tag
          if (shouldCache) {
            cache.inserted[name] = true;
          }

          if ( // using === development instead of !== production
          // because if people do ssr in tests, the source maps showing up would be annoying
          process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
            return rules + serialized.map;
          }

          return rules;
        } else {
          // in compat mode, we put the styles on the inserted cache so
          // that emotion-server can pull out the styles
          // except when we don't want to cache it which was in Global but now
          // is nowhere but we don't want to do a major right now
          // and just in case we're going to leave the case here
          // it's also not affecting client side bundle size
          // so it's really not a big deal
          if (shouldCache) {
            cache.inserted[name] = rules;
          } else {
            return rules;
          }
        }
      };
    }

    var cache = {
      key: key,
      sheet: new StyleSheet({
        key: key,
        container: container,
        nonce: options.nonce,
        speedy: options.speedy,
        prepend: options.prepend
      }),
      nonce: options.nonce,
      inserted: inserted,
      registered: {},
      insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
  };

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
  Symbol.for("react.suspense_list"):60120,r$1=b$1?Symbol.for("react.memo"):60115,t$1=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
  function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e$1:case g$1:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t$1:case r$1:case h$1:return a;default:return u}}case d$1:return u}}}function A$1(a){return z$1(a)===m$1}var AsyncMode$1=l$1;var ConcurrentMode$1=m$1;var ContextConsumer$1=k$1;var ContextProvider$1=h$1;var Element$2=c$1;var ForwardRef$1=n$1;var Fragment$1=e$1;var Lazy$1=t$1;var Memo$1=r$1;var Portal$1=d$1;
  var Profiler$1=g$1;var StrictMode$1=f$1;var Suspense$1=p$1;var isAsyncMode$1=function(a){return A$1(a)||z$1(a)===l$1};var isConcurrentMode$1=A$1;var isContextConsumer$1=function(a){return z$1(a)===k$1};var isContextProvider$1=function(a){return z$1(a)===h$1};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};var isForwardRef$1=function(a){return z$1(a)===n$1};var isFragment$1=function(a){return z$1(a)===e$1};var isLazy$1=function(a){return z$1(a)===t$1};
  var isMemo$1=function(a){return z$1(a)===r$1};var isPortal$1=function(a){return z$1(a)===d$1};var isProfiler$1=function(a){return z$1(a)===g$1};var isStrictMode$1=function(a){return z$1(a)===f$1};var isSuspense$1=function(a){return z$1(a)===p$1};
  var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$1||a===p$1||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$1||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};var typeOf$1=z$1;

  var reactIs_production_min$1 = {
  	AsyncMode: AsyncMode$1,
  	ConcurrentMode: ConcurrentMode$1,
  	ContextConsumer: ContextConsumer$1,
  	ContextProvider: ContextProvider$1,
  	Element: Element$2,
  	ForwardRef: ForwardRef$1,
  	Fragment: Fragment$1,
  	Lazy: Lazy$1,
  	Memo: Memo$1,
  	Portal: Portal$1,
  	Profiler: Profiler$1,
  	StrictMode: StrictMode$1,
  	Suspense: Suspense$1,
  	isAsyncMode: isAsyncMode$1,
  	isConcurrentMode: isConcurrentMode$1,
  	isContextConsumer: isContextConsumer$1,
  	isContextProvider: isContextProvider$1,
  	isElement: isElement$1,
  	isForwardRef: isForwardRef$1,
  	isFragment: isFragment$1,
  	isLazy: isLazy$1,
  	isMemo: isMemo$1,
  	isPortal: isPortal$1,
  	isProfiler: isProfiler$1,
  	isStrictMode: isStrictMode$1,
  	isSuspense: isSuspense$1,
  	isValidElementType: isValidElementType$1,
  	typeOf: typeOf$1
  };

  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var reactIs_development$1 = createCommonjsModule(function (module, exports) {



  if (process.env.NODE_ENV !== "production") {
    (function() {

  // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
  // nor polyfill, then a plain number is used for performance.
  var hasSymbol = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
  var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
  var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
  var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
  var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
  var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
  var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
  // (unstable) APIs that have been removed. Can we remove the symbols?

  var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
  var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
  var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
  var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
  var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
  var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
  var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
  var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
  var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
  var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
  var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

  function isValidElementType(type) {
    return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
    type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
  }

  function typeOf(object) {
    if (typeof object === 'object' && object !== null) {
      var $$typeof = object.$$typeof;

      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          var type = object.type;

          switch (type) {
            case REACT_ASYNC_MODE_TYPE:
            case REACT_CONCURRENT_MODE_TYPE:
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
              return type;

            default:
              var $$typeofType = type && type.$$typeof;

              switch ($$typeofType) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                case REACT_PROVIDER_TYPE:
                  return $$typeofType;

                default:
                  return $$typeof;
              }

          }

        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }

    return undefined;
  } // AsyncMode is deprecated along with isAsyncMode

  var AsyncMode = REACT_ASYNC_MODE_TYPE;
  var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
  var ContextConsumer = REACT_CONTEXT_TYPE;
  var ContextProvider = REACT_PROVIDER_TYPE;
  var Element = REACT_ELEMENT_TYPE;
  var ForwardRef = REACT_FORWARD_REF_TYPE;
  var Fragment = REACT_FRAGMENT_TYPE;
  var Lazy = REACT_LAZY_TYPE;
  var Memo = REACT_MEMO_TYPE;
  var Portal = REACT_PORTAL_TYPE;
  var Profiler = REACT_PROFILER_TYPE;
  var StrictMode = REACT_STRICT_MODE_TYPE;
  var Suspense = REACT_SUSPENSE_TYPE;
  var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

  function isAsyncMode(object) {
    {
      if (!hasWarnedAboutDeprecatedIsAsyncMode) {
        hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

        console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
      }
    }

    return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
  }
  function isConcurrentMode(object) {
    return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
  }
  function isContextConsumer(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  }
  function isContextProvider(object) {
    return typeOf(object) === REACT_PROVIDER_TYPE;
  }
  function isElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
  function isForwardRef(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  }
  function isFragment(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  }
  function isLazy(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  }
  function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  }
  function isPortal(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  }
  function isProfiler(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  }
  function isStrictMode(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  }
  function isSuspense(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  }

  exports.AsyncMode = AsyncMode;
  exports.ConcurrentMode = ConcurrentMode;
  exports.ContextConsumer = ContextConsumer;
  exports.ContextProvider = ContextProvider;
  exports.Element = Element;
  exports.ForwardRef = ForwardRef;
  exports.Fragment = Fragment;
  exports.Lazy = Lazy;
  exports.Memo = Memo;
  exports.Portal = Portal;
  exports.Profiler = Profiler;
  exports.StrictMode = StrictMode;
  exports.Suspense = Suspense;
  exports.isAsyncMode = isAsyncMode;
  exports.isConcurrentMode = isConcurrentMode;
  exports.isContextConsumer = isContextConsumer;
  exports.isContextProvider = isContextProvider;
  exports.isElement = isElement;
  exports.isForwardRef = isForwardRef;
  exports.isFragment = isFragment;
  exports.isLazy = isLazy;
  exports.isMemo = isMemo;
  exports.isPortal = isPortal;
  exports.isProfiler = isProfiler;
  exports.isStrictMode = isStrictMode;
  exports.isSuspense = isSuspense;
  exports.isValidElementType = isValidElementType;
  exports.typeOf = typeOf;
    })();
  }
  });

  var reactIs$1 = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1;
  } else {
    module.exports = reactIs_development$1;
  }
  });

  var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

  var isBrowser$1 = typeof document !== 'undefined';
  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className] + ";");
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }
  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;

    if ( // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }

    if (cache.inserted[serialized.name] === undefined) {
      var stylesForSSR = '';
      var current = serialized;

      do {
        var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

        if (!isBrowser$1 && maybeStyles !== undefined) {
          stylesForSSR += maybeStyles;
        }

        current = current.next;
      } while (current !== undefined);

      if (!isBrowser$1 && stylesForSSR.length !== 0) {
        return stylesForSSR;
      }
    }
  };

  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
        i = 0,
        len = str.length;

    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^=
      /* k >>> r: */
      k >>> 24;
      h =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array


    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h =
        /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.


    h ^= h >>> 13;
    h =
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };

  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };

  var processStyleName = /* #__PURE__ */memoize(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });

  var processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }

    if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  if (process.env.NODE_ENV !== 'production') {
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
    var oldProcessStyleValue = processStyleValue;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g;
    var hyphenatedCache = {};

    processStyleValue = function processStyleValue(key, value) {
      if (key === 'content') {
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
          throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
        }
      }

      var processed = oldProcessStyleValue(key, value);

      if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
        hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
          return _char.toUpperCase();
        }) + "?");
      }

      return processed;
    };
  }

  function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) {
      return '';
    }

    if (interpolation.__emotion_styles !== undefined) {
      if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
        throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
      }

      return interpolation;
    }

    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }

      case 'object':
        {
          if (interpolation.anim === 1) {
            cursor = {
              name: interpolation.name,
              styles: interpolation.styles,
              next: cursor
            };
            return interpolation.name;
          }

          if (interpolation.styles !== undefined) {
            var next = interpolation.next;

            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }

            var styles = interpolation.styles + ";";

            if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
              styles += interpolation.map;
            }

            return styles;
          }

          return createStringFromObject(mergedProps, registered, interpolation);
        }

      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result);
          } else if (process.env.NODE_ENV !== 'production') {
            console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
          }

          break;
        }

      case 'string':
        if (process.env.NODE_ENV !== 'production') {
          var matched = [];
          var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
            var fakeVarName = "animation" + matched.length;
            matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
            return "${" + fakeVarName + "}";
          });

          if (matched.length) {
            console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
          }
        }

        break;
    } // finalize string values (regular strings and functions interpolated into css calls)


    if (registered == null) {
      return interpolation;
    }

    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
  }

  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';

    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
      }
    } else {
      for (var _key in obj) {
        var value = obj[_key];

        if (typeof value !== 'object') {
          if (registered != null && registered[value] !== undefined) {
            string += _key + "{" + registered[value] + "}";
          } else if (isProcessableValue(value)) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
          }
        } else {
          if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
          }

          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);

            switch (_key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(_key) + ":" + interpolated + ";";
                  break;
                }

              default:
                {
                  if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                    console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                  }

                  string += _key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }

    return string;
  }

  var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
  var sourceMapPattern;

  if (process.env.NODE_ENV !== 'production') {
    sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
  } // this is the cursor for keyframes
  // keyframes are stored on the SerializedStyles object as a linked list


  var cursor;
  var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }

    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings);
    } else {
      if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[0];
    } // we start at 1 since we've already handled the first arg


    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i]);

      if (stringMode) {
        if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles += strings[i];
      }
    }

    var sourceMap;

    if (process.env.NODE_ENV !== 'production') {
      styles = styles.replace(sourceMapPattern, function (match) {
        sourceMap = match;
        return '';
      });
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time


    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' + // $FlowFixMe we know it's not null
      match[1];
    }

    var name = murmur2(styles) + identifierName;

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
      return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: cursor,
        toString: function toString() {
          return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
      };
    }

    return {
      name: name,
      styles: styles,
      next: cursor
    };
  };

  var isBrowser$2 = typeof document !== 'undefined';
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

  var EmotionCacheContext = /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
    key: 'css'
  }) : null);

  if (process.env.NODE_ENV !== 'production') {
    EmotionCacheContext.displayName = 'EmotionCacheContext';
  }

  EmotionCacheContext.Provider;

  var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      // the cache will never be null in the browser
      var cache = React.useContext(EmotionCacheContext);
      return func(props, cache, ref);
    });
  };

  if (!isBrowser$2) {
    withEmotionCache = function withEmotionCache(func) {
      return function (props) {
        var cache = React.useContext(EmotionCacheContext);

        if (cache === null) {
          // yes, we're potentially creating this on every render
          // it doesn't actually matter though since it's only on the server
          // so there will only every be a single render
          // that could change in the future because of suspense and etc. but for now,
          // this works and i don't want to optimise for a future thing that we aren't sure about
          cache = createCache({
            key: 'css'
          });
          return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
            value: cache
          }, func(props, cache));
        } else {
          return func(props, cache);
        }
      };
    };
  }

  var ThemeContext = /* #__PURE__ */React.createContext({});

  if (process.env.NODE_ENV !== 'production') {
    ThemeContext.displayName = 'EmotionThemeContext';
  }

  // thus we only need to replace what is a valid character for JS, but not for CSS

  var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
  };

  var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
  var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
  var createEmotionProps = function createEmotionProps(type, props) {
    if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
    props.css.indexOf(':') !== -1) {
      throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
    }

    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty$1.call(props, key)) {
        newProps[key] = props[key];
      }
    }

    newProps[typePropName] = type;

    if (process.env.NODE_ENV !== 'production') {
      var error = new Error();

      if (error.stack) {
        // chrome
        var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z0-9$]+) /);

        if (!match) {
          // safari and firefox
          match = error.stack.match(/.*\n([A-Z][A-Za-z0-9$]+)@/);
        }

        if (match) {
          newProps[labelPropName] = sanitizeIdentifier(match[1]);
        }
      }
    }

    return newProps;
  };
  var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible

    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
      cssProp = cache.registered[cssProp];
    }

    var type = props[typePropName];
    var registeredStyles = [cssProp];
    var className = '';

    if (typeof props.className === 'string') {
      className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
    } else if (props.className != null) {
      className = props.className + " ";
    }

    var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext));

    if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
      var labelFromStack = props[labelPropName];

      if (labelFromStack) {
        serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
      }
    }

    var rules = insertStyles(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty$1.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
        newProps[key] = props[key];
      }
    }

    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/React.createElement(type, newProps);

    if (!isBrowser$2 && rules !== undefined) {
      var _ref;

      var serializedNames = serialized.name;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        next = next.next;
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
    }

    return ele;
  });

  if (process.env.NODE_ENV !== 'production') {
    Emotion.displayName = 'EmotionCssPropInternal';
  }

  var pkg = {
  	name: "@emotion/react",
  	version: "11.5.0",
  	main: "dist/emotion-react.cjs.js",
  	module: "dist/emotion-react.esm.js",
  	browser: {
  		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
  		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  	},
  	types: "types/index.d.ts",
  	files: [
  		"src",
  		"dist",
  		"jsx-runtime",
  		"jsx-dev-runtime",
  		"isolated-hoist-non-react-statics-do-not-use-this-in-your-code",
  		"types/*.d.ts",
  		"macro.js",
  		"macro.d.ts",
  		"macro.js.flow"
  	],
  	sideEffects: false,
  	author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
  	license: "MIT",
  	scripts: {
  		"test:typescript": "dtslint types"
  	},
  	dependencies: {
  		"@babel/runtime": "^7.13.10",
  		"@emotion/cache": "^11.5.0",
  		"@emotion/serialize": "^1.0.2",
  		"@emotion/sheet": "^1.0.3",
  		"@emotion/utils": "^1.0.0",
  		"@emotion/weak-memoize": "^0.2.5",
  		"hoist-non-react-statics": "^3.3.1"
  	},
  	peerDependencies: {
  		"@babel/core": "^7.0.0",
  		react: ">=16.8.0"
  	},
  	peerDependenciesMeta: {
  		"@babel/core": {
  			optional: true
  		},
  		"@types/react": {
  			optional: true
  		}
  	},
  	devDependencies: {
  		"@babel/core": "^7.13.10",
  		"@emotion/css": "11.5.0",
  		"@emotion/css-prettifier": "1.0.0",
  		"@emotion/server": "11.4.0",
  		"@emotion/styled": "11.3.0",
  		"@types/react": "^16.9.11",
  		dtslint: "^0.3.0",
  		"html-tag-names": "^1.1.2",
  		react: "16.14.0",
  		"svg-tag-names": "^1.1.1"
  	},
  	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  	publishConfig: {
  		access: "public"
  	},
  	"umd:main": "dist/emotion-react.umd.min.js",
  	preconstruct: {
  		entrypoints: [
  			"./index.js",
  			"./jsx-runtime.js",
  			"./jsx-dev-runtime.js",
  			"./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"
  		],
  		umdName: "emotionReact"
  	}
  };

  var jsx = function jsx(type, props) {
    var args = arguments;

    if (props == null || !hasOwnProperty$1.call(props, 'css')) {
      // $FlowFixMe
      return React.createElement.apply(undefined, args);
    }

    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = Emotion;
    createElementArgArray[1] = createEmotionProps(type, props);

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    } // $FlowFixMe


    return React.createElement.apply(null, createElementArgArray);
  };

  var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
  // initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
  // initial client-side render from SSR, use place of hydrating tag

  var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
    if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
    // probably using the custom createElement which
    // means it will be turned into a className prop
    // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
    props.className || props.css)) {
      console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
      warnedAboutCssPropForGlobal = true;
    }

    var styles = props.styles;
    var serialized = serializeStyles([styles], undefined, React.useContext(ThemeContext));

    if (!isBrowser$2) {
      var _ref;

      var serializedNames = serialized.name;
      var serializedStyles = serialized.styles;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        serializedStyles += next.styles;
        next = next.next;
      }

      var shouldCache = cache.compat === true;
      var rules = cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, cache.sheet, shouldCache);

      if (shouldCache) {
        return null;
      }

      return /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything


    var sheetRef = React.useRef();
    React.useLayoutEffect(function () {
      var key = cache.key + "-global";
      var sheet = new StyleSheet({
        key: key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy
      });
      var rehydrating = false; // $FlowFixMe

      var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

      if (cache.sheet.tags.length) {
        sheet.before = cache.sheet.tags[0];
      }

      if (node !== null) {
        rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

        node.setAttribute('data-emotion', key);
        sheet.hydrate([node]);
      }

      sheetRef.current = [sheet, rehydrating];
      return function () {
        sheet.flush();
      };
    }, [cache]);
    React.useLayoutEffect(function () {
      var sheetRefCurrent = sheetRef.current;
      var sheet = sheetRefCurrent[0],
          rehydrating = sheetRefCurrent[1];

      if (rehydrating) {
        sheetRefCurrent[1] = false;
        return;
      }

      if (serialized.next !== undefined) {
        // insert keyframes
        insertStyles(cache, serialized.next, true);
      }

      if (sheet.tags.length) {
        // if this doesn't exist then it will be null so the style element will be appended
        var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
        sheet.before = element;
        sheet.flush();
      }

      cache.insert("", serialized, sheet, false);
    }, [cache, serialized.name]);
    return null;
  });

  if (process.env.NODE_ENV !== 'production') {
    Global.displayName = 'EmotionGlobal';
  }

  function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return serializeStyles(args);
  }

  var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe

    return {
      name: name,
      styles: "@keyframes " + name + "{" + insertable.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  };

  var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';

    for (; i < len; i++) {
      var arg = args[i];
      if (arg == null) continue;
      var toAdd = void 0;

      switch (typeof arg) {
        case 'boolean':
          break;

        case 'object':
          {
            if (Array.isArray(arg)) {
              toAdd = classnames(arg);
            } else {
              if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
                console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
              }

              toAdd = '';

              for (var k in arg) {
                if (arg[k] && k) {
                  toAdd && (toAdd += ' ');
                  toAdd += k;
                }
              }
            }

            break;
          }

        default:
          {
            toAdd = arg;
          }
      }

      if (toAdd) {
        cls && (cls += ' ');
        cls += toAdd;
      }
    }

    return cls;
  };

  function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles);
  }

  var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, cache.registered);

      if (isBrowser$2) {
        insertStyles(cache, serialized, false);
      } else {
        var res = insertStyles(cache, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }

      return cache.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(cache.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: React.useContext(ThemeContext)
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
    }

    return ele;
  });

  if (process.env.NODE_ENV !== 'production') {
    ClassNames.displayName = 'EmotionClassNames';
  }

  if (process.env.NODE_ENV !== 'production') {
    var isBrowser$3 = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

    var isJest = typeof jest !== 'undefined';

    if (isBrowser$3 && !isJest) {
      // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
      var globalContext = // $FlowIgnore
      typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
      : isBrowser$3 ? window : global;
      var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

      if (globalContext[globalKey]) {
        console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
      }

      globalContext[globalKey] = true;
    }
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
  // ==============================
  // NO OP
  // ==============================
  var noop = function noop() {};
  // Class Name Prefixer
  // ==============================

  /**
   String representation of component state for styling with class names.

   Expects an array of strings OR a string/object pair:
   - className(['comp', 'comp-arg', 'comp-arg-2'])
     @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
   - className('comp', { some: true, state: false })
     @returns 'react-select__comp react-select__comp--some'
  */

  function applyPrefixToName(prefix, name) {
    if (!name) {
      return prefix;
    } else if (name[0] === '-') {
      return prefix + name;
    } else {
      return prefix + '__' + name;
    }
  }

  function classNames(prefix, state, className) {
    var arr = [className];

    if (state && prefix) {
      for (var key in state) {
        if (state.hasOwnProperty(key) && state[key]) {
          arr.push("".concat(applyPrefixToName(prefix, key)));
        }
      }
    }

    return arr.filter(function (i) {
      return i;
    }).map(function (i) {
      return String(i).trim();
    }).join(' ');
  } // ==============================
  // Clean Value
  // ==============================

  var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if (_typeof(value) === 'object' && value !== null) return [value];
    return [];
  }; // ==============================
  // Clean Common Props
  // ==============================

  var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
        props.clearValue;
        props.cx;
        props.getStyles;
        props.getValue;
        props.hasValue;
        props.isMulti;
        props.isRtl;
        props.options;
        props.selectOption;
        props.selectProps;
        props.setValue;
        props.theme;
        var innerProps = _objectWithoutProperties(props, _excluded$3);

    return _objectSpread2({}, innerProps);
  }; // ==============================
  // Scroll Helpers
  // ==============================

  function isDocumentElement(el) {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
  } // Normalized Scroll Top
  // ------------------------------

  function getScrollTop(el) {
    if (isDocumentElement(el)) {
      return window.pageYOffset;
    }

    return el.scrollTop;
  }
  function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
      window.scrollTo(0, top);
      return;
    }

    el.scrollTop = top;
  } // Get Scroll Parent
  // ------------------------------

  function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;

    for (var parent = element; parent = parent.parentElement;) {
      style = getComputedStyle(parent);

      if (excludeStaticParent && style.position === 'static') {
        continue;
      }

      if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
        return parent;
      }
    }

    return document.documentElement;
  } // Animated Scroll To
  // ------------------------------

  /**
    @param t: time (elapsed)
    @param b: initial value
    @param c: amount of change
    @param d: duration
  */

  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;

    function animateScroll() {
      currentTime += increment;
      var val = easeOutCubic(currentTime, start, change, duration);
      scrollTo(element, val);

      if (currentTime < duration) {
        window.requestAnimationFrame(animateScroll);
      } else {
        callback(element);
      }
    }

    animateScroll();
  } // Scroll Into View
  // ------------------------------

  function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;

    if (focusedRect.bottom + overScroll > menuRect.bottom) {
      scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    } else if (focusedRect.top - overScroll < menuRect.top) {
      scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
  } // ==============================
  // Get bounding client object
  // ==============================
  // cannot get keys using array notation with DOMRect

  function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
      bottom: rect.bottom,
      height: rect.height,
      left: rect.left,
      right: rect.right,
      top: rect.top,
      width: rect.width
    };
  }
  // Touch Capability Detector
  // ==============================

  function isTouchCapable() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  } // ==============================
  // Mobile Device Detector
  // ==============================

  function isMobileDevice() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return false;
    }
  } // ==============================
  // Passive Event Detector
  // ==============================
  // https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

  var passiveOptionAccessed = false;
  var options = {
    get passive() {
      return passiveOptionAccessed = true;
    }

  }; // check for SSR

  var w$2 = typeof window !== 'undefined' ? window : {};

  if (w$2.addEventListener && w$2.removeEventListener) {
    w$2.addEventListener('p', noop, options);
    w$2.removeEventListener('p', noop, false);
  }

  var supportsPassiveEvents = passiveOptionAccessed;
  function notNullish(item) {
    return item != null;
  }
  function isArray(arg) {
    return Array.isArray(arg);
  }
  function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
  }
  function singleValueAsValue(singleValue) {
    return singleValue;
  }
  function multiValueAsValue(multiValue) {
    return multiValue;
  }

  function getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight,
        menuEl = _ref.menuEl,
        minHeight = _ref.minHeight,
        placement = _ref.placement,
        shouldScroll = _ref.shouldScroll,
        isFixedPosition = _ref.isFixedPosition,
        theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
      placement: 'bottom',
      maxHeight: maxHeight
    }; // something went wrong, return default state

    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered

    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
        scrollHeight = _scrollParent$getBoun.height;

    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
        menuBottom = _menuEl$getBoundingCl.bottom,
        menuHeight = _menuEl$getBoundingCl.height,
        menuTop = _menuEl$getBoundingCl.top;

    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
        containerTop = _menuEl$offsetParent$.top;

    var viewHeight = window.innerHeight;
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;

    switch (placement) {
      case 'auto':
      case 'bottom':
        // 1: the menu will fit, do nothing
        if (viewSpaceBelow >= menuHeight) {
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled


        if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          }

          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained


        if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          } // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.


          var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
          return {
            placement: 'bottom',
            maxHeight: constrainedHeight
          };
        } // 4. Forked beviour when there isn't enough space below
        // AUTO: flip the menu, render above


        if (placement === 'auto' || isFixedPosition) {
          // may need to be constrained after flipping
          var _constrainedHeight = maxHeight;
          var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

          if (spaceAbove >= minHeight) {
            _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
          }

          return {
            placement: 'top',
            maxHeight: _constrainedHeight
          };
        } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


        if (placement === 'bottom') {
          if (shouldScroll) {
            scrollTo(scrollParent, scrollDown);
          }

          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        }

        break;

      case 'top':
        // 1: the menu will fit, do nothing
        if (viewSpaceAbove >= menuHeight) {
          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled


        if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }

          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained


        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.

          if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
            _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
          }

          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }

          return {
            placement: 'top',
            maxHeight: _constrainedHeight2
          };
        } // 4. not enough space, the browser WILL NOT increase scrollable area when
        // absolutely positioned element rendered above the viewport (only below).
        // Flip the menu, render below


        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };

      default:
        throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    }

    return defaultState;
  } // Menu Component
  // ------------------------------

  function alignToControl(placement) {
    var placementToCSSProp = {
      bottom: 'top',
      top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
  }

  var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
  };

  var menuCSS = function menuCSS(_ref2) {
    var _ref3;

    var placement = _ref2.placement,
        _ref2$theme = _ref2.theme,
        borderRadius = _ref2$theme.borderRadius,
        spacing = _ref2$theme.spacing,
        colors = _ref2$theme.colors;
    return _ref3 = {
      label: 'menu'
    }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
  };
  var PortalPlacementContext = /*#__PURE__*/React.createContext({
    getPortalPlacement: null
  }); // NOTE: internal only

  var MenuPlacer = /*#__PURE__*/function (_Component) {
    _inherits(MenuPlacer, _Component);

    var _super = _createSuper(MenuPlacer);

    function MenuPlacer() {
      var _this;

      _classCallCheck(this, MenuPlacer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        maxHeight: _this.props.maxMenuHeight,
        placement: null
      };
      _this.context = void 0;

      _this.getPlacement = function (ref) {
        var _this$props = _this.props,
            minMenuHeight = _this$props.minMenuHeight,
            maxMenuHeight = _this$props.maxMenuHeight,
            menuPlacement = _this$props.menuPlacement,
            menuPosition = _this$props.menuPosition,
            menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
            theme = _this$props.theme;
        if (!ref) return; // DO NOT scroll if position is fixed

        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
          maxHeight: maxMenuHeight,
          menuEl: ref,
          minHeight: minMenuHeight,
          placement: menuPlacement,
          shouldScroll: shouldScroll,
          isFixedPosition: isFixedPosition,
          theme: theme
        });
        var getPortalPlacement = _this.context.getPortalPlacement;
        if (getPortalPlacement) getPortalPlacement(state);

        _this.setState(state);
      };

      _this.getUpdatedProps = function () {
        var menuPlacement = _this.props.menuPlacement;
        var placement = _this.state.placement || coercePlacement(menuPlacement);
        return _objectSpread2(_objectSpread2({}, _this.props), {}, {
          placement: placement,
          maxHeight: _this.state.maxHeight
        });
      };

      return _this;
    }

    _createClass(MenuPlacer, [{
      key: "render",
      value: function render() {
        var children = this.props.children;
        return children({
          ref: this.getPlacement,
          placerProps: this.getUpdatedProps()
        });
      }
    }]);

    return MenuPlacer;
  }(React.Component);
  MenuPlacer.contextType = PortalPlacementContext;

  var Menu = function Menu(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerRef = props.innerRef,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('menu', props),
      className: cx({
        menu: true
      }, className),
      ref: innerRef
    }, innerProps), children);
  };
  // Menu List
  // ==============================

  var menuListCSS = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight,
        baseUnit = _ref4.theme.spacing.baseUnit;
    return {
      maxHeight: maxHeight,
      overflowY: 'auto',
      paddingBottom: baseUnit,
      paddingTop: baseUnit,
      position: 'relative',
      // required for offset[Height, Top] > keyboard scroll
      WebkitOverflowScrolling: 'touch'
    };
  };
  var MenuList = function MenuList(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        innerRef = props.innerRef,
        isMulti = props.isMulti;
    return jsx("div", _extends({
      css: getStyles('menuList', props),
      className: cx({
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    }, innerProps), children);
  }; // ==============================
  // Menu Notices
  // ==============================

  var noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme,
        baseUnit = _ref5$theme.spacing.baseUnit,
        colors = _ref5$theme.colors;
    return {
      color: colors.neutral40,
      padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
      textAlign: 'center'
    };
  };

  var noOptionsMessageCSS = noticeCSS;
  var loadingMessageCSS = noticeCSS;
  var NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('noOptionsMessage', props),
      className: cx({
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps), children);
  };
  NoOptionsMessage.defaultProps = {
    children: 'No options'
  };
  var LoadingMessage = function LoadingMessage(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('loadingMessage', props),
      className: cx({
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps), children);
  };
  LoadingMessage.defaultProps = {
    children: 'Loading...'
  }; // ==============================
  // Menu Portal
  // ==============================

  var menuPortalCSS = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect,
        offset = _ref6.offset,
        position = _ref6.position;
    return {
      left: rect.left,
      position: position,
      top: offset,
      width: rect.width,
      zIndex: 1
    };
  };
  var MenuPortal = /*#__PURE__*/function (_Component2) {
    _inherits(MenuPortal, _Component2);

    var _super2 = _createSuper(MenuPortal);

    function MenuPortal() {
      var _this2;

      _classCallCheck(this, MenuPortal);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));
      _this2.state = {
        placement: null
      };

      _this2.getPortalPlacement = function (_ref7) {
        var placement = _ref7.placement;
        var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

        if (placement !== initialPlacement) {
          _this2.setState({
            placement: placement
          });
        }
      };

      return _this2;
    }

    _createClass(MenuPortal, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            appendTo = _this$props2.appendTo,
            children = _this$props2.children,
            className = _this$props2.className,
            controlElement = _this$props2.controlElement,
            cx = _this$props2.cx,
            innerProps = _this$props2.innerProps,
            menuPlacement = _this$props2.menuPlacement,
            position = _this$props2.menuPosition,
            getStyles = _this$props2.getStyles;
        var isFixed = position === 'fixed'; // bail early if required elements aren't present

        if (!appendTo && !isFixed || !controlElement) {
          return null;
        }

        var placement = this.state.placement || coercePlacement(menuPlacement);
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = isFixed ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        var state = {
          offset: offset,
          position: position,
          rect: rect
        }; // same wrapper element whether fixed or portalled

        var menuWrapper = jsx("div", _extends({
          css: getStyles('menuPortal', state),
          className: cx({
            'menu-portal': true
          }, className)
        }, innerProps), children);
        return jsx(PortalPlacementContext.Provider, {
          value: {
            getPortalPlacement: this.getPortalPlacement
          }
        }, appendTo ? /*#__PURE__*/reactDom.createPortal(menuWrapper, appendTo) : menuWrapper);
      }
    }]);

    return MenuPortal;
  }(React.Component);

  var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        isRtl = _ref.isRtl;
    return {
      label: 'container',
      direction: isRtl ? 'rtl' : undefined,
      pointerEvents: isDisabled ? 'none' : undefined,
      // cancel mouse events when disabled
      position: 'relative'
    };
  };
  var SelectContainer = function SelectContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isDisabled = props.isDisabled,
        isRtl = props.isRtl;
    return jsx("div", _extends({
      css: getStyles('container', props),
      className: cx({
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps), children);
  }; // ==============================
  // Value Container
  // ==============================

  var valueContainerCSS = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing,
        isMulti = _ref2.isMulti,
        hasValue = _ref2.hasValue;
    return {
      alignItems: 'center',
      display: isMulti && hasValue ? 'flex' : 'grid',
      flex: 1,
      flexWrap: 'wrap',
      padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
      WebkitOverflowScrolling: 'touch',
      position: 'relative',
      overflow: 'hidden'
    };
  };
  var ValueContainer = function ValueContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        innerProps = props.innerProps,
        isMulti = props.isMulti,
        getStyles = props.getStyles,
        hasValue = props.hasValue;
    return jsx("div", _extends({
      css: getStyles('valueContainer', props),
      className: cx({
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
      }, className)
    }, innerProps), children);
  }; // ==============================
  // Indicator Container
  // ==============================

  var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'flex',
      flexShrink: 0
    };
  };
  var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        innerProps = props.innerProps,
        getStyles = props.getStyles;
    return jsx("div", _extends({
      css: getStyles('indicatorsContainer', props),
      className: cx({
        indicators: true
      }, className)
    }, innerProps), children);
  };

  var _templateObject$6;

  var _excluded$2 = ["size"];

  function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

  var _ref2 = process.env.NODE_ENV === "production" ? {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
  } : {
    name: "tj5bde-Svg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  };

  // ==============================
  // Dropdown & Clear Icons
  // ==============================
  var Svg = function Svg(_ref) {
    var size = _ref.size,
        props = _objectWithoutProperties(_ref, _excluded$2);

    return jsx("svg", _extends({
      height: size,
      width: size,
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false",
      css: _ref2
    }, props));
  };

  var CrossIcon = function CrossIcon(props) {
    return jsx(Svg, _extends({
      size: 20
    }, props), jsx("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
  };
  var DownChevron = function DownChevron(props) {
    return jsx(Svg, _extends({
      size: 20
    }, props), jsx("path", {
      d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
  }; // ==============================
  // Dropdown & Clear Buttons
  // ==============================

  var baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused,
        _ref3$theme = _ref3.theme,
        baseUnit = _ref3$theme.spacing.baseUnit,
        colors = _ref3$theme.colors;
    return {
      label: 'indicatorContainer',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      ':hover': {
        color: isFocused ? colors.neutral80 : colors.neutral40
      }
    };
  };

  var dropdownIndicatorCSS = baseCSS;
  var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('dropdownIndicator', props),
      className: cx({
        indicator: true,
        'dropdown-indicator': true
      }, className)
    }, innerProps), children || jsx(DownChevron, null));
  };
  var clearIndicatorCSS = baseCSS;
  var ClearIndicator = function ClearIndicator(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('clearIndicator', props),
      className: cx({
        indicator: true,
        'clear-indicator': true
      }, className)
    }, innerProps), children || jsx(CrossIcon, null));
  }; // ==============================
  // Separator
  // ==============================

  var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled,
        _ref4$theme = _ref4.theme,
        baseUnit = _ref4$theme.spacing.baseUnit,
        colors = _ref4$theme.colors;
    return {
      label: 'indicatorSeparator',
      alignSelf: 'stretch',
      backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
      marginBottom: baseUnit * 2,
      marginTop: baseUnit * 2,
      width: 1
    };
  };
  var IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("span", _extends({}, innerProps, {
      css: getStyles('indicatorSeparator', props),
      className: cx({
        'indicator-separator': true
      }, className)
    }));
  }; // ==============================
  // Loading
  // ==============================

  var loadingDotAnimations = keyframes(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
  var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused,
        size = _ref5.size,
        _ref5$theme = _ref5.theme,
        colors = _ref5$theme.colors,
        baseUnit = _ref5$theme.spacing.baseUnit;
    return {
      label: 'loadingIndicator',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      alignSelf: 'center',
      fontSize: size,
      lineHeight: 1,
      marginRight: size,
      textAlign: 'center',
      verticalAlign: 'middle'
    };
  };

  var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay,
        offset = _ref6.offset;
    return jsx("span", {
      css: /*#__PURE__*/css({
        animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
        backgroundColor: 'currentColor',
        borderRadius: '1em',
        display: 'inline-block',
        marginLeft: offset ? '1em' : undefined,
        height: '1em',
        verticalAlign: 'top',
        width: '1em'
      }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
  };

  var LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isRtl = props.isRtl;
    return jsx("div", _extends({
      css: getStyles('loadingIndicator', props),
      className: cx({
        indicator: true,
        'loading-indicator': true
      }, className)
    }, innerProps), jsx(LoadingDot, {
      delay: 0,
      offset: isRtl
    }), jsx(LoadingDot, {
      delay: 160,
      offset: true
    }), jsx(LoadingDot, {
      delay: 320,
      offset: !isRtl
    }));
  };
  LoadingIndicator.defaultProps = {
    size: 4
  };

  var css$1 = function css(_ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        _ref$theme = _ref.theme,
        colors = _ref$theme.colors,
        borderRadius = _ref$theme.borderRadius,
        spacing = _ref$theme.spacing;
    return {
      label: 'control',
      alignItems: 'center',
      backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
      borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
      borderRadius: borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: spacing.controlHeight,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      '&:hover': {
        borderColor: isFocused ? colors.primary : colors.neutral30
      }
    };
  };

  var Control = function Control(props) {
    var children = props.children,
        cx = props.cx,
        getStyles = props.getStyles,
        className = props.className,
        isDisabled = props.isDisabled,
        isFocused = props.isFocused,
        innerRef = props.innerRef,
        innerProps = props.innerProps,
        menuIsOpen = props.menuIsOpen;
    return jsx("div", _extends({
      ref: innerRef,
      css: getStyles('control', props),
      className: cx({
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
      }, className)
    }, innerProps), children);
  };

  var _excluded$1 = ["data"];
  var groupCSS = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
      paddingBottom: spacing.baseUnit * 2,
      paddingTop: spacing.baseUnit * 2
    };
  };

  var Group = function Group(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        Heading = props.Heading,
        headingProps = props.headingProps,
        innerProps = props.innerProps,
        label = props.label,
        theme = props.theme,
        selectProps = props.selectProps;
    return jsx("div", _extends({
      css: getStyles('group', props),
      className: cx({
        group: true
      }, className)
    }, innerProps), jsx(Heading, _extends({}, headingProps, {
      selectProps: selectProps,
      theme: theme,
      getStyles: getStyles,
      cx: cx
    }), label), jsx("div", null, children));
  };

  var groupHeadingCSS = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      label: 'group',
      color: '#999',
      cursor: 'default',
      display: 'block',
      fontSize: '75%',
      fontWeight: 500,
      marginBottom: '0.25em',
      paddingLeft: spacing.baseUnit * 3,
      paddingRight: spacing.baseUnit * 3,
      textTransform: 'uppercase'
    };
  };
  var GroupHeading = function GroupHeading(props) {
    var getStyles = props.getStyles,
        cx = props.cx,
        className = props.className;

    var _cleanCommonProps = cleanCommonProps(props);
        _cleanCommonProps.data;
        var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1);

    return jsx("div", _extends({
      css: getStyles('groupHeading', props),
      className: cx({
        'group-heading': true
      }, className)
    }, innerProps));
  };

  var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
  var inputCSS = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return _objectSpread2({
      margin: spacing.baseUnit / 2,
      paddingBottom: spacing.baseUnit / 2,
      paddingTop: spacing.baseUnit / 2,
      visibility: isDisabled ? 'hidden' : 'visible',
      color: colors.neutral80
    }, containerStyle);
  };
  var spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
  };
  var containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': _objectSpread2({
      content: 'attr(data-value) " "',
      visibility: 'hidden',
      whiteSpace: 'pre'
    }, spacingStyle)
  };

  var inputStyle = function inputStyle(isHidden) {
    return _objectSpread2({
      label: 'input',
      color: 'inherit',
      background: 0,
      opacity: isHidden ? 0 : 1,
      width: '100%'
    }, spacingStyle);
  };

  var Input = function Input(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        value = props.value;

    var _cleanCommonProps = cleanCommonProps(props),
        innerRef = _cleanCommonProps.innerRef,
        isDisabled = _cleanCommonProps.isDisabled,
        isHidden = _cleanCommonProps.isHidden,
        inputClassName = _cleanCommonProps.inputClassName,
        innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded);

    return jsx("div", {
      className: cx({
        'input-container': true
      }, className),
      css: getStyles('input', props),
      "data-value": value || ''
    }, jsx("input", _extends({
      className: cx({
        input: true
      }, inputClassName),
      ref: innerRef,
      style: inputStyle(isHidden),
      disabled: isDisabled
    }, innerProps)));
  };

  var multiValueCSS = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        borderRadius = _ref$theme.borderRadius,
        colors = _ref$theme.colors;
    return {
      label: 'multiValue',
      backgroundColor: colors.neutral10,
      borderRadius: borderRadius / 2,
      display: 'flex',
      margin: spacing.baseUnit / 2,
      minWidth: 0 // resolves flex/text-overflow bug

    };
  };
  var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme,
        borderRadius = _ref2$theme.borderRadius,
        colors = _ref2$theme.colors,
        cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
      borderRadius: borderRadius / 2,
      color: colors.neutral80,
      fontSize: '85%',
      overflow: 'hidden',
      padding: 3,
      paddingLeft: 6,
      textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
      whiteSpace: 'nowrap'
    };
  };
  var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme,
        spacing = _ref3$theme.spacing,
        borderRadius = _ref3$theme.borderRadius,
        colors = _ref3$theme.colors,
        isFocused = _ref3.isFocused;
    return {
      alignItems: 'center',
      borderRadius: borderRadius / 2,
      backgroundColor: isFocused ? colors.dangerLight : undefined,
      display: 'flex',
      paddingLeft: spacing.baseUnit,
      paddingRight: spacing.baseUnit,
      ':hover': {
        backgroundColor: colors.dangerLight,
        color: colors.danger
      }
    };
  };
  var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children,
        innerProps = _ref4.innerProps;
    return jsx("div", innerProps, children);
  };
  var MultiValueContainer = MultiValueGeneric;
  var MultiValueLabel = MultiValueGeneric;
  function MultiValueRemove(_ref5) {
    var children = _ref5.children,
        innerProps = _ref5.innerProps;
    return jsx("div", _extends({
      role: "button"
    }, innerProps), children || jsx(CrossIcon, {
      size: 14
    }));
  }

  var MultiValue = function MultiValue(props) {
    var children = props.children,
        className = props.className,
        components = props.components,
        cx = props.cx,
        data = props.data,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isDisabled = props.isDisabled,
        removeProps = props.removeProps,
        selectProps = props.selectProps;
    var Container = components.Container,
        Label = components.Label,
        Remove = components.Remove;
    return jsx(ClassNames, null, function (_ref6) {
      var css = _ref6.css,
          emotionCx = _ref6.cx;
      return jsx(Container, {
        data: data,
        innerProps: _objectSpread2({
          className: emotionCx(css(getStyles('multiValue', props)), cx({
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
          }, className))
        }, innerProps),
        selectProps: selectProps
      }, jsx(Label, {
        data: data,
        innerProps: {
          className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
            'multi-value__label': true
          }, className))
        },
        selectProps: selectProps
      }, children), jsx(Remove, {
        data: data,
        innerProps: _objectSpread2({
          className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
            'multi-value__remove': true
          }, className)),
          'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
      }));
    });
  };

  var optionCSS = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'option',
      backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
      color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
      cursor: 'default',
      display: 'block',
      fontSize: 'inherit',
      padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
      width: '100%',
      userSelect: 'none',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      // provide some affordance on touch devices
      ':active': {
        backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
      }
    };
  };

  var Option = function Option(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isDisabled = props.isDisabled,
        isFocused = props.isFocused,
        isSelected = props.isSelected,
        innerRef = props.innerRef,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('option', props),
      className: cx({
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className),
      ref: innerRef,
      "aria-disabled": isDisabled
    }, innerProps), children);
  };

  var placeholderCSS = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'placeholder',
      color: colors.neutral50,
      gridArea: '1 / 1 / 2 / 3',
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2
    };
  };

  var Placeholder = function Placeholder(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('placeholder', props),
      className: cx({
        placeholder: true
      }, className)
    }, innerProps), children);
  };

  var css$2 = function css(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'singleValue',
      color: isDisabled ? colors.neutral40 : colors.neutral80,
      gridArea: '1 / 1 / 2 / 3',
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    };
  };

  var SingleValue = function SingleValue(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isDisabled = props.isDisabled,
        innerProps = props.innerProps;
    return jsx("div", _extends({
      css: getStyles('singleValue', props),
      className: cx({
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps), children);
  };

  var components = {
    ClearIndicator: ClearIndicator,
    Control: Control,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option,
    Placeholder: Placeholder,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
  };
  var defaultComponents = function defaultComponents(props) {
    return _objectSpread2(_objectSpread2({}, components), props.components);
  };

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  var safeIsNaN = Number.isNaN ||
      function ponyfill(value) {
          return typeof value === 'number' && value !== value;
      };
  function isEqual(first, second) {
      if (first === second) {
          return true;
      }
      if (safeIsNaN(first) && safeIsNaN(second)) {
          return true;
      }
      return false;
  }
  function areInputsEqual(newInputs, lastInputs) {
      if (newInputs.length !== lastInputs.length) {
          return false;
      }
      for (var i = 0; i < newInputs.length; i++) {
          if (!isEqual(newInputs[i], lastInputs[i])) {
              return false;
          }
      }
      return true;
  }

  function memoizeOne(resultFn, isEqual) {
      if (isEqual === void 0) { isEqual = areInputsEqual; }
      var lastThis;
      var lastArgs = [];
      var lastResult;
      var calledOnce = false;
      function memoized() {
          var newArgs = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              newArgs[_i] = arguments[_i];
          }
          if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
              return lastResult;
          }
          lastResult = resultFn.apply(this, newArgs);
          calledOnce = true;
          lastThis = this;
          lastArgs = newArgs;
          return lastResult;
      }
      return memoized;
  }

  function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

  var _ref = process.env.NODE_ENV === "production" ? {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
  } : {
    name: "1f43avz-a11yText-A11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
  };

  var A11yText = function A11yText(props) {
    return jsx("span", _extends({
      css: _ref
    }, props));
  };

  var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
      var isSearchable = props.isSearchable,
          isMulti = props.isMulti,
          isDisabled = props.isDisabled,
          tabSelectsValue = props.tabSelectsValue,
          context = props.context;

      switch (context) {
        case 'menu':
          return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

        case 'input':
          return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

        case 'value':
          return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';

        default:
          return '';
      }
    },
    onChange: function onChange(props) {
      var action = props.action,
          _props$label = props.label,
          label = _props$label === void 0 ? '' : _props$label,
          labels = props.labels,
          isDisabled = props.isDisabled;

      switch (action) {
        case 'deselect-option':
        case 'pop-value':
        case 'remove-value':
          return "option ".concat(label, ", deselected.");

        case 'clear':
          return 'All selected options have been cleared.';

        case 'initial-input-focus':
          return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");

        case 'select-option':
          return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

        default:
          return '';
      }
    },
    onFocus: function onFocus(props) {
      var context = props.context,
          focused = props.focused,
          options = props.options,
          _props$label2 = props.label,
          label = _props$label2 === void 0 ? '' : _props$label2,
          selectValue = props.selectValue,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected;

      var getArrayIndex = function getArrayIndex(arr, item) {
        return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
      };

      if (context === 'value' && selectValue) {
        return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
      }

      if (context === 'menu') {
        var disabled = isDisabled ? ' disabled' : '';
        var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
        return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
      }

      return '';
    },
    onFilter: function onFilter(props) {
      var inputValue = props.inputValue,
          resultsMessage = props.resultsMessage;
      return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
  };

  var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection,
        focusedOption = props.focusedOption,
        focusedValue = props.focusedValue,
        focusableOptions = props.focusableOptions,
        isFocused = props.isFocused,
        selectValue = props.selectValue,
        selectProps = props.selectProps,
        id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages,
        getOptionLabel = selectProps.getOptionLabel,
        inputValue = selectProps.inputValue,
        isMulti = selectProps.isMulti,
        isOptionDisabled = selectProps.isOptionDisabled,
        isSearchable = selectProps.isSearchable,
        menuIsOpen = selectProps.menuIsOpen,
        options = selectProps.options,
        screenReaderStatus = selectProps.screenReaderStatus,
        tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

    var messages = React.useMemo(function () {
      return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [ariaLiveMessages]); // Update aria live selected option when prop changes

    var ariaSelected = React.useMemo(function () {
      var message = '';

      if (ariaSelection && messages.onChange) {
        var option = ariaSelection.option,
            selectedOptions = ariaSelection.options,
            removedValue = ariaSelection.removedValue,
            removedValues = ariaSelection.removedValues,
            value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

        var asOption = function asOption(val) {
          return !Array.isArray(val) ? val : null;
        }; // If there is just one item from the action then get its label


        var selected = removedValue || option || asOption(value);
        var label = selected ? getOptionLabel(selected) : ''; // If there are multiple items from the action then return an array of labels

        var multiSelected = selectedOptions || removedValues || undefined;
        var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];

        var onChangeProps = _objectSpread2({
          // multiSelected items are usually items that have already been selected
          // or set by the user as a default value so we assume they are not disabled
          isDisabled: selected && isOptionDisabled(selected, selectValue),
          label: label,
          labels: labels
        }, ariaSelection);

        message = messages.onChange(onChangeProps);
      }

      return message;
    }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
    var ariaFocused = React.useMemo(function () {
      var focusMsg = '';
      var focused = focusedOption || focusedValue;
      var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

      if (focused && messages.onFocus) {
        var onFocusProps = {
          focused: focused,
          label: getOptionLabel(focused),
          isDisabled: isOptionDisabled(focused, selectValue),
          isSelected: isSelected,
          options: options,
          context: focused === focusedOption ? 'menu' : 'value',
          selectValue: selectValue
        };
        focusMsg = messages.onFocus(onFocusProps);
      }

      return focusMsg;
    }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
    var ariaResults = React.useMemo(function () {
      var resultsMsg = '';

      if (menuIsOpen && options.length && messages.onFilter) {
        var resultsMessage = screenReaderStatus({
          count: focusableOptions.length
        });
        resultsMsg = messages.onFilter({
          inputValue: inputValue,
          resultsMessage: resultsMessage
        });
      }

      return resultsMsg;
    }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
    var ariaGuidance = React.useMemo(function () {
      var guidanceMsg = '';

      if (messages.guidance) {
        var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
        guidanceMsg = messages.guidance({
          'aria-label': ariaLabel,
          context: context,
          isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
          isMulti: isMulti,
          isSearchable: isSearchable,
          tabSelectsValue: tabSelectsValue
        });
      }

      return guidanceMsg;
    }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = jsx(React__default['default'].Fragment, null, jsx("span", {
      id: "aria-selection"
    }, ariaSelected), jsx("span", {
      id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return jsx(React__default['default'].Fragment, null, jsx(A11yText, {
      id: id
    }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
      "aria-live": ariaLive,
      "aria-atomic": "false",
      "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
  };

  var diacritics = [{
    base: 'A',
    letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
  }, {
    base: 'AA',
    letters: "\uA732"
  }, {
    base: 'AE',
    letters: "\xC6\u01FC\u01E2"
  }, {
    base: 'AO',
    letters: "\uA734"
  }, {
    base: 'AU',
    letters: "\uA736"
  }, {
    base: 'AV',
    letters: "\uA738\uA73A"
  }, {
    base: 'AY',
    letters: "\uA73C"
  }, {
    base: 'B',
    letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
  }, {
    base: 'C',
    letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
  }, {
    base: 'D',
    letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
  }, {
    base: 'DZ',
    letters: "\u01F1\u01C4"
  }, {
    base: 'Dz',
    letters: "\u01F2\u01C5"
  }, {
    base: 'E',
    letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
  }, {
    base: 'F',
    letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
  }, {
    base: 'G',
    letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
  }, {
    base: 'H',
    letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
  }, {
    base: 'I',
    letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
  }, {
    base: 'J',
    letters: "J\u24BF\uFF2A\u0134\u0248"
  }, {
    base: 'K',
    letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
  }, {
    base: 'L',
    letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
  }, {
    base: 'LJ',
    letters: "\u01C7"
  }, {
    base: 'Lj',
    letters: "\u01C8"
  }, {
    base: 'M',
    letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
  }, {
    base: 'N',
    letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
  }, {
    base: 'NJ',
    letters: "\u01CA"
  }, {
    base: 'Nj',
    letters: "\u01CB"
  }, {
    base: 'O',
    letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
  }, {
    base: 'OI',
    letters: "\u01A2"
  }, {
    base: 'OO',
    letters: "\uA74E"
  }, {
    base: 'OU',
    letters: "\u0222"
  }, {
    base: 'P',
    letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
  }, {
    base: 'Q',
    letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
  }, {
    base: 'R',
    letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
  }, {
    base: 'S',
    letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
  }, {
    base: 'T',
    letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
  }, {
    base: 'TZ',
    letters: "\uA728"
  }, {
    base: 'U',
    letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
  }, {
    base: 'V',
    letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
  }, {
    base: 'VY',
    letters: "\uA760"
  }, {
    base: 'W',
    letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
  }, {
    base: 'X',
    letters: "X\u24CD\uFF38\u1E8A\u1E8C"
  }, {
    base: 'Y',
    letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
  }, {
    base: 'Z',
    letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
  }, {
    base: 'a',
    letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
  }, {
    base: 'aa',
    letters: "\uA733"
  }, {
    base: 'ae',
    letters: "\xE6\u01FD\u01E3"
  }, {
    base: 'ao',
    letters: "\uA735"
  }, {
    base: 'au',
    letters: "\uA737"
  }, {
    base: 'av',
    letters: "\uA739\uA73B"
  }, {
    base: 'ay',
    letters: "\uA73D"
  }, {
    base: 'b',
    letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
  }, {
    base: 'c',
    letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
  }, {
    base: 'd',
    letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
  }, {
    base: 'dz',
    letters: "\u01F3\u01C6"
  }, {
    base: 'e',
    letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
  }, {
    base: 'f',
    letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
  }, {
    base: 'g',
    letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
  }, {
    base: 'h',
    letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
  }, {
    base: 'hv',
    letters: "\u0195"
  }, {
    base: 'i',
    letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
  }, {
    base: 'j',
    letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
  }, {
    base: 'k',
    letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
  }, {
    base: 'l',
    letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
  }, {
    base: 'lj',
    letters: "\u01C9"
  }, {
    base: 'm',
    letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
  }, {
    base: 'n',
    letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
  }, {
    base: 'nj',
    letters: "\u01CC"
  }, {
    base: 'o',
    letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
  }, {
    base: 'oi',
    letters: "\u01A3"
  }, {
    base: 'ou',
    letters: "\u0223"
  }, {
    base: 'oo',
    letters: "\uA74F"
  }, {
    base: 'p',
    letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
  }, {
    base: 'q',
    letters: "q\u24E0\uFF51\u024B\uA757\uA759"
  }, {
    base: 'r',
    letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
  }, {
    base: 's',
    letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
  }, {
    base: 't',
    letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
  }, {
    base: 'tz',
    letters: "\uA729"
  }, {
    base: 'u',
    letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
  }, {
    base: 'v',
    letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
  }, {
    base: 'vy',
    letters: "\uA761"
  }, {
    base: 'w',
    letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
  }, {
    base: 'x',
    letters: "x\u24E7\uFF58\u1E8B\u1E8D"
  }, {
    base: 'y',
    letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
  }, {
    base: 'z',
    letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
  }];
  var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
    return d.letters;
  }).join('') + ']', 'g');
  var diacriticToBase = {};

  for (var i = 0; i < diacritics.length; i++) {
    var diacritic = diacritics[i];

    for (var j = 0; j < diacritic.letters.length; j++) {
      diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
  }

  var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function (match) {
      return diacriticToBase[match];
    });
  };

  var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);

  var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
  };

  var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
  };

  var createFilter = function createFilter(config) {
    return function (option, rawInput) {
      // eslint-disable-next-line no-underscore-dangle
      if (option.data.__isNew__) return true;

      var _ignoreCase$ignoreAcc = _objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
          ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
          ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
          stringify = _ignoreCase$ignoreAcc.stringify,
          trim = _ignoreCase$ignoreAcc.trim,
          matchFrom = _ignoreCase$ignoreAcc.matchFrom;

      var input = trim ? trimString(rawInput) : rawInput;
      var candidate = trim ? trimString(stringify(option)) : stringify(option);

      if (ignoreCase) {
        input = input.toLowerCase();
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        input = memoizedStripDiacriticsForInput(input);
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
  };

  var _excluded$4 = ["innerRef"];
  function DummyInput(_ref) {
    var innerRef = _ref.innerRef,
        props = _objectWithoutProperties(_ref, _excluded$4);

    return jsx("input", _extends({
      ref: innerRef
    }, props, {
      css: /*#__PURE__*/css({
        label: 'dummyInput',
        // get rid of any default styles
        background: 0,
        border: 0,
        // important! this hides the flashing cursor
        caretColor: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        outline: 0,
        padding: 0,
        // important! without `width` browsers won't allow focus
        width: 1,
        // remove cursor on desktop
        color: 'transparent',
        // remove cursor on mobile whilst maintaining "scroll into view" behaviour
        left: -100,
        opacity: 0,
        position: 'relative',
        transform: 'scale(.01)'
      }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNNIiwiZmlsZSI6IkR1bW15SW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4ucHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
    }));
  }

  var cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
  };

  function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled,
        onBottomArrive = _ref.onBottomArrive,
        onBottomLeave = _ref.onBottomLeave,
        onTopArrive = _ref.onTopArrive,
        onTopLeave = _ref.onTopLeave;
    var isBottom = React.useRef(false);
    var isTop = React.useRef(false);
    var touchStart = React.useRef(0);
    var scrollTarget = React.useRef(null);
    var handleEventDelta = React.useCallback(function (event, delta) {
      if (scrollTarget.current === null) return;
      var _scrollTarget$current = scrollTarget.current,
          scrollTop = _scrollTarget$current.scrollTop,
          scrollHeight = _scrollTarget$current.scrollHeight,
          clientHeight = _scrollTarget$current.clientHeight;
      var target = scrollTarget.current;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && isBottom.current) {
        if (onBottomLeave) onBottomLeave(event);
        isBottom.current = false;
      }

      if (isDeltaPositive && isTop.current) {
        if (onTopLeave) onTopLeave(event);
        isTop.current = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !isBottom.current) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        isBottom.current = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !isTop.current) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        isTop.current = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        cancelScroll(event);
      }
    }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
    var onWheel = React.useCallback(function (event) {
      handleEventDelta(event, event.deltaY);
    }, [handleEventDelta]);
    var onTouchStart = React.useCallback(function (event) {
      // set touch start so we can calculate touchmove delta
      touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = React.useCallback(function (event) {
      var deltaY = touchStart.current - event.changedTouches[0].clientY;
      handleEventDelta(event, deltaY);
    }, [handleEventDelta]);
    var startListening = React.useCallback(function (el) {
      // bail early if no element is available to attach to
      if (!el) return;
      var notPassive = supportsPassiveEvents ? {
        passive: false
      } : false;
      el.addEventListener('wheel', onWheel, notPassive);
      el.addEventListener('touchstart', onTouchStart, notPassive);
      el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [onTouchMove, onTouchStart, onWheel]);
    var stopListening = React.useCallback(function (el) {
      // bail early if no element is available to detach from
      if (!el) return;
      el.removeEventListener('wheel', onWheel, false);
      el.removeEventListener('touchstart', onTouchStart, false);
      el.removeEventListener('touchmove', onTouchMove, false);
    }, [onTouchMove, onTouchStart, onWheel]);
    React.useEffect(function () {
      if (!isEnabled) return;
      var element = scrollTarget.current;
      startListening(element);
      return function () {
        stopListening(element);
      };
    }, [isEnabled, startListening, stopListening]);
    return function (element) {
      scrollTarget.current = element;
    };
  }

  var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
  var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
  };

  function preventTouchMove(e) {
    e.preventDefault();
  }

  function allowTouchMove(e) {
    e.stopPropagation();
  }

  function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;

    if (top === 0) {
      this.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      this.scrollTop = top - 1;
    }
  } // `ontouchstart` check works on most browsers
  // `maxTouchPoints` works on IE10/11 and Surface


  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }

  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  var activeScrollLocks = 0;
  var listenerOptions = {
    capture: false,
    passive: false
  };
  function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled,
        _ref$accountForScroll = _ref.accountForScrollbars,
        accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = React.useRef({});
    var scrollTarget = React.useRef(null);
    var addScrollLock = React.useCallback(function (touchScrollTarget) {
      if (!canUseDOM) return;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          originalStyles.current[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }, [accountForScrollbars]);
    var removeScrollLock = React.useCallback(function (touchScrollTarget) {
      if (!canUseDOM) return;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = originalStyles.current[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
        }
      }
    }, [accountForScrollbars]);
    React.useEffect(function () {
      if (!isEnabled) return;
      var element = scrollTarget.current;
      addScrollLock(element);
      return function () {
        removeScrollLock(element);
      };
    }, [isEnabled, addScrollLock, removeScrollLock]);
    return function (element) {
      scrollTarget.current = element;
    };
  }

  function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

  var blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
  };

  var _ref2$1 = process.env.NODE_ENV === "production" ? {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
  } : {
    name: "bp8cua-ScrollManager",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
  };

  function ScrollManager(_ref) {
    var children = _ref.children,
        lockEnabled = _ref.lockEnabled,
        _ref$captureEnabled = _ref.captureEnabled,
        captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
        onBottomArrive = _ref.onBottomArrive,
        onBottomLeave = _ref.onBottomLeave,
        onTopArrive = _ref.onTopArrive,
        onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
      isEnabled: captureEnabled,
      onBottomArrive: onBottomArrive,
      onBottomLeave: onBottomLeave,
      onTopArrive: onTopArrive,
      onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
      isEnabled: lockEnabled
    });

    var targetRef = function targetRef(element) {
      setScrollCaptureTarget(element);
      setScrollLockTarget(element);
    };

    return jsx(React__default['default'].Fragment, null, lockEnabled && jsx("div", {
      onClick: blurSelectInput,
      css: _ref2$1
    }), children(targetRef));
  }

  var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
  };
  var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
  };
  var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
  };
  var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
  };

  var defaultStyles = {
    clearIndicator: clearIndicatorCSS,
    container: containerCSS,
    control: css$1,
    dropdownIndicator: dropdownIndicatorCSS,
    group: groupCSS,
    groupHeading: groupHeadingCSS,
    indicatorsContainer: indicatorsContainerCSS,
    indicatorSeparator: indicatorSeparatorCSS,
    input: inputCSS,
    loadingIndicator: loadingIndicatorCSS,
    loadingMessage: loadingMessageCSS,
    menu: menuCSS,
    menuList: menuListCSS,
    menuPortal: menuPortalCSS,
    multiValue: multiValueCSS,
    multiValueLabel: multiValueLabelCSS,
    multiValueRemove: multiValueRemoveCSS,
    noOptionsMessage: noOptionsMessageCSS,
    option: optionCSS,
    placeholder: placeholderCSS,
    singleValue: css$2,
    valueContainer: valueContainerCSS
  }; // Merge Utility

  var colors$1 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
  };
  var borderRadius = 4; // Used to calculate consistent margin/padding on elements

  var baseUnit = 4; // The minimum height of the control

  var controlHeight = 38; // The amount of space between the control and menu */

  var menuGutter = baseUnit * 2;
  var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
  };
  var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors$1,
    spacing: spacing
  };

  var defaultProps$2 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: isTouchCapable(),
    captureMenuScroll: !isTouchCapable(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
      return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
      return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
      var count = _ref.count;
      return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true
  };

  function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);

    var isSelected = _isOptionSelected(props, option, selectValue);

    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
      type: 'option',
      data: option,
      isDisabled: isDisabled,
      isSelected: isSelected,
      label: label,
      value: value,
      index: index
    };
  }

  function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function (groupOrOption, groupOrOptionIndex) {
      if ('options' in groupOrOption) {
        var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
          return toCategorizedOption(props, option, selectValue, optionIndex);
        }).filter(function (categorizedOption) {
          return isFocusable(props, categorizedOption);
        });
        return categorizedOptions.length > 0 ? {
          type: 'group',
          data: groupOrOption,
          options: categorizedOptions,
          index: groupOrOptionIndex
        } : undefined;
      }

      var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
      return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter(notNullish);
  }

  function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
      if (categorizedOption.type === 'group') {
        optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
          return option.data;
        })));
      } else {
        optionsAccumulator.push(categorizedOption.data);
      }

      return optionsAccumulator;
    }, []);
  }

  function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
  }

  function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue,
        inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data,
        isSelected = categorizedOption.isSelected,
        label = categorizedOption.label,
        value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
      label: label,
      value: value,
      data: data
    }, inputValue);
  }

  function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue,
        lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

    if (lastFocusedIndex > -1) {
      var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

      if (nextFocusedIndex > -1) {
        // the focused value is still in the selectValue, return it
        return focusedValue;
      } else if (lastFocusedIndex < nextSelectValue.length) {
        // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
      }
    }

    return null;
  }

  function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
  }

  var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
  };

  var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
  };

  function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
  }

  function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;

    if (typeof props.isOptionSelected === 'function') {
      return props.isOptionSelected(option, selectValue);
    }

    var candidate = getOptionValue(props, option);
    return selectValue.some(function (i) {
      return getOptionValue(props, i) === candidate;
    });
  }

  function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
  }

  var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions,
        isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  var instanceId = 1;

  var Select = /*#__PURE__*/function (_Component) {
    _inherits(Select, _Component);

    var _super = _createSuper(Select);

    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
      var _this;

      _classCallCheck(this, Select);

      _this = _super.call(this, _props);
      _this.state = {
        ariaSelection: null,
        focusedOption: null,
        focusedValue: null,
        inputIsHidden: false,
        isFocused: false,
        selectValue: [],
        clearFocusValueOnUpdate: false,
        prevWasFocused: false,
        inputIsHiddenAfterUpdate: undefined,
        prevProps: undefined
      };
      _this.blockOptionHover = false;
      _this.isComposing = false;
      _this.commonProps = void 0;
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
      _this.instancePrefix = '';
      _this.openAfterFocus = false;
      _this.scrollToFocusedOptionOnUpdate = false;
      _this.userIsDragging = void 0;
      _this.controlRef = null;

      _this.getControlRef = function (ref) {
        _this.controlRef = ref;
      };

      _this.focusedOptionRef = null;

      _this.getFocusedOptionRef = function (ref) {
        _this.focusedOptionRef = ref;
      };

      _this.menuListRef = null;

      _this.getMenuListRef = function (ref) {
        _this.menuListRef = ref;
      };

      _this.inputRef = null;

      _this.getInputRef = function (ref) {
        _this.inputRef = ref;
      };

      _this.focus = _this.focusInput;
      _this.blur = _this.blurInput;

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;
        actionMeta.name = name;

        _this.ariaOnChange(newValue, actionMeta);

        onChange(newValue, actionMeta);
      };

      _this.setValue = function (newValue, action, option) {
        var _this$props2 = _this.props,
            closeMenuOnSelect = _this$props2.closeMenuOnSelect,
            isMulti = _this$props2.isMulti;

        _this.onInputChange('', {
          action: 'set-value'
        });

        if (closeMenuOnSelect) {
          _this.setState({
            inputIsHiddenAfterUpdate: !isMulti
          });

          _this.onMenuClose();
        } // when the select value should change, we should reset focusedValue


        _this.setState({
          clearFocusValueOnUpdate: true
        });

        _this.onChange(newValue, {
          action: action,
          option: option
        });
      };

      _this.selectOption = function (newValue) {
        var _this$props3 = _this.props,
            blurInputOnSelect = _this$props3.blurInputOnSelect,
            isMulti = _this$props3.isMulti,
            name = _this$props3.name;
        var selectValue = _this.state.selectValue;

        var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

        var isDisabled = _this.isOptionDisabled(newValue, selectValue);

        if (deselected) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          })), 'deselect-option', newValue);
        } else if (!isDisabled) {
          // Select option if option is not disabled
          if (isMulti) {
            _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
          } else {
            _this.setValue(singleValueAsValue(newValue), 'select-option');
          }
        } else {
          _this.ariaOnChange(singleValueAsValue(newValue), {
            action: 'select-option',
            option: newValue,
            name: name
          });

          return;
        }

        if (blurInputOnSelect) {
          _this.blurInput();
        }
      };

      _this.removeValue = function (removedValue) {
        var isMulti = _this.props.isMulti;
        var selectValue = _this.state.selectValue;

        var candidate = _this.getOptionValue(removedValue);

        var newValueArray = selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        });
        var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

        _this.onChange(newValue, {
          action: 'remove-value',
          removedValue: removedValue
        });

        _this.focusInput();
      };

      _this.clearValue = function () {
        var selectValue = _this.state.selectValue;

        _this.onChange(valueTernary(_this.props.isMulti, [], null), {
          action: 'clear',
          removedValues: selectValue
        });
      };

      _this.popValue = function () {
        var isMulti = _this.props.isMulti;
        var selectValue = _this.state.selectValue;
        var lastSelectedValue = selectValue[selectValue.length - 1];
        var newValueArray = selectValue.slice(0, selectValue.length - 1);
        var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

        _this.onChange(newValue, {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      };

      _this.getValue = function () {
        return _this.state.selectValue;
      };

      _this.cx = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
      };

      _this.getOptionLabel = function (data) {
        return getOptionLabel(_this.props, data);
      };

      _this.getOptionValue = function (data) {
        return getOptionValue(_this.props, data);
      };

      _this.getStyles = function (key, props) {
        var base = defaultStyles[key](props);
        base.boxSizing = 'border-box';
        var custom = _this.props.styles[key];
        return custom ? custom(base, props) : base;
      };

      _this.getElementId = function (element) {
        return "".concat(_this.instancePrefix, "-").concat(element);
      };

      _this.getComponents = function () {
        return defaultComponents(_this.props);
      };

      _this.buildCategorizedOptions = function () {
        return buildCategorizedOptions(_this.props, _this.state.selectValue);
      };

      _this.getCategorizedOptions = function () {
        return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
      };

      _this.buildFocusableOptions = function () {
        return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
      };

      _this.getFocusableOptions = function () {
        return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
      };

      _this.ariaOnChange = function (value, actionMeta) {
        _this.setState({
          ariaSelection: _objectSpread2({
            value: value
          }, actionMeta)
        });
      };

      _this.onMenuMouseDown = function (event) {
        if (event.button !== 0) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        _this.focusInput();
      };

      _this.onMenuMouseMove = function (event) {
        _this.blockOptionHover = false;
      };

      _this.onControlMouseDown = function (event) {
        var openMenuOnClick = _this.props.openMenuOnClick;

        if (!_this.state.isFocused) {
          if (openMenuOnClick) {
            _this.openAfterFocus = true;
          }

          _this.focusInput();
        } else if (!_this.props.menuIsOpen) {
          if (openMenuOnClick) {
            _this.openMenu('first');
          }
        } else {
          if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
            _this.onMenuClose();
          }
        }

        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          event.preventDefault();
        }
      };

      _this.onDropdownIndicatorMouseDown = function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        if (_this.props.isDisabled) return;
        var _this$props4 = _this.props,
            isMulti = _this$props4.isMulti,
            menuIsOpen = _this$props4.menuIsOpen;

        _this.focusInput();

        if (menuIsOpen) {
          _this.setState({
            inputIsHiddenAfterUpdate: !isMulti
          });

          _this.onMenuClose();
        } else {
          _this.openMenu('first');
        }

        event.preventDefault();
        event.stopPropagation();
      };

      _this.onClearIndicatorMouseDown = function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        _this.clearValue();

        event.preventDefault();
        event.stopPropagation();
        _this.openAfterFocus = false;

        if (event.type === 'touchend') {
          _this.focusInput();
        } else {
          setTimeout(function () {
            return _this.focusInput();
          });
        }
      };

      _this.onScroll = function (event) {
        if (typeof _this.props.closeMenuOnScroll === 'boolean') {
          if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
            _this.props.onMenuClose();
          }
        } else if (typeof _this.props.closeMenuOnScroll === 'function') {
          if (_this.props.closeMenuOnScroll(event)) {
            _this.props.onMenuClose();
          }
        }
      };

      _this.onCompositionStart = function () {
        _this.isComposing = true;
      };

      _this.onCompositionEnd = function () {
        _this.isComposing = false;
      };

      _this.onTouchStart = function (_ref2) {
        var touches = _ref2.touches;
        var touch = touches && touches.item(0);

        if (!touch) {
          return;
        }

        _this.initialTouchX = touch.clientX;
        _this.initialTouchY = touch.clientY;
        _this.userIsDragging = false;
      };

      _this.onTouchMove = function (_ref3) {
        var touches = _ref3.touches;
        var touch = touches && touches.item(0);

        if (!touch) {
          return;
        }

        var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
        var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
        var moveThreshold = 5;
        _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
      };

      _this.onTouchEnd = function (event) {
        if (_this.userIsDragging) return; // close the menu if the user taps outside
        // we're checking on event.target here instead of event.currentTarget, because we want to assert information
        // on events on child elements, not the document (which we've attached this handler to).

        if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
          _this.blurInput();
        } // reset move vars


        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
      };

      _this.onControlTouchEnd = function (event) {
        if (_this.userIsDragging) return;

        _this.onControlMouseDown(event);
      };

      _this.onClearIndicatorTouchEnd = function (event) {
        if (_this.userIsDragging) return;

        _this.onClearIndicatorMouseDown(event);
      };

      _this.onDropdownIndicatorTouchEnd = function (event) {
        if (_this.userIsDragging) return;

        _this.onDropdownIndicatorMouseDown(event);
      };

      _this.handleInputChange = function (event) {
        var inputValue = event.currentTarget.value;

        _this.setState({
          inputIsHiddenAfterUpdate: false
        });

        _this.onInputChange(inputValue, {
          action: 'input-change'
        });

        if (!_this.props.menuIsOpen) {
          _this.onMenuOpen();
        }
      };

      _this.onInputFocus = function (event) {
        if (_this.props.onFocus) {
          _this.props.onFocus(event);
        }

        _this.setState({
          inputIsHiddenAfterUpdate: false,
          isFocused: true
        });

        if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
          _this.openMenu('first');
        }

        _this.openAfterFocus = false;
      };

      _this.onInputBlur = function (event) {
        if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
          _this.inputRef.focus();

          return;
        }

        if (_this.props.onBlur) {
          _this.props.onBlur(event);
        }

        _this.onInputChange('', {
          action: 'input-blur'
        });

        _this.onMenuClose();

        _this.setState({
          focusedValue: null,
          isFocused: false
        });
      };

      _this.onOptionHover = function (focusedOption) {
        if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
          return;
        }

        _this.setState({
          focusedOption: focusedOption
        });
      };

      _this.shouldHideSelectedOptions = function () {
        return shouldHideSelectedOptions(_this.props);
      };

      _this.onKeyDown = function (event) {
        var _this$props5 = _this.props,
            isMulti = _this$props5.isMulti,
            backspaceRemovesValue = _this$props5.backspaceRemovesValue,
            escapeClearsValue = _this$props5.escapeClearsValue,
            inputValue = _this$props5.inputValue,
            isClearable = _this$props5.isClearable,
            isDisabled = _this$props5.isDisabled,
            menuIsOpen = _this$props5.menuIsOpen,
            onKeyDown = _this$props5.onKeyDown,
            tabSelectsValue = _this$props5.tabSelectsValue,
            openMenuOnFocus = _this$props5.openMenuOnFocus;
        var _this$state = _this.state,
            focusedOption = _this$state.focusedOption,
            focusedValue = _this$state.focusedValue,
            selectValue = _this$state.selectValue;
        if (isDisabled) return;

        if (typeof onKeyDown === 'function') {
          onKeyDown(event);

          if (event.defaultPrevented) {
            return;
          }
        } // Block option hover events when the user has just pressed a key


        _this.blockOptionHover = true;

        switch (event.key) {
          case 'ArrowLeft':
            if (!isMulti || inputValue) return;

            _this.focusValue('previous');

            break;

          case 'ArrowRight':
            if (!isMulti || inputValue) return;

            _this.focusValue('next');

            break;

          case 'Delete':
          case 'Backspace':
            if (inputValue) return;

            if (focusedValue) {
              _this.removeValue(focusedValue);
            } else {
              if (!backspaceRemovesValue) return;

              if (isMulti) {
                _this.popValue();
              } else if (isClearable) {
                _this.clearValue();
              }
            }

            break;

          case 'Tab':
            if (_this.isComposing) return;

            if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
              return;
            }

            _this.selectOption(focusedOption);

            break;

          case 'Enter':
            if (event.keyCode === 229) {
              // ignore the keydown event from an Input Method Editor(IME)
              // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
              break;
            }

            if (menuIsOpen) {
              if (!focusedOption) return;
              if (_this.isComposing) return;

              _this.selectOption(focusedOption);

              break;
            }

            return;

          case 'Escape':
            if (menuIsOpen) {
              _this.setState({
                inputIsHiddenAfterUpdate: false
              });

              _this.onInputChange('', {
                action: 'menu-close'
              });

              _this.onMenuClose();
            } else if (isClearable && escapeClearsValue) {
              _this.clearValue();
            }

            break;

          case ' ':
            // space
            if (inputValue) {
              return;
            }

            if (!menuIsOpen) {
              _this.openMenu('first');

              break;
            }

            if (!focusedOption) return;

            _this.selectOption(focusedOption);

            break;

          case 'ArrowUp':
            if (menuIsOpen) {
              _this.focusOption('up');
            } else {
              _this.openMenu('last');
            }

            break;

          case 'ArrowDown':
            if (menuIsOpen) {
              _this.focusOption('down');
            } else {
              _this.openMenu('first');
            }

            break;

          case 'PageUp':
            if (!menuIsOpen) return;

            _this.focusOption('pageup');

            break;

          case 'PageDown':
            if (!menuIsOpen) return;

            _this.focusOption('pagedown');

            break;

          case 'Home':
            if (!menuIsOpen) return;

            _this.focusOption('first');

            break;

          case 'End':
            if (!menuIsOpen) return;

            _this.focusOption('last');

            break;

          default:
            return;
        }

        event.preventDefault();
      };

      _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
      _this.state.selectValue = cleanValue(_props.value);
      return _this;
    }

    _createClass(Select, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();

        if (this.props.closeMenuOnScroll && document && document.addEventListener) {
          // Listen to all scroll events, and filter them out inside of 'onScroll'
          document.addEventListener('scroll', this.onScroll, true);
        }

        if (this.props.autoFocus) {
          this.focusInput();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props6 = this.props,
            isDisabled = _this$props6.isDisabled,
            menuIsOpen = _this$props6.menuIsOpen;
        var isFocused = this.state.isFocused;

        if ( // ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) {
          this.focusInput();
        }

        if (isFocused && isDisabled && !prevProps.isDisabled) {
          // ensure select state gets blurred in case Select is programatically disabled while focused
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            isFocused: false
          }, this.onMenuClose);
        } // scroll the focused option into view if necessary


        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
          scrollIntoView(this.menuListRef, this.focusedOptionRef);
          this.scrollToFocusedOptionOnUpdate = false;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        document.removeEventListener('scroll', this.onScroll, true);
      } // ==============================
      // Consumer Handlers
      // ==============================

    }, {
      key: "onMenuOpen",
      value: function onMenuOpen() {
        this.props.onMenuOpen();
      }
    }, {
      key: "onMenuClose",
      value: function onMenuClose() {
        this.onInputChange('', {
          action: 'menu-close'
        });
        this.props.onMenuClose();
      }
    }, {
      key: "onInputChange",
      value: function onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
      } // ==============================
      // Methods
      // ==============================

    }, {
      key: "focusInput",
      value: function focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
      }
    }, {
      key: "blurInput",
      value: function blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
      } // aliased for consumers

    }, {
      key: "openMenu",
      value: function openMenu(focusOption) {
        var _this2 = this;

        var _this$state2 = this.state,
            selectValue = _this$state2.selectValue,
            isFocused = _this$state2.isFocused;
        var focusableOptions = this.buildFocusableOptions();
        var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;

        if (!this.props.isMulti) {
          var selectedIndex = focusableOptions.indexOf(selectValue[0]);

          if (selectedIndex > -1) {
            openAtIndex = selectedIndex;
          }
        } // only scroll if the menu isn't already open


        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
          inputIsHiddenAfterUpdate: false,
          focusedValue: null,
          focusedOption: focusableOptions[openAtIndex]
        }, function () {
          return _this2.onMenuOpen();
        });
      }
    }, {
      key: "focusValue",
      value: function focusValue(direction) {
        var _this$state3 = this.state,
            selectValue = _this$state3.selectValue,
            focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

        if (!this.props.isMulti) return;
        this.setState({
          focusedOption: null
        });
        var focusedIndex = selectValue.indexOf(focusedValue);

        if (!focusedValue) {
          focusedIndex = -1;
        }

        var lastIndex = selectValue.length - 1;
        var nextFocus = -1;
        if (!selectValue.length) return;

        switch (direction) {
          case 'previous':
            if (focusedIndex === 0) {
              // don't cycle from the start to the end
              nextFocus = 0;
            } else if (focusedIndex === -1) {
              // if nothing is focused, focus the last value first
              nextFocus = lastIndex;
            } else {
              nextFocus = focusedIndex - 1;
            }

            break;

          case 'next':
            if (focusedIndex > -1 && focusedIndex < lastIndex) {
              nextFocus = focusedIndex + 1;
            }

            break;
        }

        this.setState({
          inputIsHidden: nextFocus !== -1,
          focusedValue: selectValue[nextFocus]
        });
      }
    }, {
      key: "focusOption",
      value: function focusOption() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
        var pageSize = this.props.pageSize;
        var focusedOption = this.state.focusedOption;
        var options = this.getFocusableOptions();
        if (!options.length) return;
        var nextFocus = 0; // handles 'first'

        var focusedIndex = options.indexOf(focusedOption);

        if (!focusedOption) {
          focusedIndex = -1;
        }

        if (direction === 'up') {
          nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        } else if (direction === 'down') {
          nextFocus = (focusedIndex + 1) % options.length;
        } else if (direction === 'pageup') {
          nextFocus = focusedIndex - pageSize;
          if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
          nextFocus = focusedIndex + pageSize;
          if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') {
          nextFocus = options.length - 1;
        }

        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
          focusedOption: options[nextFocus],
          focusedValue: null
        });
      }
    }, {
      key: "getTheme",
      value: // ==============================
      // Getters
      // ==============================
      function getTheme() {
        // Use the default theme if there are no customizations.
        if (!this.props.theme) {
          return defaultTheme;
        } // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.


        if (typeof this.props.theme === 'function') {
          return this.props.theme(defaultTheme);
        } // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.


        return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
      }
    }, {
      key: "getCommonProps",
      value: function getCommonProps() {
        var clearValue = this.clearValue,
            cx = this.cx,
            getStyles = this.getStyles,
            getValue = this.getValue,
            selectOption = this.selectOption,
            setValue = this.setValue,
            props = this.props;
        var isMulti = props.isMulti,
            isRtl = props.isRtl,
            options = props.options;
        var hasValue = this.hasValue();
        return {
          clearValue: clearValue,
          cx: cx,
          getStyles: getStyles,
          getValue: getValue,
          hasValue: hasValue,
          isMulti: isMulti,
          isRtl: isRtl,
          options: options,
          selectOption: selectOption,
          selectProps: props,
          setValue: setValue,
          theme: this.getTheme()
        };
      }
    }, {
      key: "hasValue",
      value: function hasValue() {
        var selectValue = this.state.selectValue;
        return selectValue.length > 0;
      }
    }, {
      key: "hasOptions",
      value: function hasOptions() {
        return !!this.getFocusableOptions().length;
      }
    }, {
      key: "isClearable",
      value: function isClearable() {
        var _this$props7 = this.props,
            isClearable = _this$props7.isClearable,
            isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable

        if (isClearable === undefined) return isMulti;
        return isClearable;
      }
    }, {
      key: "isOptionDisabled",
      value: function isOptionDisabled(option, selectValue) {
        return _isOptionDisabled(this.props, option, selectValue);
      }
    }, {
      key: "isOptionSelected",
      value: function isOptionSelected(option, selectValue) {
        return _isOptionSelected(this.props, option, selectValue);
      }
    }, {
      key: "filterOption",
      value: function filterOption(option, inputValue) {
        return _filterOption(this.props, option, inputValue);
      }
    }, {
      key: "formatOptionLabel",
      value: function formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
          var _inputValue = this.props.inputValue;
          var _selectValue = this.state.selectValue;
          return this.props.formatOptionLabel(data, {
            context: context,
            inputValue: _inputValue,
            selectValue: _selectValue
          });
        } else {
          return this.getOptionLabel(data);
        }
      }
    }, {
      key: "formatGroupLabel",
      value: function formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
      } // ==============================
      // Mouse Handlers
      // ==============================

    }, {
      key: "startListeningComposition",
      value: // ==============================
      // Composition Handlers
      // ==============================
      function startListeningComposition() {
        if (document && document.addEventListener) {
          document.addEventListener('compositionstart', this.onCompositionStart, false);
          document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
      }
    }, {
      key: "stopListeningComposition",
      value: function stopListeningComposition() {
        if (document && document.removeEventListener) {
          document.removeEventListener('compositionstart', this.onCompositionStart);
          document.removeEventListener('compositionend', this.onCompositionEnd);
        }
      }
    }, {
      key: "startListeningToTouch",
      value: // ==============================
      // Touch Handlers
      // ==============================
      function startListeningToTouch() {
        if (document && document.addEventListener) {
          document.addEventListener('touchstart', this.onTouchStart, false);
          document.addEventListener('touchmove', this.onTouchMove, false);
          document.addEventListener('touchend', this.onTouchEnd, false);
        }
      }
    }, {
      key: "stopListeningToTouch",
      value: function stopListeningToTouch() {
        if (document && document.removeEventListener) {
          document.removeEventListener('touchstart', this.onTouchStart);
          document.removeEventListener('touchmove', this.onTouchMove);
          document.removeEventListener('touchend', this.onTouchEnd);
        }
      }
    }, {
      key: "renderInput",
      value: // ==============================
      // Renderers
      // ==============================
      function renderInput() {
        var _this$props8 = this.props,
            isDisabled = _this$props8.isDisabled,
            isSearchable = _this$props8.isSearchable,
            inputId = _this$props8.inputId,
            inputValue = _this$props8.inputValue,
            tabIndex = _this$props8.tabIndex,
            form = _this$props8.form,
            menuIsOpen = _this$props8.menuIsOpen;

        var _this$getComponents = this.getComponents(),
            Input = _this$getComponents.Input;

        var _this$state4 = this.state,
            inputIsHidden = _this$state4.inputIsHidden,
            ariaSelection = _this$state4.ariaSelection;
        var commonProps = this.commonProps;
        var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

        var ariaAttributes = _objectSpread2(_objectSpread2({
          'aria-autocomplete': 'list',
          'aria-expanded': menuIsOpen,
          'aria-haspopup': true,
          'aria-controls': this.getElementId('listbox'),
          'aria-owns': this.getElementId('listbox'),
          'aria-errormessage': this.props['aria-errormessage'],
          'aria-invalid': this.props['aria-invalid'],
          'aria-label': this.props['aria-label'],
          'aria-labelledby': this.props['aria-labelledby'],
          role: 'combobox'
        }, !isSearchable && {
          'aria-readonly': true
        }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
          'aria-describedby': this.getElementId('live-region')
        } : {
          'aria-describedby': this.getElementId('placeholder')
        });

        if (!isSearchable) {
          // use a dummy input to maintain focus/blur functionality
          return /*#__PURE__*/React__default['default'].createElement(DummyInput, _extends({
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: ""
          }, ariaAttributes));
        }

        return /*#__PURE__*/React__default['default'].createElement(Input, _extends({}, commonProps, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: id,
          innerRef: this.getInputRef,
          isDisabled: isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: tabIndex,
          form: form,
          type: "text",
          value: inputValue
        }, ariaAttributes));
      }
    }, {
      key: "renderPlaceholderOrValue",
      value: function renderPlaceholderOrValue() {
        var _this3 = this;

        var _this$getComponents2 = this.getComponents(),
            MultiValue = _this$getComponents2.MultiValue,
            MultiValueContainer = _this$getComponents2.MultiValueContainer,
            MultiValueLabel = _this$getComponents2.MultiValueLabel,
            MultiValueRemove = _this$getComponents2.MultiValueRemove,
            SingleValue = _this$getComponents2.SingleValue,
            Placeholder = _this$getComponents2.Placeholder;

        var commonProps = this.commonProps;
        var _this$props9 = this.props,
            controlShouldRenderValue = _this$props9.controlShouldRenderValue,
            isDisabled = _this$props9.isDisabled,
            isMulti = _this$props9.isMulti,
            inputValue = _this$props9.inputValue,
            placeholder = _this$props9.placeholder;
        var _this$state5 = this.state,
            selectValue = _this$state5.selectValue,
            focusedValue = _this$state5.focusedValue,
            isFocused = _this$state5.isFocused;

        if (!this.hasValue() || !controlShouldRenderValue) {
          return inputValue ? null : /*#__PURE__*/React__default['default'].createElement(Placeholder, _extends({}, commonProps, {
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
              id: this.getElementId('placeholder')
            }
          }), placeholder);
        }

        if (isMulti) {
          return selectValue.map(function (opt, index) {
            var isOptionFocused = opt === focusedValue;
            return /*#__PURE__*/React__default['default'].createElement(MultiValue, _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isOptionFocused,
              isDisabled: isDisabled,
              key: "".concat(_this3.getOptionValue(opt), "-").concat(index),
              index: index,
              removeProps: {
                onClick: function onClick() {
                  return _this3.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this3.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }), _this3.formatOptionLabel(opt, 'value'));
          });
        }

        if (inputValue) {
          return null;
        }

        var singleValue = selectValue[0];
        return /*#__PURE__*/React__default['default'].createElement(SingleValue, _extends({}, commonProps, {
          data: singleValue,
          isDisabled: isDisabled
        }), this.formatOptionLabel(singleValue, 'value'));
      }
    }, {
      key: "renderClearIndicator",
      value: function renderClearIndicator() {
        var _this$getComponents3 = this.getComponents(),
            ClearIndicator = _this$getComponents3.ClearIndicator;

        var commonProps = this.commonProps;
        var _this$props10 = this.props,
            isDisabled = _this$props10.isDisabled,
            isLoading = _this$props10.isLoading;
        var isFocused = this.state.isFocused;

        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
          return null;
        }

        var innerProps = {
          onMouseDown: this.onClearIndicatorMouseDown,
          onTouchEnd: this.onClearIndicatorTouchEnd,
          'aria-hidden': 'true'
        };
        return /*#__PURE__*/React__default['default'].createElement(ClearIndicator, _extends({}, commonProps, {
          innerProps: innerProps,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderLoadingIndicator",
      value: function renderLoadingIndicator() {
        var _this$getComponents4 = this.getComponents(),
            LoadingIndicator = _this$getComponents4.LoadingIndicator;

        var commonProps = this.commonProps;
        var _this$props11 = this.props,
            isDisabled = _this$props11.isDisabled,
            isLoading = _this$props11.isLoading;
        var isFocused = this.state.isFocused;
        if (!LoadingIndicator || !isLoading) return null;
        var innerProps = {
          'aria-hidden': 'true'
        };
        return /*#__PURE__*/React__default['default'].createElement(LoadingIndicator, _extends({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderIndicatorSeparator",
      value: function renderIndicatorSeparator() {
        var _this$getComponents5 = this.getComponents(),
            DropdownIndicator = _this$getComponents5.DropdownIndicator,
            IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator


        if (!DropdownIndicator || !IndicatorSeparator) return null;
        var commonProps = this.commonProps;
        var isDisabled = this.props.isDisabled;
        var isFocused = this.state.isFocused;
        return /*#__PURE__*/React__default['default'].createElement(IndicatorSeparator, _extends({}, commonProps, {
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderDropdownIndicator",
      value: function renderDropdownIndicator() {
        var _this$getComponents6 = this.getComponents(),
            DropdownIndicator = _this$getComponents6.DropdownIndicator;

        if (!DropdownIndicator) return null;
        var commonProps = this.commonProps;
        var isDisabled = this.props.isDisabled;
        var isFocused = this.state.isFocused;
        var innerProps = {
          onMouseDown: this.onDropdownIndicatorMouseDown,
          onTouchEnd: this.onDropdownIndicatorTouchEnd,
          'aria-hidden': 'true'
        };
        return /*#__PURE__*/React__default['default'].createElement(DropdownIndicator, _extends({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderMenu",
      value: function renderMenu() {
        var _this4 = this;

        var _this$getComponents7 = this.getComponents(),
            Group = _this$getComponents7.Group,
            GroupHeading = _this$getComponents7.GroupHeading,
            Menu = _this$getComponents7.Menu,
            MenuList = _this$getComponents7.MenuList,
            MenuPortal = _this$getComponents7.MenuPortal,
            LoadingMessage = _this$getComponents7.LoadingMessage,
            NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
            Option = _this$getComponents7.Option;

        var commonProps = this.commonProps;
        var focusedOption = this.state.focusedOption;
        var _this$props12 = this.props,
            captureMenuScroll = _this$props12.captureMenuScroll,
            inputValue = _this$props12.inputValue,
            isLoading = _this$props12.isLoading,
            loadingMessage = _this$props12.loadingMessage,
            minMenuHeight = _this$props12.minMenuHeight,
            maxMenuHeight = _this$props12.maxMenuHeight,
            menuIsOpen = _this$props12.menuIsOpen,
            menuPlacement = _this$props12.menuPlacement,
            menuPosition = _this$props12.menuPosition,
            menuPortalTarget = _this$props12.menuPortalTarget,
            menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
            menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
            noOptionsMessage = _this$props12.noOptionsMessage,
            onMenuScrollToTop = _this$props12.onMenuScrollToTop,
            onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
        if (!menuIsOpen) return null; // TODO: Internal Option Type here

        var render = function render(props, id) {
          var type = props.type,
              data = props.data,
              isDisabled = props.isDisabled,
              isSelected = props.isSelected,
              label = props.label,
              value = props.value;
          var isFocused = focusedOption === data;
          var onHover = isDisabled ? undefined : function () {
            return _this4.onOptionHover(data);
          };
          var onSelect = isDisabled ? undefined : function () {
            return _this4.selectOption(data);
          };
          var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
          var innerProps = {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          };
          return /*#__PURE__*/React__default['default'].createElement(Option, _extends({}, commonProps, {
            innerProps: innerProps,
            data: data,
            isDisabled: isDisabled,
            isSelected: isSelected,
            key: optionId,
            label: label,
            type: type,
            value: value,
            isFocused: isFocused,
            innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
          }), _this4.formatOptionLabel(props.data, 'menu'));
        };

        var menuUI;

        if (this.hasOptions()) {
          menuUI = this.getCategorizedOptions().map(function (item) {
            if (item.type === 'group') {
              var _data = item.data,
                  options = item.options,
                  groupIndex = item.index;
              var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
              var headingId = "".concat(groupId, "-heading");
              return /*#__PURE__*/React__default['default'].createElement(Group, _extends({}, commonProps, {
                key: groupId,
                data: _data,
                options: options,
                Heading: GroupHeading,
                headingProps: {
                  id: headingId,
                  data: item.data
                },
                label: _this4.formatGroupLabel(item.data)
              }), item.options.map(function (option) {
                return render(option, "".concat(groupIndex, "-").concat(option.index));
              }));
            } else if (item.type === 'option') {
              return render(item, "".concat(item.index));
            }
          });
        } else if (isLoading) {
          var message = loadingMessage({
            inputValue: inputValue
          });
          if (message === null) return null;
          menuUI = /*#__PURE__*/React__default['default'].createElement(LoadingMessage, commonProps, message);
        } else {
          var _message = noOptionsMessage({
            inputValue: inputValue
          });

          if (_message === null) return null;
          menuUI = /*#__PURE__*/React__default['default'].createElement(NoOptionsMessage, commonProps, _message);
        }

        var menuPlacementProps = {
          minMenuHeight: minMenuHeight,
          maxMenuHeight: maxMenuHeight,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition,
          menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        var menuElement = /*#__PURE__*/React__default['default'].createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref4) {
          var ref = _ref4.ref,
              _ref4$placerProps = _ref4.placerProps,
              placement = _ref4$placerProps.placement,
              maxHeight = _ref4$placerProps.maxHeight;
          return /*#__PURE__*/React__default['default'].createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
            innerRef: ref,
            innerProps: {
              onMouseDown: _this4.onMenuMouseDown,
              onMouseMove: _this4.onMenuMouseMove,
              id: _this4.getElementId('listbox')
            },
            isLoading: isLoading,
            placement: placement
          }), /*#__PURE__*/React__default['default'].createElement(ScrollManager, {
            captureEnabled: captureMenuScroll,
            onTopArrive: onMenuScrollToTop,
            onBottomArrive: onMenuScrollToBottom,
            lockEnabled: menuShouldBlockScroll
          }, function (scrollTargetRef) {
            return /*#__PURE__*/React__default['default'].createElement(MenuList, _extends({}, commonProps, {
              innerRef: function innerRef(instance) {
                _this4.getMenuListRef(instance);

                scrollTargetRef(instance);
              },
              isLoading: isLoading,
              maxHeight: maxHeight,
              focusedOption: focusedOption
            }), menuUI);
          }));
        }); // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`

        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React__default['default'].createElement(MenuPortal, _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }), menuElement) : menuElement;
      }
    }, {
      key: "renderFormField",
      value: function renderFormField() {
        var _this5 = this;

        var _this$props13 = this.props,
            delimiter = _this$props13.delimiter,
            isDisabled = _this$props13.isDisabled,
            isMulti = _this$props13.isMulti,
            name = _this$props13.name;
        var selectValue = this.state.selectValue;
        if (!name || isDisabled) return;

        if (isMulti) {
          if (delimiter) {
            var value = selectValue.map(function (opt) {
              return _this5.getOptionValue(opt);
            }).join(delimiter);
            return /*#__PURE__*/React__default['default'].createElement("input", {
              name: name,
              type: "hidden",
              value: value
            });
          } else {
            var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
              return /*#__PURE__*/React__default['default'].createElement("input", {
                key: "i-".concat(i),
                name: name,
                type: "hidden",
                value: _this5.getOptionValue(opt)
              });
            }) : /*#__PURE__*/React__default['default'].createElement("input", {
              name: name,
              type: "hidden"
            });
            return /*#__PURE__*/React__default['default'].createElement("div", null, input);
          }
        } else {
          var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

          return /*#__PURE__*/React__default['default'].createElement("input", {
            name: name,
            type: "hidden",
            value: _value
          });
        }
      }
    }, {
      key: "renderLiveRegion",
      value: function renderLiveRegion() {
        var commonProps = this.commonProps;
        var _this$state6 = this.state,
            ariaSelection = _this$state6.ariaSelection,
            focusedOption = _this$state6.focusedOption,
            focusedValue = _this$state6.focusedValue,
            isFocused = _this$state6.isFocused,
            selectValue = _this$state6.selectValue;
        var focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/React__default['default'].createElement(LiveRegion, _extends({}, commonProps, {
          id: this.getElementId('live-region'),
          ariaSelection: ariaSelection,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          isFocused: isFocused,
          selectValue: selectValue,
          focusableOptions: focusableOptions
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$getComponents8 = this.getComponents(),
            Control = _this$getComponents8.Control,
            IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
            SelectContainer = _this$getComponents8.SelectContainer,
            ValueContainer = _this$getComponents8.ValueContainer;

        var _this$props14 = this.props,
            className = _this$props14.className,
            id = _this$props14.id,
            isDisabled = _this$props14.isDisabled,
            menuIsOpen = _this$props14.menuIsOpen;
        var isFocused = this.state.isFocused;
        var commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/React__default['default'].createElement(SelectContainer, _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }), this.renderLiveRegion(), /*#__PURE__*/React__default['default'].createElement(Control, _extends({}, commonProps, {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: isDisabled,
          isFocused: isFocused,
          menuIsOpen: menuIsOpen
        }), /*#__PURE__*/React__default['default'].createElement(ValueContainer, _extends({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React__default['default'].createElement(IndicatorsContainer, _extends({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, state) {
        var prevProps = state.prevProps,
            clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
            inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
            ariaSelection = state.ariaSelection,
            isFocused = state.isFocused,
            prevWasFocused = state.prevWasFocused;
        var options = props.options,
            value = props.value,
            menuIsOpen = props.menuIsOpen,
            inputValue = props.inputValue,
            isMulti = props.isMulti;
        var selectValue = cleanValue(value);
        var newMenuOptionsState = {};

        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
          var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
          var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
          var focusedOption = getNextFocusedOption(state, focusableOptions);
          newMenuOptionsState = {
            selectValue: selectValue,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            clearFocusValueOnUpdate: false
          };
        } // some updates should toggle the state of the input visibility


        var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
          inputIsHidden: inputIsHiddenAfterUpdate,
          inputIsHiddenAfterUpdate: undefined
        } : {};
        var newAriaSelection = ariaSelection;
        var hasKeptFocus = isFocused && prevWasFocused;

        if (isFocused && !hasKeptFocus) {
          // If `value` or `defaultValue` props are not empty then announce them
          // when the Select is initially focused
          newAriaSelection = {
            value: valueTernary(isMulti, selectValue, selectValue[0] || null),
            options: selectValue,
            action: 'initial-input-focus'
          };
          hasKeptFocus = !prevWasFocused;
        } // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null


        if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
          newAriaSelection = null;
        }

        return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
          prevProps: props,
          ariaSelection: newAriaSelection,
          prevWasFocused: hasKeptFocus
        });
      }
    }]);

    return Select;
  }(React.Component);

  Select.defaultProps = defaultProps$2;

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  var _excluded$5 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
  function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue,
        defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
        _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
        defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
        _ref$defaultValue = _ref.defaultValue,
        defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
        propsInputValue = _ref.inputValue,
        propsMenuIsOpen = _ref.menuIsOpen,
        propsOnChange = _ref.onChange,
        propsOnInputChange = _ref.onInputChange,
        propsOnMenuClose = _ref.onMenuClose,
        propsOnMenuOpen = _ref.onMenuOpen,
        propsValue = _ref.value,
        restSelectProps = _objectWithoutProperties(_ref, _excluded$5);

    var _useState = React.useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
        _useState2 = _slicedToArray(_useState, 2),
        stateInputValue = _useState2[0],
        setStateInputValue = _useState2[1];

    var _useState3 = React.useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
        _useState4 = _slicedToArray(_useState3, 2),
        stateMenuIsOpen = _useState4[0],
        setStateMenuIsOpen = _useState4[1];

    var _useState5 = React.useState(propsValue !== undefined ? propsValue : defaultValue),
        _useState6 = _slicedToArray(_useState5, 2),
        stateValue = _useState6[0],
        setStateValue = _useState6[1];

    var onChange = React.useCallback(function (value, actionMeta) {
      if (typeof propsOnChange === 'function') {
        propsOnChange(value, actionMeta);
      }

      setStateValue(value);
    }, [propsOnChange]);
    var onInputChange = React.useCallback(function (value, actionMeta) {
      var newValue;

      if (typeof propsOnInputChange === 'function') {
        newValue = propsOnInputChange(value, actionMeta);
      }

      setStateInputValue(newValue !== undefined ? newValue : value);
    }, [propsOnInputChange]);
    var onMenuOpen = React.useCallback(function () {
      if (typeof propsOnMenuOpen === 'function') {
        propsOnMenuOpen();
      }

      setStateMenuIsOpen(true);
    }, [propsOnMenuOpen]);
    var onMenuClose = React.useCallback(function () {
      if (typeof propsOnMenuClose === 'function') {
        propsOnMenuClose();
      }

      setStateMenuIsOpen(false);
    }, [propsOnMenuClose]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
      inputValue: inputValue,
      menuIsOpen: menuIsOpen,
      onChange: onChange,
      onInputChange: onInputChange,
      onMenuClose: onMenuClose,
      onMenuOpen: onMenuOpen,
      value: value
    });
  }

  var StateManagedSelect = /*#__PURE__*/React__default['default'].forwardRef(function (props, ref) {
    var baseSelectProps = useStateManager(props);
    return /*#__PURE__*/React__default['default'].createElement(Select, _extends({
      ref: ref
    }, baseSelectProps));
  });

  var _templateObject$7, _templateObject2$4, _templateObject3$4;

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var customStyles = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        fontSize: '0.9375rem',
        lineHeight: '1.1875rem',
        maxWidth: '295px'
      });
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderRadius: state.selectProps.menuIsOpen ? '8px 8px 0 0' : '8px',
        border: "1px solid ".concat(state.isFocused && !state.selectProps.menuIsOpen ? colors.brand : colors.gray40),
        outline: state.isFocused && !state.selectProps.menuIsOpen ? "1px solid ".concat(colors.brand) : 'none',
        boxShadow: 'none',
        transition: 'none',
        '&:hover': {
          borderColor: colors.gray40
        }
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        top: 29,
        borderRadius: '0 0 8px 8px',
        border: "1px solid ".concat(colors.gray40),
        borderTop: 'none',
        boxShadow: 'none',
        overflow: 'hidden'
      });
    },
    menuList: function menuList(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0
      });
    },
    singleValue: function singleValue(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        marginInlineStart: '0.25rem'
      });
    },
    valueContainer: function valueContainer(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        display: 'flex',
        color: colors.black,
        padding: '0.625rem 1rem'
      });
    },
    input: function input(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        marginInlineStart: '0.325rem'
      });
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: '0.5rem 1rem',
        color: state.isFocused ? colors.white : colors.black,
        backgroundColor: state.isFocused ? colors.brand : colors.white,
        '&:hover': {
          color: colors.white,
          backgroundColor: colors.brand
        }
      });
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        paddingInlineEnd: '0.625rem'
      });
    }
  };
  var DropdownArrow = styled__default['default'](SelectCaret)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  transition: transform ease 150ms;\n\n  ", "\n"])), function (_ref) {
    var open = _ref.open;
    return open ? 'transform: rotate(-180deg);' : '';
  });
  var StyledOption = styled__default['default'].div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
  var OptionDivider = styled__default['default'].div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  border-top: 0.5px solid ", "50;\n  width: calc(100% - 1.5rem);\n  margin: 0 0.75rem;\n"])), colors.gray40);

  var DropdownIndicator$1 = function DropdownIndicator(props) {
    return /*#__PURE__*/React__default['default'].createElement(components.DropdownIndicator, props, /*#__PURE__*/React__default['default'].createElement(DropdownArrow, {
      open: props.selectProps.menuIsOpen
    }));
  };

  var ValueContainer$1 = function ValueContainer(props) {
    return /*#__PURE__*/React__default['default'].createElement(components.ValueContainer, props, /*#__PURE__*/React__default['default'].createElement(Globe, null), props.children);
  };

  var LanguageSelect = function LanguageSelect(_ref) {
    var currentLanguage = _ref.currentLanguage,
        onLanguageSelect = _ref.onLanguageSelect,
        languages = _ref.languages,
        languageAriaLabel = _ref.languageAriaLabel;
    var otherLocales = languages.map(function (l) {
      return {
        value: l.id,
        label: l.title
      };
    });

    var handleLanguageSelect = function handleLanguageSelect(l) {
      return onLanguageSelect(l.value);
    };

    var Option = function Option(props) {
      return /*#__PURE__*/React__default['default'].createElement(StyledOption, null, /*#__PURE__*/React__default['default'].createElement(OptionDivider, null), /*#__PURE__*/React__default['default'].createElement(components.Option, props));
    };

    return /*#__PURE__*/React__default['default'].createElement(StateManagedSelect, {
      value: otherLocales.find(function (l) {
        return l.value === currentLanguage;
      }),
      onChange: handleLanguageSelect,
      options: otherLocales,
      filterOption: function filterOption(option) {
        return currentLanguage !== option.value;
      },
      components: {
        ValueContainer: ValueContainer$1,
        DropdownIndicator: DropdownIndicator$1,
        IndicatorSeparator: null,
        Option: Option
      },
      maxMenuHeight: 190,
      styles: customStyles,
      "aria-label": languageAriaLabel,
      isSearchable: false
    });
  };

  LanguageSelect.propTypes = {
    /**
     * A function that runs when a new value is selected;
     * receives new value: `(l) => onLanguageSelect(l.value)`
     * is expected to update `currentLanguage`.
     */
    onLanguageSelect: propTypes.func.isRequired,

    /**
     * Currently selected language;
     * expected to be a locale code that matches to a option in `languages[x].id`
     */
    currentLanguage: propTypes.string,

    /** Provide a **_translated_** aria-label for the select field */
    languageAriaLabel: propTypes.string,

    /**
     * A list of languages to render.
     * `shape` for each language:
     *
     * ```js
     * {
     *    // Should be a standard locale code and match the
     *    // code specified in your i18n config "locales" array
     *    id: string.isRequired,
     *
     *    // Display label of language/locale
     *    title: string.isRequired
     * }
     * ```
     */
    languages: propTypes.arrayOf(propTypes.shape({
      /**
       * This should ideally be a locale code and should match the
       * code specified in your i18n config "locales" array
       */
      id: propTypes.string.isRequired,

      /** Display label of language/locale */
      title: propTypes.string.isRequired
    })).isRequired
  };
  LanguageSelect.defaultProps = {
    currentLanguage: 'en',
    languages: [{
      id: 'en',
      title: 'English'
    }],
    languageAriaLabel: 'Select a language'
  };

  var _templateObject$8, _templateObject2$5;
  var SocialIconsComponent = styled__default['default'].nav(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  line-height: 1;\n"])));
  var A$2 = styled__default['default'].a(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  display: inline-block;\n  line-height: 1;\n\n  path {\n    transition: fill 200ms ease;\n  }\n\n  &:hover {\n    path {\n      fill: ", ";\n    }\n  }\n"])), colors.brand);

  var SocialIcons = function SocialIcons(_ref) {
    var socialIcons = _ref.socialIcons,
        rest = _objectWithoutProperties(_ref, ["socialIcons"]);

    return /*#__PURE__*/React__default['default'].createElement(SocialIconsComponent, _extends({
      "aria-label": "Social media links"
    }, rest), socialIcons.map(function (item, index) {
      return /*#__PURE__*/React__default['default'].createElement(A$2, {
        href: item.url,
        target: "_blank",
        key: index,
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default['default'].createElement(SocialIcon, {
        variant: item.name
      }));
    }));
  };

  var _templateObject$9, _templateObject2$6, _templateObject3$5, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$3;
  var FooterComponent = styled__default['default'].footer(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: 5rem;\n  padding-bottom: 2.5rem;\n  padding-top: 6rem;\n"])));
  var LogoLockup = styled__default['default'].div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-bottom: 4.125rem;\n\n  @media (min-width: ", ") {\n    padding-inline-end: 3.125rem;\n  }\n\n  @media (min-width: ", ") {\n    padding-inline-end: 3.125rem;\n    margin-bottom: 0;\n  }\n"])), breakpoints.tablet, breakpoints.desktop);
  var StyledLogo = styled__default['default'](Logo)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  margin-bottom: 1.25rem;\n"])));
  var Description = styled__default['default'].p(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  ", ";\n  max-width: 30.125rem;\n  margin-bottom: 1rem;\n\n  @media (min-width: ", ") {\n    max-width: 23.25rem;\n    margin-bottom: 1.25rem;\n  }\n"])), body20, breakpoints.desktop);
  var StyledSocialIcons = styled__default['default'](SocialIcons)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  margin-bottom: 1.875rem;\n"])));
  var Content = styled__default['default'].div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: ", ") {\n    flex-direction: row;\n  }\n"])), breakpoints.desktop);
  var FooterNav = styled__default['default'].div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  width: auto;\n\n  @media (min-width: ", ") {\n    justify-content: space-between;\n  }\n"])), breakpoints.desktop);

  var Footer = function Footer(_ref) {
    var className = _ref.className,
        columns = _ref.columns,
        description = _ref.description,
        legal = _ref.legal,
        socialIcons = _ref.socialIcons,
        onLanguageSelect = _ref.onLanguageSelect,
        currentLanguage = _ref.currentLanguage,
        language = _ref.language;
        _ref.languageAriaLabel;
    return /*#__PURE__*/React__default['default'].createElement(FooterComponent, {
      className: className
    }, /*#__PURE__*/React__default['default'].createElement(MaxWidth, null, /*#__PURE__*/React__default['default'].createElement(StyledLogo, null), /*#__PURE__*/React__default['default'].createElement(Content, null, /*#__PURE__*/React__default['default'].createElement(LogoLockup, null, /*#__PURE__*/React__default['default'].createElement(Description, null, description), /*#__PURE__*/React__default['default'].createElement(StyledSocialIcons, {
      socialIcons: socialIcons
    }), /*#__PURE__*/React__default['default'].createElement(LanguageSelect, _extends({
      onLanguageSelect: onLanguageSelect,
      currentLanguage: currentLanguage
    }, language))), /*#__PURE__*/React__default['default'].createElement(FooterNav, null, columns.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement(NavColumn, _extends({
        key: item.title
      }, item));
    }))), /*#__PURE__*/React__default['default'].createElement(Legal$1, legal)));
  };

  Footer.propTypes = {
    className: propTypes.string,

    /**
     * Array of columns, each with a header and a list of links;
     * do not include "language" column here.
     */
    columns: propTypes.arrayOf(propTypes.shape({
      /** The title of the column. */
      title: propTypes.string.isRequired,

      /** A list of links. `shape` for each link: `{ display: string, url: string}` */
      items: propTypes.arrayOf(propTypes.shape({
        display: propTypes.string.isRequired,
        url: propTypes.string.isRequired
      })).isRequired
    })).isRequired,

    /**
     * Currently selected language;
     * expected to be a locale code that matches to a option in `language.languages[x].id`
     */
    currentLanguage: propTypes.string.isRequired,

    /** Description of the company. */
    description: propTypes.string.isRequired,

    /**
     * The langauge column is always present,
     * and includes a list of languages the user can switch to.
     */
    language: propTypes.shape({
      /**
       * A list of languages to render.
       * `shape` for each language:
       *
       * ```js
       * {
       *    // Should be a standard locale code and match the
       *    // code specified in your i18n config "locales" array
       *    id: string.isRequired,
       *
       *    // Display label of language/locale
       *    title: string.isRequired
       * }
       * ```
       */
      languages: propTypes.arrayOf(propTypes.shape({
        /**
         * This should ideally be a locale code and should match the
         * code specified in your i18n config "locales" array
         */
        id: propTypes.string.isRequired,

        /** Display label of language/locale */
        title: propTypes.string.isRequired
      })).isRequired,

      /** Provide a **_translated_** aria-label for the language select component */
      languageAriaLabel: propTypes.string
    }),

    /**
     * Small line at the bottom, including a copyright string and
     * legal links (eg, links to privacy policy and terms of service)
     */
    legal: propTypes.shape({
      /**
       * A list of legal-related links, usually just privacy policy and terms of use.
       * `shape` for each link: `{ display: string, url: string}`
       */
      items: propTypes.arrayOf(propTypes.shape({
        url: propTypes.string.isRequired,
        display: propTypes.string.isRequired
      }))
    }).isRequired,

    /** A function that changes the language based on the locale code passed. */
    onLanguageSelect: propTypes.func.isRequired,

    /**
     * An array of social icons that should be displayed,
     * including the URL they link to. The SVG icon is local to
     * the component library, so when adding a new social link,
     * the icon must also get added to the ui-kit. See the icons
     * object above.
     */
    socialIcons: propTypes.arrayOf(propTypes.shape({
      /** The name of the icon must match the icon component name. */
      name: propTypes.string.isRequired,

      /** The url that the icon links to. */
      url: propTypes.string.isRequired
    })).isRequired
  };

  var propTypes$3 = {
    /** Fill color of the paths */
    color: propTypes.string,
    className: propTypes.string
  };
  var defaultProps$3 = {
    color: colors.black,
    className: null
  };

  var Wordmark = function Wordmark(_ref) {
    var color = _ref.color,
        className = _ref.className;
    var fill = colors[color] || color;
    return /*#__PURE__*/React__default['default'].createElement("svg", {
      className: className,
      width: "101",
      height: "18",
      viewBox: "0 0 101 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-labelledby": "wordmark-title"
    }, /*#__PURE__*/React__default['default'].createElement("title", {
      id: "wordmark-title"
    }, "mmhmm"), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M15.9779 5.13281C18.627 5.13281 20.3104 6.89893 20.3104 9.68609V17.494C20.3104 17.7387 20.1119 17.9372 19.8672 17.9372H15.5104C15.2656 17.9372 15.0672 17.7387 15.0672 17.494V11.0935C15.0672 10.3484 14.7637 9.74127 14.0186 9.74127C13.4559 9.74127 12.9713 10.1054 12.7921 10.7075C12.7813 10.7437 12.7768 10.7814 12.7768 10.8192V17.494C12.7768 17.7387 12.5783 17.9372 12.3336 17.9372H7.97682C7.73204 17.9372 7.53361 17.7387 7.53361 17.494V11.0935C7.53361 10.3484 7.23005 9.74127 6.48497 9.74127C5.92233 9.74127 5.43773 10.1054 5.25846 10.7075C5.24769 10.7437 5.24317 10.7814 5.24317 10.8192V17.494C5.24317 17.7387 5.04474 17.9372 4.79996 17.9372H0.443214C0.198434 17.9372 0 17.7387 0 17.494V5.85198C0 5.6072 0.198433 5.40877 0.443213 5.40877H4.79996C5.04474 5.40877 5.24317 5.6072 5.24317 5.85198V6.42979C5.90546 5.65712 7.14727 5.13281 8.52705 5.13281C9.97962 5.13281 10.9649 5.57883 11.7252 6.24727C11.9033 6.40387 12.1705 6.41502 12.3609 6.27371C13.1233 5.70815 14.3348 5.13281 15.9779 5.13281Z",
      fill: fill
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M37.9715 5.13281C40.6207 5.13281 42.3041 6.89893 42.3041 9.68609V17.494C42.3041 17.7387 42.1056 17.9372 41.8609 17.9372H37.5041C37.2593 17.9372 37.0609 17.7387 37.0609 17.494V11.0935C37.0609 10.3484 36.7573 9.74127 36.0123 9.74127C35.4496 9.74127 34.965 10.1054 34.7858 10.7075C34.775 10.7437 34.7705 10.7814 34.7705 10.8192V17.494C34.7705 17.7387 34.572 17.9372 34.3272 17.9372H29.9705C29.7257 17.9372 29.5273 17.7387 29.5273 17.494V11.0935C29.5273 10.3484 29.2237 9.74127 28.4787 9.74127C27.916 9.74127 27.4314 10.1054 27.2522 10.7075C27.2414 10.7437 27.2369 10.7814 27.2369 10.8192V17.494C27.2369 17.7387 27.0384 17.9372 26.7936 17.9372H22.4369C22.1921 17.9372 21.9937 17.7387 21.9937 17.494V5.85198C21.9937 5.6072 22.1921 5.40877 22.4369 5.40877H26.7936C27.0384 5.40877 27.2369 5.6072 27.2369 5.85198V6.42979C27.8992 5.65712 29.141 5.13281 30.5207 5.13281C31.9733 5.13281 32.9586 5.57883 33.7189 6.24727C33.897 6.40387 34.1642 6.41502 34.3546 6.27371C35.117 5.70815 36.3285 5.13281 37.9715 5.13281Z",
      fill: fill
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M43.9874 0.443213C43.9874 0.198433 44.1859 0 44.4307 0H48.7874C49.0322 0 49.2306 0.198433 49.2306 0.443213V6.42978C49.9205 5.6571 51.1623 5.1328 52.5697 5.1328C55.3016 5.1328 57.0126 6.89892 57.0126 9.68607V17.4939C57.0126 17.7387 56.8141 17.9372 56.5694 17.9372H52.2126C51.9678 17.9372 51.7694 17.7387 51.7694 17.4939V11.0934C51.7694 10.3484 51.3831 9.74125 50.5552 9.74125C49.939 9.74125 49.4268 10.1054 49.246 10.7075C49.2351 10.7437 49.2306 10.7814 49.2306 10.8192V17.4939C49.2306 17.7387 49.0322 17.9372 48.7874 17.9372H44.4307C44.1859 17.9372 43.9874 17.7387 43.9874 17.4939V0.443213Z",
      fill: fill
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M74.6738 5.13281C77.3229 5.13281 79.0063 6.89893 79.0063 9.68609V17.494C79.0063 17.7387 78.8078 17.9372 78.5631 17.9372H74.2063C73.9615 17.9372 73.7631 17.7387 73.7631 17.494V11.0935C73.7631 10.3484 73.4595 9.74127 72.7145 9.74127C72.1518 9.74127 71.6672 10.1054 71.488 10.7075C71.4772 10.7437 71.4727 10.7814 71.4727 10.8192V17.494C71.4727 17.7387 71.2742 17.9372 71.0294 17.9372H66.6727C66.4279 17.9372 66.2295 17.7387 66.2295 17.494V11.0935C66.2295 10.3484 65.9259 9.74127 65.1809 9.74127C64.6182 9.74127 64.1336 10.1054 63.9544 10.7075C63.9436 10.7437 63.9391 10.7814 63.9391 10.8192V17.494C63.9391 17.7387 63.7406 17.9372 63.4958 17.9372H59.1391C58.8943 17.9372 58.6959 17.7387 58.6959 17.494V5.85198C58.6959 5.6072 58.8943 5.40877 59.1391 5.40877H63.4958C63.7406 5.40877 63.9391 5.6072 63.9391 5.85198V6.42979C64.6014 5.65712 65.8432 5.13281 67.2229 5.13281C68.6755 5.13281 69.6608 5.57883 70.4211 6.24727C70.5992 6.40387 70.8664 6.41502 71.0568 6.27371C71.8192 5.70815 73.0307 5.13281 74.6738 5.13281Z",
      fill: fill
    }), /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M96.6675 5.13281C99.3167 5.13281 101 6.89893 101 9.68609V17.494C101 17.7387 100.802 17.9372 100.557 17.9372H96.2C95.9553 17.9372 95.7568 17.7387 95.7568 17.494V11.0935C95.7568 10.3484 95.4533 9.74127 94.7082 9.74127C94.1456 9.74127 93.661 10.1054 93.4817 10.7075C93.4709 10.7437 93.4664 10.7814 93.4664 10.8192V17.494C93.4664 17.7387 93.268 17.9372 93.0232 17.9372H88.6664C88.4217 17.9372 88.2232 17.7387 88.2232 17.494V11.0935C88.2232 10.3484 87.9197 9.74127 87.1746 9.74127C86.612 9.74127 86.1274 10.1054 85.9481 10.7075C85.9373 10.7437 85.9328 10.7814 85.9328 10.8192V17.494C85.9328 17.7387 85.7344 17.9372 85.4896 17.9372H81.1328C80.8881 17.9372 80.6896 17.7387 80.6896 17.494V5.85198C80.6896 5.6072 80.8881 5.40877 81.1328 5.40877H85.4896C85.7344 5.40877 85.9328 5.6072 85.9328 5.85198V6.42979C86.5951 5.65712 87.8369 5.13281 89.2167 5.13281C90.6693 5.13281 91.6546 5.57883 92.4148 6.24727C92.593 6.40387 92.8601 6.41502 93.0506 6.27371C93.8129 5.70815 95.0244 5.13281 96.6675 5.13281Z",
      fill: fill
    }));
  };

  Wordmark.propTypes = propTypes$3;
  Wordmark.defaultProps = defaultProps$3;

  function canUseDOM$1() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
  }

  /**
   * React currently throws a warning when using useLayoutEffect on the server. To
   * get around it, we can conditionally useEffect on the server (no-op) and
   * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
   * ensure we don't get a render flash for certain operations, but we may also
   * need affected components to render on the server. One example is when setting
   * a component's descendants to retrieve their index values.
   *
   * Important to note that using this hook as an escape hatch will break the
   * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
   * Use sparingly only when the effect won't effect the rendered HTML to avoid
   * any server/client mismatch.
   *
   * If a useLayoutEffect is needed and the result would create a mismatch, it's
   * likely that the component in question shouldn't be rendered on the server at
   * all, so a better approach would be to lazily render those in a parent
   * component after client-side hydration.
   *
   * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
   * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
   *
   * @param effect
   * @param deps
   */

  var useIsomorphicLayoutEffect = /*#__PURE__*/canUseDOM$1() ? React.useLayoutEffect : React.useEffect;

  /*
   * Welcome to @reach/auto-id!

   * Let's see if we can make sense of why this hook exists and its
   * implementation.
   *
   * Some background:
   *   1. Accessibility APIs rely heavily on element IDs
   *   2. Requiring developers to put IDs on every element in Reach UI is both
   *      cumbersome and error-prone
   *   3. With a component model, we can generate IDs for them!
   *
   * Solution 1: Generate random IDs.
   *
   * This works great as long as you don't server render your app. When React (in
   * the client) tries to reuse the markup from the server, the IDs won't match
   * and React will then recreate the entire DOM tree.
   *
   * Solution 2: Increment an integer
   *
   * This sounds great. Since we're rendering the exact same tree on the server
   * and client, we can increment a counter and get a deterministic result between
   * client and server. Also, JS integers can go up to nine-quadrillion. I'm
   * pretty sure the tab will be closed before an app never needs
   * 10 quadrillion IDs!
   *
   * Problem solved, right?
   *
   * Ah, but there's a catch! React's concurrent rendering makes this approach
   * non-deterministic. While the client and server will end up with the same
   * elements in the end, depending on suspense boundaries (and possibly some user
   * input during the initial render) the incrementing integers won't always match
   * up.
   *
   * Solution 3: Don't use IDs at all on the server; patch after first render.
   *
   * What we've done here is solution 2 with some tricks. With this approach, the
   * ID returned is an empty string on the first render. This way the server and
   * client have the same markup no matter how wild the concurrent rendering may
   * have gotten.
   *
   * After the render, we patch up the components with an incremented ID. This
   * causes a double render on any components with `useId`. Shouldn't be a problem
   * since the components using this hook should be small, and we're only updating
   * the ID attribute on the DOM, nothing big is happening.
   *
   * It doesn't have to be an incremented number, though--we could do generate
   * random strings instead, but incrementing a number is probably the cheapest
   * thing we can do.
   *
   * Additionally, we only do this patchup on the very first client render ever.
   * Any calls to `useId` that happen dynamically in the client will be
   * populated immediately with a value. So, we only get the double render after
   * server hydration and never again, SO BACK OFF ALRIGHT?
   */
  var serverHandoffComplete = false;
  var id = 0;

  var genId = function genId() {
    return ++id;
  };
  /**
   * useId
   *
   * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
   *
   * Note: The returned ID will initially be `null` and will update after a
   * component mounts. Users may need to supply their own ID if they need
   * consistent values for SSR.
   *
   * @see Docs https://reach.tech/auto-id
   */


  function useId(idFromProps) {
    /*
     * If this instance isn't part of the initial render, we don't have to do the
     * double render/patch-up dance. We can just generate the ID and return it.
     */
    var initialId = idFromProps || (serverHandoffComplete ? genId() : null);

    var _React$useState = React.useState(initialId),
        id = _React$useState[0],
        setId = _React$useState[1];

    useIsomorphicLayoutEffect(function () {
      if (id === null) {
        /*
         * Patch the ID after render. We do this in `useLayoutEffect` to avoid any
         * rendering flicker, though it'll make the first render slower (unlikely
         * to matter, but you're welcome to measure your app and let us know if
         * it's a problem).
         */
        setId(genId());
      } // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);
    React.useEffect(function () {
      if (serverHandoffComplete === false) {
        /*
         * Flag all future uses of `useId` to skip the update dance. This is in
         * `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
         * accidentally bail out of the patch-up dance prematurely.
         */
        serverHandoffComplete = true;
      }
    }, []);
    return id != null ? String(id) : undefined;
  }

  /**
   * Forces a re-render, similar to `forceUpdate` in class components.
   */

  function useForceUpdate() {
    var _useState = React.useState(Object.create(null)),
        dispatch = _useState[1];

    return React.useCallback(function () {
      dispatch(Object.create(null));
    }, []);
  }

  /**
   * Welcome to @reach/portal!
   *
   * Creates and appends a DOM node to the end of `document.body` and renders a
   * React tree into it. Useful for rendering a natural React element hierarchy
   * with a different DOM hierarchy to prevent parent styles from clipping or
   * hiding content (for popovers, dropdowns, and modals).
   *
   * @see Docs   https://reach.tech/portal
   * @see Source https://github.com/reach/reach-ui/tree/main/packages/portal
   * @see React  https://reactjs.org/docs/portals.html
   */
  /**
   * Portal
   *
   * @see Docs https://reach.tech/portal#portal
   */

  var Portal$2 = function Portal(_ref) {
    var children = _ref.children,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? "reach-portal" : _ref$type;
    var mountNode = React.useRef(null);
    var portalNode = React.useRef(null);
    var forceUpdate = useForceUpdate();
    useIsomorphicLayoutEffect(function () {
      // This ref may be null when a hot-loader replaces components on the page
      if (!mountNode.current) return; // It's possible that the content of the portal has, itself, been portaled.
      // In that case, it's important to append to the correct document element.

      var ownerDocument = mountNode.current.ownerDocument;
      portalNode.current = ownerDocument == null ? void 0 : ownerDocument.createElement(type);
      ownerDocument.body.appendChild(portalNode.current);
      forceUpdate();
      return function () {
        if (portalNode.current && portalNode.current.ownerDocument) {
          portalNode.current.ownerDocument.body.removeChild(portalNode.current);
        }
      };
    }, [type, forceUpdate]);
    return portalNode.current ? /*#__PURE__*/reactDom.createPortal(children, portalNode.current) : /*#__PURE__*/React.createElement("span", {
      ref: mountNode
    });
  };
  /**
   * @see Docs https://reach.tech/portal#portal-props
   */


  if (process.env.NODE_ENV !== "production") {
    Portal$2.displayName = "Portal";
  } ////////////////////////////////////////////////////////////////////////////////

  var props = ["bottom", "height", "left", "right", "top", "width"];

  var rectChanged = function rectChanged(a, b) {
    if (a === void 0) {
      a = {};
    }

    if (b === void 0) {
      b = {};
    }

    return props.some(function (prop) {
      return a[prop] !== b[prop];
    });
  };

  var observedNodes = /*#__PURE__*/new Map();
  var rafId;

  var run = function run() {
    var changedStates = [];
    observedNodes.forEach(function (state, node) {
      var newRect = node.getBoundingClientRect();

      if (rectChanged(newRect, state.rect)) {
        state.rect = newRect;
        changedStates.push(state);
      }
    });
    changedStates.forEach(function (state) {
      state.callbacks.forEach(function (cb) {
        return cb(state.rect);
      });
    });
    rafId = window.requestAnimationFrame(run);
  };

  function observeRect(node, cb) {
    return {
      observe: function observe() {
        var wasEmpty = observedNodes.size === 0;

        if (observedNodes.has(node)) {
          observedNodes.get(node).callbacks.push(cb);
        } else {
          observedNodes.set(node, {
            rect: undefined,
            hasRectChanged: false,
            callbacks: [cb]
          });
        }

        if (wasEmpty) run();
      },
      unobserve: function unobserve() {
        var state = observedNodes.get(node);

        if (state) {
          // Remove the callback
          var index = state.callbacks.indexOf(cb);
          if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference

          if (!state.callbacks.length) observedNodes["delete"](node); // Stop the loop

          if (!observedNodes.size) cancelAnimationFrame(rafId);
        }
      }
    };
  }

  /**
   * Checks whether or not a value is a boolean.
   *
   * @param value
   */
  function isBoolean(value) {
    return typeof value === "boolean";
  }
  /**
   * Checks whether or not a value is a function.
   *
   * @param value
   */

  function isFunction(value) {
    // eslint-disable-next-line eqeqeq
    return !!(value && {}.toString.call(value) == "[object Function]");
  }
  /**
   * Checks whether or not a value is a string.
   *
   * @param value
   */

  function isString(value) {
    return typeof value === "string";
  }

  var isProduction = process.env.NODE_ENV === 'production';
  function warning(condition, message) {
    if (!isProduction) {
      if (condition) {
        return;
      }

      var text = "Warning: " + message;

      if (typeof console !== 'undefined') {
        console.warn(text);
      }

      try {
        throw Error(text);
      } catch (x) {}
    }
  }

  /**
   * @see Docs https://reach.tech/rect#rect-props
   */


  if (process.env.NODE_ENV !== "production") {
    ({
      children: propTypes.func.isRequired,
      observe: propTypes.bool,
      onChange: propTypes.func
    });
  } ////////////////////////////////////////////////////////////////////////////////


  /**
   * useRect
   *
   * @param nodeRef
   * @param observe
   * @param onChange
   */
  function useRect(nodeRef, observeOrOptions, deprecated_onChange) {
    var observe;
    var onChange;

    if (isBoolean(observeOrOptions)) {
      observe = observeOrOptions;
    } else {
      var _observeOrOptions$obs;

      observe = (_observeOrOptions$obs = observeOrOptions == null ? void 0 : observeOrOptions.observe) != null ? _observeOrOptions$obs : true;
      onChange = observeOrOptions == null ? void 0 : observeOrOptions.onChange;
    }

    if (isFunction(deprecated_onChange)) {
      onChange = deprecated_onChange;
    }

    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useEffect(function () {
        process.env.NODE_ENV !== "production" ? warning(!isBoolean(observeOrOptions), "Passing `observe` as the second argument to `useRect` is deprecated and will be removed in a future version of Reach UI. Instead, you can pass an object of options with an `observe` property as the second argument (`useRect(ref, { observe })`).\n" + "See https://reach.tech/rect#userect-observe") : void 0;
      }, [observeOrOptions]); // eslint-disable-next-line react-hooks/rules-of-hooks

      React.useEffect(function () {
        process.env.NODE_ENV !== "production" ? warning(!isFunction(deprecated_onChange), "Passing `onChange` as the third argument to `useRect` is deprecated and will be removed in a future version of Reach UI. Instead, you can pass an object of options with an `onChange` property as the second argument (`useRect(ref, { onChange })`).\n" + "See https://reach.tech/rect#userect-onchange") : void 0;
      }, [deprecated_onChange]);
    }

    var _React$useState = React.useState(nodeRef.current),
        element = _React$useState[0],
        setElement = _React$useState[1];

    var initialRectIsSet = React.useRef(false);
    var initialRefIsSet = React.useRef(false);

    var _React$useState2 = React.useState(null),
        rect = _React$useState2[0],
        setRect = _React$useState2[1];

    var onChangeRef = React.useRef(onChange); // eslint-disable-next-line react-hooks/exhaustive-deps

    useIsomorphicLayoutEffect(function () {
      onChangeRef.current = onChange;

      if (nodeRef.current !== element) {
        setElement(nodeRef.current);
      }
    });
    useIsomorphicLayoutEffect(function () {
      if (element && !initialRectIsSet.current) {
        initialRectIsSet.current = true;
        setRect(element.getBoundingClientRect());
      }
    }, [element]);
    useIsomorphicLayoutEffect(function () {
      if (!observe) {
        return;
      }

      var elem = element; // State initializes before refs are placed, meaning the element state will
      // be undefined on the first render. We still want the rect on the first
      // render, so initially we'll use the nodeRef that was passed instead of
      // state for our measurements.

      if (!initialRefIsSet.current) {
        initialRefIsSet.current = true;
        elem = nodeRef.current;
      }

      if (!elem) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("You need to place the ref");
        }

        return;
      }

      var observer = observeRect(elem, function (rect) {
        onChangeRef.current == null ? void 0 : onChangeRef.current(rect);
        setRect(rect);
      });
      observer.observe();
      return function () {
        observer.unobserve();
      };
    }, [observe, element, nodeRef]);
    return rect;
  }

  /**
   * Get an element's owner document. Useful when components are used in iframes
   * or other environments like dev tools.
   *
   * @param element
   */

  function getOwnerDocument(element) {
    return canUseDOM$1() ? element ? element.ownerDocument : document : null;
  }

  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }

  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    it = o[Symbol.iterator]();
    return it.next.bind(it);
  }

  /**
   * Passes or assigns an arbitrary value to a ref function or object.
   *
   * @param ref
   * @param value
   */
  function assignRef(ref, value) {
    if (ref == null) return;

    if (isFunction(ref)) {
      ref(value);
    } else {
      try {
        ref.current = value;
      } catch (error) {
        throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
      }
    }
  }
  /**
   * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
   * dealing with components that need an explicit ref for DOM calculations but
   * also forwards refs assigned by an app.
   *
   * @param refs Refs to fork
   */

  function useComposedRefs() {
    for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
      refs[_key] = arguments[_key];
    }

    return React.useCallback(function (node) {
      for (var _iterator = _createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done;) {
        var ref = _step.value;
        assignRef(ref, node);
      } // eslint-disable-next-line react-hooks/exhaustive-deps

    }, refs);
  }

  var candidateSelectors = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
  ];
  var candidateSelector = candidateSelectors.join(',');

  var matches = typeof Element === 'undefined'
    ? function () {}
    : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

  function tabbable(el, options) {
    options = options || {};

    var regularTabbables = [];
    var orderedTabbables = [];

    var candidates = el.querySelectorAll(candidateSelector);

    if (options.includeContainer) {
      if (matches.call(el, candidateSelector)) {
        candidates = Array.prototype.slice.apply(candidates);
        candidates.unshift(el);
      }
    }

    var i, candidate, candidateTabindex;
    for (i = 0; i < candidates.length; i++) {
      candidate = candidates[i];

      if (!isNodeMatchingSelectorTabbable(candidate)) continue;

      candidateTabindex = getTabindex(candidate);
      if (candidateTabindex === 0) {
        regularTabbables.push(candidate);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          node: candidate,
        });
      }
    }

    var tabbableNodes = orderedTabbables
      .sort(sortOrderedTabbables)
      .map(function(a) { return a.node })
      .concat(regularTabbables);

    return tabbableNodes;
  }

  tabbable.isTabbable = isTabbable;
  tabbable.isFocusable = isFocusable$1;

  function isNodeMatchingSelectorTabbable(node) {
    if (
      !isNodeMatchingSelectorFocusable(node)
      || isNonTabbableRadio(node)
      || getTabindex(node) < 0
    ) {
      return false;
    }
    return true;
  }

  function isTabbable(node) {
    if (!node) throw new Error('No node provided');
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(node);
  }

  function isNodeMatchingSelectorFocusable(node) {
    if (
      node.disabled
      || isHiddenInput(node)
      || isHidden(node)
    ) {
      return false;
    }
    return true;
  }

  var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
  function isFocusable$1(node) {
    if (!node) throw new Error('No node provided');
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(node);
  }

  function getTabindex(node) {
    var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
    if (!isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if (isContentEditable(node)) return 0;
    return node.tabIndex;
  }

  function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  }

  function isContentEditable(node) {
    return node.contentEditable === 'true';
  }

  function isInput(node) {
    return node.tagName === 'INPUT';
  }

  function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  }

  function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  }

  function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  }

  function getCheckedRadio(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked) {
        return nodes[i];
      }
    }
  }

  function isTabbableRadio(node) {
    if (!node.name) return true;
    // This won't account for the edge case where you have radio groups with the same
    // in separate forms on the same page.
    var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
    var checked = getCheckedRadio(radioSet);
    return !checked || checked === node;
  }

  function isHidden(node) {
    // offsetParent being null will allow detecting cases where an element is invisible or inside an invisible element,
    // as long as the element does not use position: fixed. For them, their visibility has to be checked directly as well.
    return node.offsetParent === null || getComputedStyle(node).visibility === 'hidden';
  }

  var tabbable_1 = tabbable;

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  var _excluded$6 = ["as", "targetRef", "position", "unstable_observableRefs"];
  ////////////////////////////////////////////////////////////////////////////////

  /**
   * Popover
   */
  var Popover = /*#__PURE__*/React.forwardRef(function Popover(props, ref) {
    return /*#__PURE__*/React.createElement(Portal$2, null, /*#__PURE__*/React.createElement(PopoverImpl, _extends$1({
      ref: ref
    }, props)));
  });

  if (process.env.NODE_ENV !== "production") {
    Popover.displayName = "Popover";
  } ////////////////////////////////////////////////////////////////////////////////

  /**
   * PopoverImpl
   *
   * Popover is conditionally rendered so we can't start measuring until it shows
   * up, so useRect needs to live down here not up in Popover
   */


  var PopoverImpl = /*#__PURE__*/React.forwardRef(function PopoverImpl(_ref, forwardedRef) {
    var _ref$as = _ref.as,
        Comp = _ref$as === void 0 ? "div" : _ref$as,
        targetRef = _ref.targetRef,
        _ref$position = _ref.position,
        position = _ref$position === void 0 ? positionDefault : _ref$position,
        _ref$unstable_observa = _ref.unstable_observableRefs,
        unstable_observableRefs = _ref$unstable_observa === void 0 ? [] : _ref$unstable_observa,
        props = _objectWithoutPropertiesLoose$1(_ref, _excluded$6);

    var popoverRef = React.useRef(null);
    var popoverRect = useRect(popoverRef, {
      observe: !props.hidden
    });
    var targetRect = useRect(targetRef, {
      observe: !props.hidden
    });
    var ref = useComposedRefs(popoverRef, forwardedRef);
    useSimulateTabNavigationForReactTree(targetRef, popoverRef);
    return /*#__PURE__*/React.createElement(Comp, _extends$1({
      "data-reach-popover": "",
      ref: ref
    }, props, {
      style: _extends$1({
        position: "absolute"
      }, getStyles.apply(void 0, [position, targetRect, popoverRect].concat(unstable_observableRefs)), props.style)
    }));
  });

  if (process.env.NODE_ENV !== "production") {
    PopoverImpl.displayName = "PopoverImpl";
  } ////////////////////////////////////////////////////////////////////////////////


  function getStyles(position, targetRect, popoverRect) {
    for (var _len = arguments.length, unstable_observableRefs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      unstable_observableRefs[_key - 3] = arguments[_key];
    }

    return popoverRect ? position.apply(void 0, [targetRect, popoverRect].concat(unstable_observableRefs.map(function (ref) {
      return ref.current;
    }))) : {
      visibility: "hidden"
    };
  }

  function getTopPosition(targetRect, popoverRect, isDirectionUp) {
    return {
      top: isDirectionUp ? targetRect.top - popoverRect.height + window.pageYOffset + "px" : targetRect.top + targetRect.height + window.pageYOffset + "px"
    };
  }

  var positionDefault = function positionDefault(targetRect, popoverRect) {
    if (!targetRect || !popoverRect) {
      return {};
    }

    var _getCollisions = getCollisions(targetRect, popoverRect),
        directionRight = _getCollisions.directionRight,
        directionUp = _getCollisions.directionUp;

    return _extends$1({
      left: directionRight ? targetRect.right - popoverRect.width + window.pageXOffset + "px" : targetRect.left + window.pageXOffset + "px"
    }, getTopPosition(targetRect, popoverRect, directionUp));
  };

  var positionMatchWidth = function positionMatchWidth(targetRect, popoverRect) {
    if (!targetRect || !popoverRect) {
      return {};
    }

    var _getCollisions3 = getCollisions(targetRect, popoverRect),
        directionUp = _getCollisions3.directionUp;

    return _extends$1({
      width: targetRect.width,
      left: targetRect.left
    }, getTopPosition(targetRect, popoverRect, directionUp));
  };

  function getCollisions(targetRect, popoverRect, offsetLeft, offsetBottom) {
    if (offsetLeft === void 0) {
      offsetLeft = 0;
    }

    if (offsetBottom === void 0) {
      offsetBottom = 0;
    }

    var collisions = {
      top: targetRect.top - popoverRect.height < 0,
      right: window.innerWidth < targetRect.left + popoverRect.width - offsetLeft,
      bottom: window.innerHeight < targetRect.bottom + popoverRect.height - offsetBottom,
      left: targetRect.left + targetRect.width - popoverRect.width < 0
    };
    var directionRight = collisions.right && !collisions.left;
    var directionLeft = collisions.left && !collisions.right;
    var directionUp = collisions.bottom && !collisions.top;
    var directionDown = collisions.top && !collisions.bottom;
    return {
      directionRight: directionRight,
      directionLeft: directionLeft,
      directionUp: directionUp,
      directionDown: directionDown
    };
  } // Heads up, my jQuery past haunts this function. This hook scopes the tab
  // order to the React element tree, instead of the DOM tree. This way, when the
  // user navigates with tab from the targetRef, the tab order moves into the
  // popup, and then out of the popup back to the rest of the document.
  // (We call targetRef, triggerRef inside this function to avoid confusion with
  // event.target)


  function useSimulateTabNavigationForReactTree(triggerRef, popoverRef) {
    var ownerDocument = getOwnerDocument(triggerRef.current);

    function handleKeyDown(event) {
      if (event.key === "Tab" && popoverRef.current && tabbable_1(popoverRef.current).length === 0) {
        return;
      }

      if (event.key === "Tab" && event.shiftKey) {
        if (shiftTabbedFromElementAfterTrigger(event)) {
          focusLastTabbableInPopover(event);
        } else if (shiftTabbedOutOfPopover(event)) {
          focusTriggerRef(event);
        } else if (shiftTabbedToBrowserChrome(event)) {
          disableTabbablesInPopover();
        }
      } else if (event.key === "Tab") {
        if (tabbedFromTriggerToPopover()) {
          focusFirstPopoverTabbable(event);
        } else if (tabbedOutOfPopover()) {
          focusTabbableAfterTrigger(event);
        } else if (tabbedToBrowserChrome(event)) {
          disableTabbablesInPopover();
        }
      }
    }

    React.useEffect(function () {
      ownerDocument.addEventListener("keydown", handleKeyDown);
      return function () {
        ownerDocument.removeEventListener("keydown", handleKeyDown);
      }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getElementAfterTrigger() {
      var elements = tabbable_1(ownerDocument);
      var targetIndex = elements && triggerRef.current ? elements.indexOf(triggerRef.current) : -1;
      var elementAfterTrigger = elements && elements[targetIndex + 1];
      return popoverRef.current && popoverRef.current.contains(elementAfterTrigger || null) ? false : elementAfterTrigger;
    }

    function tabbedFromTriggerToPopover() {
      return triggerRef.current ? triggerRef.current === ownerDocument.activeElement : false;
    }

    function focusFirstPopoverTabbable(event) {
      var elements = popoverRef.current && tabbable_1(popoverRef.current);

      if (elements && elements[0]) {
        event.preventDefault();
        elements[0].focus();
      }
    }

    function tabbedOutOfPopover() {
      var inPopover = popoverRef.current ? popoverRef.current.contains(ownerDocument.activeElement || null) : false;

      if (inPopover) {
        var elements = popoverRef.current && tabbable_1(popoverRef.current);
        return Boolean(elements && elements[elements.length - 1] === ownerDocument.activeElement);
      }

      return false;
    }

    function focusTabbableAfterTrigger(event) {
      var elementAfterTrigger = getElementAfterTrigger();

      if (elementAfterTrigger) {
        event.preventDefault();
        elementAfterTrigger.focus();
      }
    }

    function shiftTabbedFromElementAfterTrigger(event) {
      if (!event.shiftKey) return;
      var elementAfterTrigger = getElementAfterTrigger();
      return event.target === elementAfterTrigger;
    }

    function focusLastTabbableInPopover(event) {
      var elements = popoverRef.current && tabbable_1(popoverRef.current);
      var last = elements && elements[elements.length - 1];

      if (last) {
        event.preventDefault();
        last.focus();
      }
    }

    function shiftTabbedOutOfPopover(event) {
      var elements = popoverRef.current && tabbable_1(popoverRef.current);

      if (elements) {
        return elements.length === 0 ? false : event.target === elements[0];
      }

      return false;
    }

    function focusTriggerRef(event) {
      var _triggerRef$current;

      event.preventDefault();
      (_triggerRef$current = triggerRef.current) == null ? void 0 : _triggerRef$current.focus();
    }

    function tabbedToBrowserChrome(event) {
      var elements = popoverRef.current ? tabbable_1(ownerDocument).filter(function (element) {
        return !popoverRef.current.contains(element);
      }) : null;
      return elements ? event.target === elements[elements.length - 1] : false;
    }

    function shiftTabbedToBrowserChrome(event) {
      // we're assuming the popover will never contain the first tabbable
      // element, and it better not, because the trigger needs to be tabbable!
      return event.target === tabbable_1(ownerDocument)[0];
    }

    var restoreTabIndexTuplés = [];

    function disableTabbablesInPopover() {
      var elements = popoverRef.current && tabbable_1(popoverRef.current);

      if (elements) {
        elements.forEach(function (element) {
          restoreTabIndexTuplés.push([element, element.tabIndex]);
          element.tabIndex = -1;
        });
        ownerDocument.addEventListener("focusin", enableTabbablesInPopover);
      }
    }

    function enableTabbablesInPopover() {
      ownerDocument.removeEventListener("focusin", enableTabbablesInPopover);
      restoreTabIndexTuplés.forEach(function (_ref2) {
        var element = _ref2[0],
            tabIndex = _ref2[1];
        element.tabIndex = tabIndex;
      });
    }
  } ////////////////////////////////////////////////////////////////////////////////

  function createNamedContext(name, defaultValue) {
    var Ctx = /*#__PURE__*/React.createContext(defaultValue);

    if (process.env.NODE_ENV !== "production") {
      Ctx.displayName = name;
    }

    return Ctx;
  }

  function noop$1() {}

  function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _extends$2() {
    _extends$2 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$2.apply(this, arguments);
  }

  var _excluded$7 = ["element", "index"];

  function createDescendantContext(name, initialValue) {
    if (initialValue === void 0) {
      initialValue = {};
    }

    var descendants = [];
    return createNamedContext(name, _extends$2({
      descendants: descendants,
      registerDescendant: noop$1,
      unregisterDescendant: noop$1
    }, initialValue));
  }
  /**
   * This hook registers our descendant by passing it into an array. We can then
   * search that array by to find its index when registering it in the component.
   * We use this for focus management, keyboard navigation, and typeahead
   * functionality for some components.
   *
   * The hook accepts the element node and (optionally) a key. The key is useful
   * if multiple descendants have identical text values and we need to
   * differentiate siblings for some reason.
   *
   * Our main goals with this are:
   *   1) maximum composability,
   *   2) minimal API friction
   *   3) SSR compatibility*
   *   4) concurrent safe
   *   5) index always up-to-date with the tree despite changes
   *   6) works with memoization of any component in the tree (hopefully)
   *
   * As for SSR, the good news is that we don't actually need the index on the
   * server for most use-cases, as we are only using it to determine the order of
   * composed descendants for keyboard navigation. However, in the few cases where
   * this is not the case, we can require an explicit index from the app.
   */


  function useDescendant(descendant, context, indexProp) {
    var forceUpdate = useForceUpdate();

    var _React$useContext = React.useContext(context),
        registerDescendant = _React$useContext.registerDescendant,
        unregisterDescendant = _React$useContext.unregisterDescendant,
        descendants = _React$useContext.descendants; // This will initially return -1 because we haven't registered the descendant
    // on the first render. After we register, this will then return the correct
    // index on the following render and we will re-register descendants so that
    // everything is up-to-date before the user interacts with a collection.


    var index = indexProp != null ? indexProp : descendants.findIndex(function (item) {
      return item.element === descendant.element;
    }); // Prevent any flashing

    useIsomorphicLayoutEffect(function () {
      if (!descendant.element) forceUpdate();
      registerDescendant(_extends$2({}, descendant, {
        index: index
      }));
      return function () {
        unregisterDescendant(descendant.element);
      };
    }, [descendant, forceUpdate, index, registerDescendant, unregisterDescendant].concat(Object.values(descendant)));
    return index;
  }

  function useDescendantsInit() {
    return React.useState([]);
  }

  function useDescendants(ctx) {
    return React.useContext(ctx).descendants;
  }

  function DescendantProvider(_ref) {
    var Ctx = _ref.context,
        children = _ref.children,
        items = _ref.items,
        set = _ref.set;
    var registerDescendant = React.useCallback(function (_ref2) {
      var element = _ref2.element,
          explicitIndex = _ref2.index,
          rest = _objectWithoutPropertiesLoose$2(_ref2, _excluded$7);

      if (!element) {
        return;
      }

      set(function (items) {
        var newItems;

        if (explicitIndex != null) {
          return [].concat(items, [_extends$2({}, rest, {
            element: element,
            index: explicitIndex
          })]).sort(function (a, b) {
            return a.index - b.index;
          });
        } else if (items.length === 0) {
          // If there are no items, register at index 0 and bail.
          newItems = [_extends$2({}, rest, {
            element: element,
            index: 0
          })];
        } else if (items.find(function (item) {
          return item.element === element;
        })) {
          // If the element is already registered, just use the same array
          newItems = items;
        } else {
          // When registering a descendant, we need to make sure we insert in
          // into the array in the same order that it appears in the DOM. So as
          // new descendants are added or maybe some are removed, we always know
          // that the array is up-to-date and correct.
          //
          // So here we look at our registered descendants and see if the new
          // element we are adding appears earlier than an existing descendant's
          // DOM node via `node.compareDocumentPosition`. If it does, we insert
          // the new element at this index. Because `registerDescendant` will be
          // called in an effect every time the descendants state value changes,
          // we should be sure that this index is accurate when descendent
          // elements come or go from our component.
          var index = items.findIndex(function (item) {
            if (!item.element || !element) {
              return false;
            } // Does this element's DOM node appear before another item in the
            // array in our DOM tree? If so, return true to grab the index at
            // this point in the array so we know where to insert the new
            // element.


            return Boolean(item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING);
          });

          var newItem = _extends$2({}, rest, {
            element: element,
            index: index
          }); // If an index is not found we will push the element to the end.


          if (index === -1) {
            newItems = [].concat(items, [newItem]);
          } else {
            newItems = [].concat(items.slice(0, index), [newItem], items.slice(index));
          }
        }

        return newItems.map(function (item, index) {
          return _extends$2({}, item, {
            index: index
          });
        });
      });
    }, // set is a state setter initialized by the useDescendantsInit hook.
    // We can safely ignore the lint warning here because it will not change
    // between renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var unregisterDescendant = React.useCallback(function (element) {
      if (!element) {
        return;
      }

      set(function (items) {
        return items.filter(function (item) {
          return element !== item.element;
        });
      });
    }, // set is a state setter initialized by the useDescendantsInit hook.
    // We can safely ignore the lint warning here because it will not change
    // between renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/React.createElement(Ctx.Provider, {
      value: React.useMemo(function () {
        return {
          descendants: items,
          registerDescendant: registerDescendant,
          unregisterDescendant: unregisterDescendant
        };
      }, [items, registerDescendant, unregisterDescendant])
    }, children);
  }
  /**
   * Testing this as an abstraction for compound components that use keyboard
   * navigation. Hoping this will help us prevent bugs and mismatched behavior
   * across various components, but it may also prove to be too messy of an
   * abstraction in the end.
   *
   * Currently used in:
   *   - Tabs
   *   - Accordion
   *
   * @param context
   * @param options
   */


  function useDescendantKeyDown(context, options) {
    var _React$useContext2 = React.useContext(context),
        descendants = _React$useContext2.descendants;

    var callback = options.callback,
        currentIndex = options.currentIndex,
        filter = options.filter,
        _options$key = options.key,
        key = _options$key === void 0 ? "index" : _options$key,
        _options$orientation = options.orientation,
        orientation = _options$orientation === void 0 ? "vertical" : _options$orientation,
        _options$rotate = options.rotate,
        rotate = _options$rotate === void 0 ? true : _options$rotate,
        _options$rtl = options.rtl,
        rtl = _options$rtl === void 0 ? false : _options$rtl;
    return function handleKeyDown(event) {
      if (!["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(event.key)) {
        return;
      }

      var index = currentIndex != null ? currentIndex : -1; // If we use a filter function, we need to re-index our descendants array
      // so that filtered descendent elements aren't selected.

      var selectableDescendants = filter ? descendants.filter(filter) : descendants; // We need some options for any of this to work!

      if (!selectableDescendants.length) {
        return;
      }

      var selectableIndex = selectableDescendants.findIndex(function (descendant) {
        return descendant.index === currentIndex;
      });

      function getNextOption() {
        var atBottom = index === getLastOption().index;
        return atBottom ? rotate ? getFirstOption() : selectableDescendants[selectableIndex] : selectableDescendants[(selectableIndex + 1) % selectableDescendants.length];
      }

      function getPreviousOption() {
        var atTop = index === getFirstOption().index;
        return atTop ? rotate ? getLastOption() : selectableDescendants[selectableIndex] : selectableDescendants[(selectableIndex - 1 + selectableDescendants.length) % selectableDescendants.length];
      }

      function getFirstOption() {
        return selectableDescendants[0];
      }

      function getLastOption() {
        return selectableDescendants[selectableDescendants.length - 1];
      }

      switch (event.key) {
        case "ArrowDown":
          if (orientation === "vertical" || orientation === "both") {
            event.preventDefault();
            var next = getNextOption();
            callback(key === "option" ? next : next[key]);
          }

          break;

        case "ArrowUp":
          if (orientation === "vertical" || orientation === "both") {
            event.preventDefault();
            var prev = getPreviousOption();
            callback(key === "option" ? prev : prev[key]);
          }

          break;

        case "ArrowLeft":
          if (orientation === "horizontal" || orientation === "both") {
            event.preventDefault();
            var nextOrPrev = (rtl ? getNextOption : getPreviousOption)();
            callback(key === "option" ? nextOrPrev : nextOrPrev[key]);
          }

          break;

        case "ArrowRight":
          if (orientation === "horizontal" || orientation === "both") {
            event.preventDefault();
            var prevOrNext = (rtl ? getPreviousOption : getNextOption)();
            callback(key === "option" ? prevOrNext : prevOrNext[key]);
          }

          break;

        case "PageUp":
          event.preventDefault();
          var prevOrFirst = (event.ctrlKey ? getPreviousOption : getFirstOption)();
          callback(key === "option" ? prevOrFirst : prevOrFirst[key]);
          break;

        case "Home":
          event.preventDefault();
          var first = getFirstOption();
          callback(key === "option" ? first : first[key]);
          break;

        case "PageDown":
          event.preventDefault();
          var nextOrLast = (event.ctrlKey ? getNextOption : getLastOption)();
          callback(key === "option" ? nextOrLast : nextOrLast[key]);
          break;

        case "End":
          event.preventDefault();
          var last = getLastOption();
          callback(key === "option" ? last : last[key]);
          break;
      }
    };
  } ////////////////////////////////////////////////////////////////////////////////

  /**
   * Detects right clicks
   *
   * @param nativeEvent
   */
  function isRightClick(nativeEvent) {
    return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
  }

  /* eslint-disable react-hooks/rules-of-hooks */

  /**
   * Converts a callback to a ref to avoid triggering re-renders when passed as a
   * prop and exposed as a stable function to avoid executing effects when
   * passed as a dependency.
   */
  function createStableCallbackHook(useEffectHook, callback) {
    var callbackRef = React.useRef(callback);
    useEffectHook(function () {
      callbackRef.current = callback;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps

    return React.useCallback(function () {
      callbackRef.current && callbackRef.current.apply(callbackRef, arguments);
    }, []);
  }
  /**
   * Converts a callback to a ref to avoid triggering re-renders when passed as a
   * prop and exposed as a stable function to avoid executing effects when passed
   * as a dependency.
   */


  function useStableCallback(callback) {
    return createStableCallbackHook(React.useEffect, callback);
  }

  /**
   * Joins strings to format IDs for compound components.
   *
   * @param args
   */
  function makeId() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.filter(function (val) {
      return val != null;
    }).join("--");
  }

  /* eslint-disable react-hooks/rules-of-hooks */
  var checkedPkgs = {};
  /**
   * When in dev mode, checks that styles for a given `@reach` package are loaded.
   *
   * @param packageName Name of the package to check.
   * @example checkStyles("dialog") will check for styles for @reach/dialog
   */

  function checkStyles(packageName) {
    if (process.env.NODE_ENV !== "production") {
      // In CJS files, process.env.NODE_ENV is stripped from our build, but we
      // need it to prevent style checks from clogging up user logs while testing.
      // This is a workaround until we can tweak the build a bit to accommodate.
      var _ref = typeof process !== "undefined" ? process.env : {
        NODE_ENV: "development"
      },
          environment = _ref.NODE_ENV; // only check once per package


      if (checkedPkgs[packageName]) return;
      checkedPkgs[packageName] = true;

      if (environment === "development" && parseInt(window.getComputedStyle(document.body).getPropertyValue("--reach-" + packageName), 10) !== 1) {
        console.warn("@reach/" + packageName + " styles not found. If you are using a bundler like webpack or parcel include this in the entry file of your app before any of your own styles:\n  \n      import \"@reach/" + packageName + "/styles.css\";\n  \n    Otherwise you'll need to include them some other way:\n  \n      <link rel=\"stylesheet\" type=\"text/css\" href=\"node_modules/@reach/" + packageName + "/styles.css\" />\n  \n    For more information visit https://ui.reach.tech/styling.\n    ");
      }
    }
  }
  /**
   * When in dev mode, checks that styles for a given `@reach` package are loaded.
   *
   * @param packageName Name of the package to check.
   * @example useCheckStyles("dialog") will check for styles for @reach/dialog
   */

  function useCheckStyles(packageName) {
    if (process.env.NODE_ENV !== "production") {
      var name = React.useRef(packageName);
      React.useEffect(function () {
        return void (name.current = packageName);
      }, [packageName]);
      React.useEffect(function () {
        return checkStyles(name.current);
      }, []);
    }
  }
  /**
   * Logs a warning in dev mode when a component switches from controlled to
   * uncontrolled, or vice versa
   *
   * A single prop should typically be used to determine whether or not a
   * component is controlled or not.
   *
   * @param controlledValue
   * @param controlledPropName
   * @param componentName
   */

  function useControlledSwitchWarning(controlledValue, controlledPropName, componentName) {
    if (process.env.NODE_ENV !== "production") {
      var controlledRef = React.useRef(controlledValue != null);
      var nameCache = React.useRef({
        componentName: componentName,
        controlledPropName: controlledPropName
      });
      React.useEffect(function () {
        nameCache.current = {
          componentName: componentName,
          controlledPropName: controlledPropName
        };
      }, [componentName, controlledPropName]);
      React.useEffect(function () {
        var wasControlled = controlledRef.current;
        var _nameCache$current = nameCache.current,
            componentName = _nameCache$current.componentName,
            controlledPropName = _nameCache$current.controlledPropName;
        var isControlled = controlledValue != null;

        if (wasControlled !== isControlled) {
          console.error("A component is changing an " + (wasControlled ? "" : "un") + "controlled `" + controlledPropName + "` state of " + componentName + " to be " + (wasControlled ? "un" : "") + "controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled " + componentName + " element for the lifetime of the component.\n      More info: https://fb.me/react-controlled-components");
        }
      }, [controlledValue]);
    }
  }

  function useStatefulRefValue(ref, initialState) {
    var _useState = React.useState(initialState),
        state = _useState[0],
        setState = _useState[1];

    var callbackRef = React.useCallback(function (refValue) {
      ref.current = refValue;
      setState(refValue); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [state, callbackRef];
  }

  /**
   * Wraps a lib-defined event handler and a user-defined event handler, returning
   * a single handler that allows a user to prevent lib-defined handlers from
   * firing.
   *
   * @param theirHandler User-supplied event handler
   * @param ourHandler Library-supplied event handler
   */
  function composeEventHandlers(theirHandler, ourHandler) {
    return function (event) {
      theirHandler && theirHandler(event);

      if (!event.defaultPrevented) {
        return ourHandler(event);
      }
    };
  }

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0

  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.

  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */
  var t$2;!function(t){t[t.NotStarted=0]="NotStarted",t[t.Running=1]="Running",t[t.Stopped=2]="Stopped";}(t$2||(t$2={}));var n$2={type:"xstate.init"};function e$2(t){return void 0===t?[]:[].concat(t)}function r$2(t){return {type:"xstate.assign",assignment:t}}function i$1(t,n){return "string"==typeof(t="string"==typeof t&&n&&n[t]?n[t]:t)?{type:t}:"function"==typeof t?{type:t.name,exec:t}:t}function o(t){return function(n){return t===n}}function a(t){return "string"==typeof t?{type:t}:t}function u(t,n){return {value:t,context:n,actions:[],changed:!1,matches:o(t)}}function c$2(t,n){void 0===n&&(n={});var r={config:t,_options:n,initialState:{value:t.initial,actions:e$2(t.states[t.initial].entry).map((function(t){return i$1(t,n.actions)})),context:t.context,matches:o(t.initial)},transition:function(n,c){var s,f,l="string"==typeof n?{value:n,context:t.context}:n,v=l.value,p=l.context,g=a(c),y=t.states[v];if(y.on){var d=e$2(y.on[g.type]),x=function(n){if(void 0===n)return {value:u(v,p)};var e="string"==typeof n?{target:n}:n,a=e.target,c=void 0===a?v:a,s=e.actions,f=void 0===s?[]:s,l=e.cond,d=p;if((void 0===l?function(){return !0}:l)(p,g)){var x=t.states[c],m=!1,h=[].concat(y.exit,f,x.entry).filter((function(t){return t})).map((function(t){return i$1(t,r._options.actions)})).filter((function(t){if("xstate.assign"===t.type){m=!0;var n=Object.assign({},d);return "function"==typeof t.assignment?n=t.assignment(d,g):Object.keys(t.assignment).forEach((function(e){n[e]="function"==typeof t.assignment[e]?t.assignment[e](d,g):t.assignment[e];})),d=n,!1}return !0}));return {value:{value:c,context:d,actions:h,changed:c!==v||h.length>0||m,matches:o(c)}}}};try{for(var m=function(t){var n="function"==typeof Symbol&&t[Symbol.iterator],e=0;return n?n.call(t):{next:function(){return t&&e>=t.length&&(t=void 0),{value:t&&t[e++],done:!t}}}}(d),h=m.next();!h.done;h=m.next()){var S=x(h.value);if("object"==typeof S)return S.value}}catch(t){s={error:t};}finally{try{h&&!h.done&&(f=m.return)&&f.call(m);}finally{if(s)throw s.error}}}return u(v,p)}};return r}var s=function(t,n){return t.actions.forEach((function(e){var r=e.exec;return r&&r(t.context,n)}))};function f$2(e){var r=e.initialState,i=t$2.NotStarted,o=new Set,u={_machine:e,send:function(n){i===t$2.Running&&(r=e.transition(r,n),s(r,a(n)),o.forEach((function(t){return t(r)})));},subscribe:function(t){return o.add(t),t(r),{unsubscribe:function(){return o.delete(t)}}},start:function(){return i=t$2.Running,s(r,n$2),u},stop:function(){return i=t$2.Stopped,o.clear(),u},get state(){return r},get status(){return i}};return u}

  /**
   * React hook for creating a value exactly once.
   * @see https://github.com/Andarist/use-constant
   */

  function useConstant(fn) {
    var ref = React.useRef();

    if (!ref.current) {
      ref.current = {
        v: fn()
      };
    }

    return ref.current.v;
  }

  function _extends$3() {
    _extends$3 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$3.apply(this, arguments);
  }

  var getServiceState = function getServiceState(service) {
    var currentValue;
    service.subscribe(function (state) {
      currentValue = state;
    }).unsubscribe();
    return currentValue;
  };
  /**
   * This `useMachine` works very similiarly to what you get from `@xstate/react`
   * with some additions.
   *  - A second argument `refs` is passed to send all of our refs into our
   *    machine's contextual data object.
   *  - We wrap the `send` function so that refs are updated included in all of
   *    our events so we can use their current value (generally DOM nodes)
   *    anywhere in our actions.
   *  - We initialize the machine inside the component rather than throwing an
   *    error if an outside initializer creates a value that doesn't match. This
   *    is useful as some components may need a different initial state or some
   *    initial data based on props. We should *generally* just update the state
   *    with an event via useEffect and depend on a static initial value, but this
   *    is difficult if that initial value matters for SSR or to prevent some
   *    layout jank before the first paint. I don't think there's a problem with
   *    this approach, but we'll see what happens.
   *
   * @param initialMachine
   * @param refs
   */


  function useMachine(initialMachine, refs, DEBUG) {
    // State machine should not change between renders, so let's store it in a
    // ref. This should also help if we need to use a creator function to inject
    // dynamic initial state values based on props.
    var machineRef = React.useRef(initialMachine);
    var service = useConstant(function () {
      return f$2(machineRef.current).start();
    });
    var lastEventType = React.useRef(null);

    var _React$useState = React.useState(function () {
      return getServiceState(service);
    }),
        state = _React$useState[0],
        setState = _React$useState[1]; // This function reference will change on every render if we just pass on
    // current.matches, but it shouldn't change unless the current value is
    // updated. This was causing some lagginess when profiling in Listbox but
    // is probably an issue everywhere since the parent components that handle
    // state logic at the top might re-create context on each render as a
    // result of this change.
    // Add refs to every event so we can use them to perform actions.


    var send = React.useCallback(function (rawEvent) {
      var event = isString(rawEvent) ? {
        type: rawEvent
      } : rawEvent;
      var refValues = unwrapRefs(refs);
      service.send(_extends$3({}, event, {
        lastEventType: lastEventType.current,
        refs: refValues
      }));
      lastEventType.current = event.type;

      if (process.env.NODE_ENV !== "production") {
        if (DEBUG) {
          console.group("Event Sent");
          console.log("Event:", event);
          console.groupEnd();
        }
      }
    }, // We can disable the lint warning here. Refs will always be refs
    // (TypeScript enforced!) and should not trigger a re-render. The state
    // machine service persist for the life of the component.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [DEBUG]);
    React.useEffect(function () {
      service.subscribe(function setStateIfChanged(newState) {
        if (newState.changed) {
          setState(newState);
        }
      });
      return function () {
        service.stop();
      };
    }, [service]);
    React.useEffect(function () {
      if (process.env.NODE_ENV !== "production") {
        if (DEBUG && state.changed) {
          console.group("State Updated");
          console.log("State:", state);
          console.groupEnd();
        }
      }
    }, [DEBUG, state]); // We are going to pass along our state without the actions to avoid excess
    // renders when the reference changes. We haven't really needed them at this
    // point, but if we do we can maybe reconsider this approach.

    var memoizedState = React.useMemo(function () {
      return _extends$3({}, state, {
        matches: function matches(value) {
          return value === state.value;
        }
      });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.changed, state.context, state.value]);
    return [memoizedState, send, service];
  }
  /**
   * Converts an object with React refs into an object with the same keys and
   * the current value of those refs.
   *
   * @param refs
   */

  function unwrapRefs(refs) {
    return Object.entries(refs).reduce(function (value, _ref) {
      var name = _ref[0],
          ref = _ref[1];
      value[name] = ref.current;
      return value;
    }, {});
  }
  /**
   * Most of the time you want to create a static state machine outside of your
   * component, but in some cases we may need data from props in the first render
   * cycle. We can create our machine in each component IF we only create it once
   * and guarantee that it never changes between renders.
   *
   * This hook can take a machine definition created by a function inline to use
   * values defined in the component, and we never change the machine for the
   * life of the component.
   *
   * @param machineDefinition
   * @param options
   */

  function useCreateMachine(machineDefinition, options) {
    return useConstant(function () {
      return c$2(machineDefinition, options);
    });
  } ////////////////////////////////////////////////////////////////////////////////

  function _extends$4() {
    _extends$4 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$4.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose$3(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var _commonEvents;
  ////////////////////////////////////////////////////////////////////////////////
  // States
  var ListboxStates; ////////////////////////////////////////////////////////////////////////////////
  // Events

  (function (ListboxStates) {
    ListboxStates["Idle"] = "IDLE";
    ListboxStates["Open"] = "OPEN";
    ListboxStates["Navigating"] = "NAVIGATING";
    ListboxStates["Dragging"] = "DRAGGING";
    ListboxStates["Interacting"] = "INTERACTING";
  })(ListboxStates || (ListboxStates = {}));

  var ListboxEvents; ////////////////////////////////////////////////////////////////////////////////
  // Actions and conditions

  (function (ListboxEvents) {
    ListboxEvents["ButtonMouseDown"] = "BUTTON_MOUSE_DOWN";
    ListboxEvents["ButtonMouseUp"] = "BUTTON_MOUSE_UP";
    ListboxEvents["Blur"] = "BLUR";
    ListboxEvents["ClearNavSelection"] = "CLEAR_NAV_SELECTION";
    ListboxEvents["ClearTypeahead"] = "CLEAR_TYPEAHEAD";
    ListboxEvents["GetDerivedData"] = "GET_DERIVED_DATA";
    ListboxEvents["KeyDownEscape"] = "KEY_DOWN_ESCAPE";
    ListboxEvents["KeyDownEnter"] = "KEY_DOWN_ENTER";
    ListboxEvents["KeyDownSpace"] = "KEY_DOWN_SPACE";
    ListboxEvents["KeyDownNavigate"] = "KEY_DOWN_NAVIGATE";
    ListboxEvents["KeyDownSearch"] = "KEY_DOWN_SEARCH";
    ListboxEvents["KeyDownTab"] = "KEY_DOWN_TAB";
    ListboxEvents["KeyDownShiftTab"] = "KEY_DOWN_SHIFT_TAB";
    ListboxEvents["OptionTouchStart"] = "OPTION_TOUCH_START";
    ListboxEvents["OptionMouseMove"] = "OPTION_MOUSE_MOVE";
    ListboxEvents["OptionMouseEnter"] = "OPTION_MOUSE_ENTER";
    ListboxEvents["OptionMouseDown"] = "OPTION_MOUSE_DOWN";
    ListboxEvents["OptionMouseUp"] = "OPTION_MOUSE_UP";
    ListboxEvents["OptionClick"] = "OPTION_CLICK";
    ListboxEvents["ListMouseUp"] = "LIST_MOUSE_UP";
    ListboxEvents["OptionPress"] = "OPTION_PRESS";
    ListboxEvents["OutsideMouseDown"] = "OUTSIDE_MOUSE_DOWN";
    ListboxEvents["OutsideMouseUp"] = "OUTSIDE_MOUSE_UP";
    ListboxEvents["ValueChange"] = "VALUE_CHANGE";
    ListboxEvents["PopoverPointerDown"] = "POPOVER_POINTER_DOWN";
    ListboxEvents["PopoverPointerUp"] = "POPOVER_POINTER_UP";
    ListboxEvents["UpdateAfterTypeahead"] = "UPDATE_AFTER_TYPEAHEAD";
  })(ListboxEvents || (ListboxEvents = {}));

  var clearNavigationValue = /*#__PURE__*/r$2({
    navigationValue: null
  });
  var clearTypeahead = /*#__PURE__*/r$2({
    typeaheadQuery: null
  });
  var assignValue = /*#__PURE__*/r$2({
    value: function value(_, event) {
      return event.value;
    }
  });
  var navigate = /*#__PURE__*/r$2({
    navigationValue: function navigationValue(data, event) {
      return event.value;
    }
  });
  var navigateFromCurrentValue = /*#__PURE__*/r$2({
    navigationValue: function navigationValue(data) {
      // Before we navigate based on the current value, we need to make sure the
      // current value is selectable. If not, we should instead navigate to the
      // first selectable option.
      var selected = findOptionFromValue(data.value, data.options);

      if (selected && !selected.disabled) {
        return data.value;
      } else {
        var _data$options$find;

        return ((_data$options$find = data.options.find(function (option) {
          return !option.disabled;
        })) == null ? void 0 : _data$options$find.value) || null;
      }
    }
  });

  function listboxLostFocus(data, event) {
    if (event.type === ListboxEvents.Blur) {
      var _event$refs = event.refs,
          list = _event$refs.list,
          popover = _event$refs.popover;
      var relatedTarget = event.relatedTarget;
      var ownerDocument = getOwnerDocument(popover);
      return !!((ownerDocument == null ? void 0 : ownerDocument.activeElement) !== list && popover && !popover.contains(relatedTarget || (ownerDocument == null ? void 0 : ownerDocument.activeElement)));
    }

    return false;
  }

  function clickedOutsideOfListbox(data, event) {
    if (event.type === ListboxEvents.OutsideMouseDown || event.type === ListboxEvents.OutsideMouseUp) {
      var _event$refs2 = event.refs,
          button = _event$refs2.button,
          popover = _event$refs2.popover;
      var relatedTarget = event.relatedTarget; // Close the popover IF:

      return !!( // clicked element is not the button
      relatedTarget !== button && // clicked element is not inside the button
      button && !button.contains(relatedTarget) && // clicked element is not inside the popover
      popover && !popover.contains(relatedTarget));
    }

    return false;
  }

  function optionIsActive(data, event) {
    return !!data.options.find(function (option) {
      return option.value === data.navigationValue;
    });
  }

  function shouldNavigate(data, event) {
    var _event$refs3 = event.refs,
        popover = _event$refs3.popover,
        list = _event$refs3.list;
    var relatedTarget = event.relatedTarget; // When a blur event happens, we want to move to Navigating state unless the
    // user is interacting with elements inside the popover...

    if (popover && relatedTarget && popover.contains(relatedTarget) && relatedTarget !== list) {
      return false;
    } // ...otherwise, just make sure the next option is selectable


    return optionIsActive(data);
  }

  function focusList(data, event) {
    requestAnimationFrame(function () {
      event.refs.list && event.refs.list.focus();
    });
  }

  function focusButton(data, event) {
    event.refs.button && event.refs.button.focus();
  }

  function listboxIsNotDisabled(data, event) {
    return !event.disabled;
  }

  function optionIsNavigable(data, event) {
    if (event.type === ListboxEvents.OptionTouchStart) {
      if (event && event.disabled) {
        return false;
      }
    }

    return true;
  }

  function optionIsSelectable(data, event) {
    if ("disabled" in event && event.disabled) {
      return false;
    }

    if ("value" in event) {
      return event.value != null;
    }

    return data.navigationValue != null;
  }

  function selectOption(data, event) {
    event.callback && event.callback(event.value);
  }

  function submitForm(data, event) {
    if (event.type !== ListboxEvents.KeyDownEnter) {
      return;
    } // So this one is a little weird, but here's what we're doing.
    // When a user presses Enter in the context of a form, the form
    // should submit. Now I know you're probably thinking:
    //
    //      "Aha! I've got it!"
    //          > inputNode.form.submit()
    //      ** cracks knuckles ** "Phew. My work here is done."
    //
    // But alas, we are not so lucky. What's really happening when a
    // user presses enter in a normal form field is that the browser
    // looks at the form the input is in, then looks for the first
    // button or input in that form where its type property is `submit`,
    // then it triggers a click event on that button. COOL, CARRY ON.
    //
    // If we were to fire inputNode.form.submit(), this would bypass any
    // onSubmit handler in the form and just do what the browser
    // normally does when you submit a form and trigger a page refresh.
    // No bueno. So we do what the browser does and just go on a duck
    // hunt for the first submit button in the form and we click that
    // sucker.


    var hiddenInput = event.refs.hiddenInput;

    if (hiddenInput && hiddenInput.form) {
      var submitButton = hiddenInput.form.querySelector("button,[type='submit']");
      submitButton && submitButton.click();
    }
  }

  var setTypeahead = /*#__PURE__*/r$2({
    typeaheadQuery: function typeaheadQuery(data, event) {
      return (data.typeaheadQuery || "") + event.query;
    }
  });
  var setValueFromTypeahead = /*#__PURE__*/r$2({
    value: function value(data, event) {
      if (event.type === ListboxEvents.UpdateAfterTypeahead && event.query) {
        var match = findOptionFromTypeahead(data.options, event.query);

        if (match && !match.disabled) {
          event.callback && event.callback(match.value);
          return match.value;
        }
      }

      return data.value;
    }
  });
  var setNavSelectionFromTypeahead = /*#__PURE__*/r$2({
    navigationValue: function navigationValue(data, event) {
      if (event.type === ListboxEvents.UpdateAfterTypeahead && event.query) {
        var match = findOptionFromTypeahead(data.options, event.query);

        if (match && !match.disabled) {
          return match.value;
        }
      }

      return data.navigationValue;
    }
  });
  var commonEvents = (_commonEvents = {}, _commonEvents[ListboxEvents.GetDerivedData] = {
    actions: /*#__PURE__*/r$2(function (ctx, event) {
      return _extends$4({}, ctx, event.data);
    })
  }, _commonEvents[ListboxEvents.ValueChange] = {
    actions: [assignValue, selectOption]
  }, _commonEvents); ////////////////////////////////////////////////////////////////////////////////

  /**
   * Initializer for our state machine.
   *
   * @param initial
   * @param props
   */

  var createMachineDefinition = function createMachineDefinition(_ref) {
    var _extends2, _extends3, _extends4, _extends5, _extends6, _states;

    var value = _ref.value;
    return {
      id: "listbox",
      initial: ListboxStates.Idle,
      context: {
        value: value,
        options: [],
        navigationValue: null,
        typeaheadQuery: null
      },
      states: (_states = {}, _states[ListboxStates.Idle] = {
        on: _extends$4({}, commonEvents, (_extends2 = {}, _extends2[ListboxEvents.ButtonMouseDown] = {
          target: ListboxStates.Open,
          actions: [navigateFromCurrentValue],
          cond: listboxIsNotDisabled
        }, _extends2[ListboxEvents.KeyDownSpace] = {
          target: ListboxStates.Navigating,
          actions: [navigateFromCurrentValue, focusList],
          cond: listboxIsNotDisabled
        }, _extends2[ListboxEvents.KeyDownSearch] = {
          target: ListboxStates.Idle,
          actions: setTypeahead,
          cond: listboxIsNotDisabled
        }, _extends2[ListboxEvents.UpdateAfterTypeahead] = {
          target: ListboxStates.Idle,
          actions: [setValueFromTypeahead],
          cond: listboxIsNotDisabled
        }, _extends2[ListboxEvents.ClearTypeahead] = {
          target: ListboxStates.Idle,
          actions: clearTypeahead
        }, _extends2[ListboxEvents.KeyDownNavigate] = {
          target: ListboxStates.Navigating,
          actions: [navigateFromCurrentValue, clearTypeahead, focusList],
          cond: listboxIsNotDisabled
        }, _extends2[ListboxEvents.KeyDownEnter] = {
          actions: [submitForm],
          cond: listboxIsNotDisabled
        }, _extends2))
      }, _states[ListboxStates.Interacting] = {
        entry: [clearNavigationValue],
        on: _extends$4({}, commonEvents, (_extends3 = {}, _extends3[ListboxEvents.ClearNavSelection] = {
          actions: [clearNavigationValue, focusList]
        }, _extends3[ListboxEvents.KeyDownEnter] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends3[ListboxEvents.KeyDownSpace] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends3[ListboxEvents.ButtonMouseDown] = {
          target: ListboxStates.Idle,
          // When the user triggers a mouseDown event on the button, we call
          // event.preventDefault() because the browser will naturally send a
          // mouseup event and click, which will reopen the button (which we
          // don't want). As such, the click won't blur the open list or
          // re-focus the trigger, so we call `focusButton` to do that manually.
          // We could work around this with deferred transitions with xstate,
          // but @xstate/fsm currently doesn't support that feature and this
          // works good enough for the moment.
          actions: [focusButton]
        }, _extends3[ListboxEvents.KeyDownEscape] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends3[ListboxEvents.OptionMouseDown] = {
          target: ListboxStates.Dragging
        }, _extends3[ListboxEvents.OutsideMouseDown] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Dragging,
          actions: clearTypeahead,
          cond: optionIsActive
        }], _extends3[ListboxEvents.OutsideMouseUp] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: optionIsActive
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends3[ListboxEvents.KeyDownEnter] = ListboxStates.Interacting, _extends3[ListboxEvents.Blur] = [{
          target: ListboxStates.Idle,
          cond: listboxLostFocus,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: shouldNavigate
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends3[ListboxEvents.OptionTouchStart] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends3[ListboxEvents.OptionClick] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends3[ListboxEvents.OptionPress] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends3[ListboxEvents.OptionMouseEnter] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends3[ListboxEvents.KeyDownNavigate] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead, focusList]
        }, _extends3))
      }, _states[ListboxStates.Open] = {
        on: _extends$4({}, commonEvents, (_extends4 = {}, _extends4[ListboxEvents.ClearNavSelection] = {
          actions: [clearNavigationValue]
        }, _extends4[ListboxEvents.KeyDownEnter] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends4[ListboxEvents.KeyDownSpace] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends4[ListboxEvents.ButtonMouseDown] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends4[ListboxEvents.KeyDownEscape] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends4[ListboxEvents.OptionMouseDown] = {
          target: ListboxStates.Dragging
        }, _extends4[ListboxEvents.OutsideMouseDown] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Dragging,
          cond: optionIsActive
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends4[ListboxEvents.OutsideMouseUp] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: optionIsActive
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends4[ListboxEvents.Blur] = [{
          target: ListboxStates.Idle,
          cond: listboxLostFocus,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: shouldNavigate
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends4[ListboxEvents.ButtonMouseUp] = {
          target: ListboxStates.Navigating,
          actions: [navigateFromCurrentValue, focusList]
        }, _extends4[ListboxEvents.ListMouseUp] = {
          target: ListboxStates.Navigating,
          actions: [navigateFromCurrentValue, focusList]
        }, _extends4[ListboxEvents.OptionTouchStart] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends4[ListboxEvents.OptionClick] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends4[ListboxEvents.OptionPress] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends4[ListboxEvents.KeyDownNavigate] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead, focusList]
        }, _extends4[ListboxEvents.KeyDownSearch] = {
          target: ListboxStates.Navigating,
          actions: setTypeahead
        }, _extends4[ListboxEvents.UpdateAfterTypeahead] = {
          actions: [setNavSelectionFromTypeahead]
        }, _extends4[ListboxEvents.ClearTypeahead] = {
          actions: clearTypeahead
        }, _extends4[ListboxEvents.OptionMouseMove] = [{
          target: ListboxStates.Dragging,
          actions: [navigate],
          cond: optionIsNavigable
        }, {
          target: ListboxStates.Dragging
        }], _extends4))
      }, _states[ListboxStates.Dragging] = {
        on: _extends$4({}, commonEvents, (_extends5 = {}, _extends5[ListboxEvents.ClearNavSelection] = {
          actions: [clearNavigationValue]
        }, _extends5[ListboxEvents.KeyDownEnter] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends5[ListboxEvents.KeyDownSpace] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends5[ListboxEvents.ButtonMouseDown] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends5[ListboxEvents.KeyDownEscape] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends5[ListboxEvents.OptionMouseDown] = {
          target: ListboxStates.Dragging
        }, _extends5[ListboxEvents.OutsideMouseDown] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: optionIsActive
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends5[ListboxEvents.OutsideMouseUp] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: optionIsActive,
          actions: focusList
        }, {
          target: ListboxStates.Interacting,
          actions: [clearTypeahead, focusList]
        }], _extends5[ListboxEvents.Blur] = [{
          target: ListboxStates.Idle,
          cond: listboxLostFocus,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: shouldNavigate
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends5[ListboxEvents.ButtonMouseUp] = {
          target: ListboxStates.Navigating,
          actions: [navigateFromCurrentValue, focusList]
        }, _extends5[ListboxEvents.OptionTouchStart] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends5[ListboxEvents.OptionClick] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends5[ListboxEvents.OptionPress] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends5[ListboxEvents.OptionMouseEnter] = {
          target: ListboxStates.Dragging,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends5[ListboxEvents.KeyDownNavigate] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead, focusList]
        }, _extends5[ListboxEvents.KeyDownSearch] = {
          target: ListboxStates.Navigating,
          actions: setTypeahead
        }, _extends5[ListboxEvents.UpdateAfterTypeahead] = {
          actions: [setNavSelectionFromTypeahead]
        }, _extends5[ListboxEvents.ClearTypeahead] = {
          actions: clearTypeahead
        }, _extends5[ListboxEvents.OptionMouseMove] = [{
          target: ListboxStates.Navigating,
          actions: [navigate],
          cond: optionIsNavigable
        }, {
          target: ListboxStates.Navigating
        }], _extends5[ListboxEvents.OptionMouseUp] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends5))
      }, _states[ListboxStates.Navigating] = {
        on: _extends$4({}, commonEvents, (_extends6 = {}, _extends6[ListboxEvents.ClearNavSelection] = {
          actions: [clearNavigationValue, focusList]
        }, _extends6[ListboxEvents.KeyDownEnter] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends6[ListboxEvents.KeyDownSpace] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends6[ListboxEvents.ButtonMouseDown] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends6[ListboxEvents.KeyDownEscape] = {
          target: ListboxStates.Idle,
          actions: [focusButton]
        }, _extends6[ListboxEvents.OptionMouseDown] = {
          target: ListboxStates.Dragging
        }, _extends6[ListboxEvents.OutsideMouseDown] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: optionIsActive
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends6[ListboxEvents.OutsideMouseUp] = [{
          target: ListboxStates.Idle,
          cond: clickedOutsideOfListbox,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: optionIsActive
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends6[ListboxEvents.Blur] = [{
          target: ListboxStates.Idle,
          cond: listboxLostFocus,
          actions: clearTypeahead
        }, {
          target: ListboxStates.Navigating,
          cond: shouldNavigate
        }, {
          target: ListboxStates.Interacting,
          actions: clearTypeahead
        }], _extends6[ListboxEvents.ButtonMouseUp] = {
          target: ListboxStates.Navigating,
          actions: [navigateFromCurrentValue, focusList]
        }, _extends6[ListboxEvents.OptionTouchStart] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends6[ListboxEvents.OptionClick] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends6[ListboxEvents.OptionPress] = {
          target: ListboxStates.Idle,
          actions: [assignValue, clearTypeahead, focusButton, selectOption],
          cond: optionIsSelectable
        }, _extends6[ListboxEvents.OptionMouseEnter] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead],
          cond: optionIsNavigable
        }, _extends6[ListboxEvents.KeyDownNavigate] = {
          target: ListboxStates.Navigating,
          actions: [navigate, clearTypeahead, focusList]
        }, _extends6[ListboxEvents.KeyDownSearch] = {
          target: ListboxStates.Navigating,
          actions: setTypeahead
        }, _extends6[ListboxEvents.UpdateAfterTypeahead] = {
          actions: [setNavSelectionFromTypeahead]
        }, _extends6[ListboxEvents.ClearTypeahead] = {
          actions: clearTypeahead
        }, _extends6[ListboxEvents.OptionMouseMove] = [{
          target: ListboxStates.Navigating,
          actions: [navigate],
          cond: optionIsNavigable
        }, {
          target: ListboxStates.Navigating
        }], _extends6))
      }, _states)
    };
  }; ////////////////////////////////////////////////////////////////////////////////

  function findOptionFromTypeahead(options, string) {
    if (string === void 0) {
      string = "";
    }

    if (!string) return null;
    var found = options.find(function (option) {
      return !option.disabled && option.label && option.label.toLowerCase().startsWith(string.toLowerCase());
    });
    return found || null;
  }

  function findOptionFromValue(value, options) {
    return value ? options.find(function (option) {
      return option.value === value;
    }) : undefined;
  } ////////////////////////////////////////////////////////////////////////////////
  // Types

  /**
   * Shared partial interface for all of our event objects.
   */

  var _excluded$8 = ["as", "aria-labelledby", "aria-label", "children", "defaultValue", "disabled", "form", "name", "onChange", "required", "value", "__componentName"],
      _excluded2 = ["arrow", "button", "children", "portal"],
      _excluded3 = ["aria-label", "arrow", "as", "children", "onKeyDown", "onMouseDown", "onMouseUp"],
      _excluded4 = ["as", "children"],
      _excluded5 = ["as", "position", "onBlur", "onKeyDown", "onMouseUp", "portal", "unstable_observableRefs"],
      _excluded6 = ["as"],
      _excluded7 = ["as", "children", "disabled", "index", "label", "onClick", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseUp", "onTouchStart", "value"],
      _excluded8 = ["as", "label", "children"],
      _excluded9 = ["as"];
  var DEBUG = false; ////////////////////////////////////////////////////////////////////////////////
  // ListboxContext

  var ListboxDescendantContext = /*#__PURE__*/createDescendantContext("ListboxDescendantContext");
  var ListboxContext = /*#__PURE__*/createNamedContext("ListboxContext", {});
  var ListboxGroupContext = /*#__PURE__*/createNamedContext("ListboxGroupContext", {}); ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxInput
   *
   * The top-level component and context provider for the listbox.
   *
   * @see Docs https://reach.tech/listbox#listboxinput
   */

  var ListboxInput = /*#__PURE__*/React.forwardRef(function ListboxInput(_ref, forwardedRef) {
    var _ref$as = _ref.as,
        Comp = _ref$as === void 0 ? "div" : _ref$as,
        ariaLabelledBy = _ref["aria-labelledby"],
        ariaLabel = _ref["aria-label"],
        children = _ref.children,
        defaultValue = _ref.defaultValue,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        form = _ref.form,
        name = _ref.name,
        onChange = _ref.onChange,
        required = _ref.required,
        valueProp = _ref.value,
        _ref$__componentName = _ref.__componentName,
        __componentName = _ref$__componentName === void 0 ? "ListboxInput" : _ref$__componentName,
        props = _objectWithoutPropertiesLoose$3(_ref, _excluded$8);

    var isControlled = React.useRef(valueProp != null);

    var _useDescendantsInit = useDescendantsInit(),
        options = _useDescendantsInit[0],
        setOptions = _useDescendantsInit[1]; // DOM refs


    var buttonRef = React.useRef(null);
    var hiddenInputRef = React.useRef(null);
    var highlightedOptionRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var listRef = React.useRef(null);
    var popoverRef = React.useRef(null);
    var selectedOptionRef = React.useRef(null);
    var machine = useCreateMachine(createMachineDefinition({
      // The initial value of our machine should come from the `value` or
      // `defaultValue` props if they exist.
      value: (isControlled.current ? valueProp : defaultValue) || null
    }));

    var _useMachine = useMachine(machine, {
      button: buttonRef,
      hiddenInput: hiddenInputRef,
      highlightedOption: highlightedOptionRef,
      input: inputRef,
      list: listRef,
      popover: popoverRef,
      selectedOption: selectedOptionRef
    }, DEBUG),
        state = _useMachine[0],
        send = _useMachine[1];

    function handleValueChange(newValue) {
      if (newValue !== state.context.value) {
        onChange == null ? void 0 : onChange(newValue);
      }
    } // IDs for aria attributes


    var _id = useId(props.id);

    var id = props.id || makeId("listbox-input", _id);
    var ref = useComposedRefs(inputRef, forwardedRef); // If the button has children, we just render them as the label.
    // Otherwise we'll find the option with a value that matches the listbox value
    // and use its label in the button. We'll get that here and send it to the
    // button via context.
    // If a user needs the label for SSR to prevent hydration mismatch issues,
    // they need to control the state of the component and pass a label directly
    // to the button.

    var valueLabel = React.useMemo(function () {
      var selected = options.find(function (option) {
        return option.value === state.context.value;
      });
      return selected ? selected.label : null;
    }, [options, state.context.value]);
    var isExpanded = isListboxExpanded(state.value);
    var context = {
      ariaLabel: ariaLabel,
      ariaLabelledBy: ariaLabelledBy,
      buttonRef: buttonRef,
      disabled: disabled,
      highlightedOptionRef: highlightedOptionRef,
      isExpanded: isExpanded,
      listboxId: id,
      listboxValueLabel: valueLabel,
      listRef: listRef,
      onValueChange: handleValueChange,
      popoverRef: popoverRef,
      selectedOptionRef: selectedOptionRef,
      send: send,
      state: state.value,
      stateData: state.context
    }; // For uncontrolled listbox components where no `defaultValue` is provided, we
    // will update the value based on the value of the first selectable option.
    // We call the update directly because:
    //   A) we only ever need to do this once, so we can guard with a ref
    //   B) useLayoutEffect races useDecendant, so we might not have options yet
    //   C) useEffect will cause a flash

    var mounted = React.useRef(false);

    if (!isControlled.current && // the app is not controlling state
    defaultValue == null && // there is no default value
    !mounted.current && // we haven't done this already
    options.length // we have some options
    ) {
        mounted.current = true;
        var first = options.find(function (option) {
          return !option.disabled;
        });

        if (first && first.value) {
          send({
            type: ListboxEvents.ValueChange,
            value: first.value
          });
        }
      }

    useControlledSwitchWarning(valueProp, "value", __componentName); // Even if the app controls state, we still need to update it internally to
    // run the state machine transitions

    useControlledStateSync(valueProp, state.context.value, function () {
      send({
        type: ListboxEvents.ValueChange,
        value: valueProp
      });
    });
    useIsomorphicLayoutEffect(function () {
      send({
        type: ListboxEvents.GetDerivedData,
        data: {
          options: options
        }
      });
    }, [options, send]);
    React.useEffect(function () {
      function handleMouseDown(event) {
        var target = event.target,
            relatedTarget = event.relatedTarget;

        if (!popoverContainsEventTarget(popoverRef.current, target)) {
          send({
            type: ListboxEvents.OutsideMouseDown,
            relatedTarget: relatedTarget || target
          });
        }
      }

      if (isExpanded) {
        window.addEventListener("mousedown", handleMouseDown);
      }

      return function () {
        window.removeEventListener("mousedown", handleMouseDown);
      };
    }, [send, isExpanded]);
    React.useEffect(function () {
      function handleMouseUp(event) {
        var target = event.target,
            relatedTarget = event.relatedTarget;

        if (!popoverContainsEventTarget(popoverRef.current, target)) {
          send({
            type: ListboxEvents.OutsideMouseUp,
            relatedTarget: relatedTarget || target
          });
        }
      }

      if (isExpanded) {
        window.addEventListener("mouseup", handleMouseUp);
      }

      return function () {
        window.removeEventListener("mouseup", handleMouseUp);
      };
    }, [send, isExpanded]);
    useCheckStyles("listbox");
    return /*#__PURE__*/React.createElement(Comp, _extends$4({}, props, {
      ref: ref,
      "data-reach-listbox-input": "",
      "data-state": isExpanded ? "expanded" : "closed",
      "data-value": state.context.value,
      id: id
    }), /*#__PURE__*/React.createElement(ListboxContext.Provider, {
      value: context
    }, /*#__PURE__*/React.createElement(DescendantProvider, {
      context: ListboxDescendantContext,
      items: options,
      set: setOptions
    }, isFunction(children) ? children({
      id: id,
      isExpanded: isExpanded,
      value: state.context.value,
      selectedOptionRef: selectedOptionRef,
      highlightedOptionRef: highlightedOptionRef,
      valueLabel: valueLabel,
      // TODO: Remove in 1.0
      expanded: isExpanded
    }) : children, (form || name || required) && /*#__PURE__*/React.createElement("input", {
      ref: hiddenInputRef,
      "data-reach-listbox-hidden-input": "",
      disabled: disabled,
      form: form,
      name: name,
      readOnly: true,
      required: required,
      tabIndex: -1,
      type: "hidden",
      value: state.context.value || ""
    }))));
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxInput.displayName = "ListboxInput";
    ListboxInput.propTypes = {
      children: /*#__PURE__*/propTypes.oneOfType([propTypes.node, propTypes.func]),
      defaultValue: propTypes.string,
      disabled: propTypes.bool,
      form: propTypes.string,
      name: propTypes.string,
      onChange: propTypes.func,
      required: propTypes.bool,
      value: propTypes.string
    };
  }
  /**
   * @see Docs https://reach.tech/listbox#listboxinput-props
   */


  ////////////////////////////////////////////////////////////////////////////////

  /**
   * Listbox
   *
   * High-level listbox API
   *
   * @example
   * <Listbox>
   *   <ListboxOption value="1">Option 1</ListboxOption>
   *   <ListboxOption value="2">Option 2</ListboxOption>
   *   <ListboxOption value="3">Option 3</ListboxOption>
   * </Listbox>
   *
   * @see Docs https://reach.tech/listbox#listbox-1
   */
  var Listbox = /*#__PURE__*/React.forwardRef(function Listbox(_ref2, forwardedRef) {
    var _ref2$arrow = _ref2.arrow,
        arrow = _ref2$arrow === void 0 ? "▼" : _ref2$arrow,
        button = _ref2.button,
        children = _ref2.children,
        _ref2$portal = _ref2.portal,
        portal = _ref2$portal === void 0 ? true : _ref2$portal,
        props = _objectWithoutPropertiesLoose$3(_ref2, _excluded2);

    return /*#__PURE__*/React.createElement(ListboxInput, _extends$4({}, props, {
      __componentName: "Listbox",
      ref: forwardedRef
    }), function (_ref3) {
      var value = _ref3.value,
          valueLabel = _ref3.valueLabel;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListboxButton, {
        arrow: arrow,
        children: button ? isFunction(button) ? button({
          value: value,
          label: valueLabel
        }) : button : undefined
      }), /*#__PURE__*/React.createElement(ListboxPopover, {
        portal: portal
      }, /*#__PURE__*/React.createElement(ListboxList, null, children)));
    });
  });

  if (process.env.NODE_ENV !== "production") {
    Listbox.displayName = "Listbox";
    Listbox.propTypes = /*#__PURE__*/_extends$4({}, ListboxInput.propTypes, {
      arrow: /*#__PURE__*/propTypes.oneOfType([propTypes.node, propTypes.bool]),
      button: /*#__PURE__*/propTypes.oneOfType([propTypes.func, propTypes.node]),
      children: propTypes.node
    });
  }
  /**
   * @see Docs https://reach.tech/listbox#listbox-props
   */


  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxButton
   *
   * The interactive toggle button that triggers the popover for the listbox.
   *
   * @see Docs https://reach.tech/listbox#listbox-button
   */
  var ListboxButtonImpl = /*#__PURE__*/React.forwardRef(function ListboxButton(_ref4, forwardedRef) {
    var ariaLabel = _ref4["aria-label"],
        _ref4$arrow = _ref4.arrow,
        arrow = _ref4$arrow === void 0 ? false : _ref4$arrow,
        _ref4$as = _ref4.as,
        Comp = _ref4$as === void 0 ? "span" : _ref4$as,
        children = _ref4.children,
        onKeyDown = _ref4.onKeyDown,
        onMouseDown = _ref4.onMouseDown,
        onMouseUp = _ref4.onMouseUp,
        props = _objectWithoutPropertiesLoose$3(_ref4, _excluded3);

    var _React$useContext = React.useContext(ListboxContext),
        buttonRef = _React$useContext.buttonRef,
        send = _React$useContext.send,
        ariaLabelledBy = _React$useContext.ariaLabelledBy,
        disabled = _React$useContext.disabled,
        isExpanded = _React$useContext.isExpanded,
        listboxId = _React$useContext.listboxId,
        stateData = _React$useContext.stateData,
        listboxValueLabel = _React$useContext.listboxValueLabel;

    var listboxValue = stateData.value;
    var ref = useComposedRefs(buttonRef, forwardedRef);
    var handleKeyDown = useKeyDown();

    function handleMouseDown(event) {
      if (!isRightClick(event.nativeEvent)) {
        event.preventDefault();
        event.stopPropagation();
        send({
          type: ListboxEvents.ButtonMouseDown,
          disabled: disabled
        });
      }
    }

    function handleMouseUp(event) {
      if (!isRightClick(event.nativeEvent)) {
        event.preventDefault();
        event.stopPropagation();
        send({
          type: ListboxEvents.ButtonMouseUp
        });
      }
    }

    var id = makeId("button", listboxId); // If the button has children, we just render them as the label
    // If a user needs the label on the server to prevent hydration mismatch
    // errors, they need to control the state of the component and pass a label
    // directly to the button.

    var label = React.useMemo(function () {
      if (!children) {
        return listboxValueLabel;
      } else if (isFunction(children)) {
        return children({
          isExpanded: isExpanded,
          label: listboxValueLabel,
          value: listboxValue,
          // TODO: Remove in 1.0
          expanded: isExpanded
        });
      }

      return children;
    }, [children, listboxValueLabel, isExpanded, listboxValue]);
    return /*#__PURE__*/React.createElement(Comp // Applicable to all host language elements regardless of whether a
    // `role` is applied.
    // https://www.w3.org/WAI/PF/aria/states_and_properties#global_states_header
    , _extends$4({
      "aria-disabled": disabled || undefined // Set by the JavaScript when the listbox is displayed. Otherwise, is
      // not present.
      // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-collapsible.html
      ,
      "aria-expanded": isExpanded || undefined // Indicates that activating the button displays a listbox.
      // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-collapsible.html
      ,
      "aria-haspopup": "listbox" // References the two elements whose labels are concatenated by the
      // browser to label the button. The first element is a span containing
      // perceivable label for the listbox component. The second element is
      // the button itself; the button text is set to the name of the
      // currently chosen element.
      // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-collapsible.html
      // If an `aria-label` is passed, we should skip `aria-labelledby` to
      // avoid confusion.
      ,
      "aria-labelledby": ariaLabel ? undefined : [ariaLabelledBy, id].filter(Boolean).join(" "),
      "aria-label": ariaLabel // Identifies the element as a button widget.
      // https://www.w3.org/TR/wai-aria-practices-1.2/examples/button/button.html
      ,
      role: "button" // Includes the element in the tab sequence.
      // https://www.w3.org/TR/wai-aria-practices-1.2/examples/button/button.html
      ,
      tabIndex: disabled ? -1 : 0
    }, props, {
      ref: ref,
      "data-reach-listbox-button": "",
      id: id,
      onKeyDown: composeEventHandlers(onKeyDown, handleKeyDown),
      onMouseDown: composeEventHandlers(onMouseDown, handleMouseDown),
      onMouseUp: composeEventHandlers(onMouseUp, handleMouseUp)
    }), label, arrow && /*#__PURE__*/React.createElement(ListboxArrow, null, isBoolean(arrow) ? null : arrow));
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxButtonImpl.displayName = "ListboxButton";
    ListboxButtonImpl.propTypes = {
      arrow: /*#__PURE__*/propTypes.oneOfType([propTypes.node, propTypes.bool]),
      children: /*#__PURE__*/propTypes.oneOfType([propTypes.node, propTypes.func])
    };
  }

  var ListboxButton = /*#__PURE__*/React.memo(ListboxButtonImpl);
  /**
   * @see Docs https://reach.tech/listbox#listboxbutton-props
   */

  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxArrow
   *
   * A wrapper component for an arrow to display in the `ListboxButton`
   *
   * @see Docs https://reach.tech/listbox#listboxarrow
   */
  var ListboxArrowImpl = /*#__PURE__*/React.forwardRef(function ListboxArrow(_ref5, forwardedRef) {
    var _ref5$as = _ref5.as,
        Comp = _ref5$as === void 0 ? "span" : _ref5$as,
        children = _ref5.children,
        props = _objectWithoutPropertiesLoose$3(_ref5, _excluded4);

    var _React$useContext2 = React.useContext(ListboxContext),
        isExpanded = _React$useContext2.isExpanded;

    return /*#__PURE__*/React.createElement(Comp // The arrow provides no semantic value and its inner content should be
    // hidden from the accessibility tree
    , _extends$4({
      "aria-hidden": true
    }, props, {
      ref: forwardedRef,
      "data-reach-listbox-arrow": "",
      "data-expanded": isExpanded ? "" : undefined
    }), isFunction(children) ? children({
      isExpanded: isExpanded,
      // TODO: Remove in 1.0
      expanded: isExpanded
    }) : children || "▼");
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxArrowImpl.displayName = "ListboxArrow";
    ListboxArrowImpl.propTypes = {
      children: /*#__PURE__*/propTypes.oneOfType([propTypes.node, propTypes.func])
    };
  }

  var ListboxArrow = /*#__PURE__*/React.memo(ListboxArrowImpl);
  /**
   * @see Docs https://reach.tech/listbox#listboxarrow-props
   */

  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxPopover
   *
   * The popover containing the list of options.
   *
   * @see Docs https://reach.tech/listbox#listboxpopover
   */
  var ListboxPopoverImpl = /*#__PURE__*/React.forwardRef(function ListboxPopover(_ref6, forwardedRef) {
    var _ref6$as = _ref6.as,
        Comp = _ref6$as === void 0 ? "div" : _ref6$as,
        _ref6$position = _ref6.position,
        position = _ref6$position === void 0 ? positionMatchWidth : _ref6$position,
        onBlur = _ref6.onBlur,
        onKeyDown = _ref6.onKeyDown,
        onMouseUp = _ref6.onMouseUp,
        _ref6$portal = _ref6.portal,
        portal = _ref6$portal === void 0 ? true : _ref6$portal,
        unstable_observableRefs = _ref6.unstable_observableRefs,
        props = _objectWithoutPropertiesLoose$3(_ref6, _excluded5);

    var _React$useContext3 = React.useContext(ListboxContext),
        isExpanded = _React$useContext3.isExpanded,
        buttonRef = _React$useContext3.buttonRef,
        popoverRef = _React$useContext3.popoverRef,
        send = _React$useContext3.send;

    var ref = useComposedRefs(popoverRef, forwardedRef);
    var handleKeyDown = useKeyDown();

    function handleMouseUp() {
      send({
        type: ListboxEvents.ListMouseUp
      });
    }

    var commonProps = _extends$4({
      hidden: !isExpanded,
      tabIndex: -1
    }, props, {
      ref: ref,
      "data-reach-listbox-popover": "",
      onMouseUp: composeEventHandlers(onMouseUp, handleMouseUp),
      onBlur: composeEventHandlers(onBlur, handleBlur),
      onKeyDown: composeEventHandlers(onKeyDown, handleKeyDown)
    });

    function handleBlur(event) {
      var nativeEvent = event.nativeEvent;
      requestAnimationFrame(function () {
        send({
          type: ListboxEvents.Blur,
          relatedTarget: nativeEvent.relatedTarget || nativeEvent.target
        });
      });
    }

    return portal ? /*#__PURE__*/React.createElement(Popover, _extends$4({}, commonProps, {
      as: Comp,
      targetRef: buttonRef,
      position: position,
      unstable_observableRefs: unstable_observableRefs
    })) : /*#__PURE__*/React.createElement(Comp, commonProps);
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxPopoverImpl.displayName = "ListboxPopover";
    ListboxPopoverImpl.propTypes = {
      children: propTypes.node.isRequired,
      portal: propTypes.bool,
      position: propTypes.func
    };
  }

  var ListboxPopover = /*#__PURE__*/React.memo(ListboxPopoverImpl);
  /**
   * @see Docs https://reach.tech/listbox#listboxpopover-props
   */

  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxList
   *
   * The list containing all listbox options.
   *
   * @see Docs https://reach.tech/listbox#listboxlist
   */
  var ListboxList = /*#__PURE__*/React.forwardRef(function ListboxList(_ref7, forwardedRef) {
    var _ref7$as = _ref7.as,
        Comp = _ref7$as === void 0 ? "ul" : _ref7$as,
        props = _objectWithoutPropertiesLoose$3(_ref7, _excluded6);

    var _React$useContext4 = React.useContext(ListboxContext),
        listRef = _React$useContext4.listRef,
        ariaLabel = _React$useContext4.ariaLabel,
        ariaLabelledBy = _React$useContext4.ariaLabelledBy,
        isExpanded = _React$useContext4.isExpanded,
        listboxId = _React$useContext4.listboxId,
        _React$useContext4$st = _React$useContext4.stateData,
        value = _React$useContext4$st.value,
        navigationValue = _React$useContext4$st.navigationValue;

    var ref = useComposedRefs(forwardedRef, listRef);
    return /*#__PURE__*/React.createElement(Comp // Tells assistive technologies which of the options, if any, is
    // visually indicated as having keyboard focus. DOM focus remains on the
    // `ul` element and the idref specified for `aria-activedescendant`
    // refers to the `li` element that is visually styled as focused. When
    // navigation keys, such as `Down Arrow`, are pressed, the JavaScript
    // changes the value.
    // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-grouped.html
    , _extends$4({
      "aria-activedescendant": useOptionId(isExpanded ? navigationValue : value) // If the listbox is not part of another widget, then it has a visible
      // label referenced by `aria-labelledby` on the element with role
      // `listbox`.
      // https://www.w3.org/TR/wai-aria-practices-1.2/#Listbox
      // If an `aria-label` is passed, we should skip `aria-labelledby` to
      // avoid confusion.
      ,
      "aria-labelledby": ariaLabel ? undefined : ariaLabelledBy,
      "aria-label": ariaLabel // An element that contains or owns all the listbox options has role
      // listbox.
      // https://www.w3.org/TR/wai-aria-practices-1.2/#Listbox
      ,
      role: "listbox" // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-collapsible.html
      ,
      tabIndex: -1
    }, props, {
      ref: ref,
      "data-reach-listbox-list": "",
      id: makeId("listbox", listboxId)
    }));
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxList.displayName = "ListboxList";
    ListboxList.propTypes = {};
  }
  /**
   * @see Docs https://reach.tech/listbox#listboxlist-props
   */


  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxOption
   *
   * A selectable option for the listbox.
   *
   * @see Docs https://reach.tech/listbox#listboxoption
   */
  var ListboxOption = /*#__PURE__*/React.forwardRef(function ListboxOption(_ref8, forwardedRef) {
    var _ref8$as = _ref8.as,
        Comp = _ref8$as === void 0 ? "li" : _ref8$as,
        children = _ref8.children,
        disabled = _ref8.disabled,
        indexProp = _ref8.index,
        labelProp = _ref8.label,
        onClick = _ref8.onClick,
        onMouseDown = _ref8.onMouseDown,
        onMouseEnter = _ref8.onMouseEnter,
        onMouseLeave = _ref8.onMouseLeave,
        onMouseMove = _ref8.onMouseMove,
        onMouseUp = _ref8.onMouseUp,
        onTouchStart = _ref8.onTouchStart,
        value = _ref8.value,
        props = _objectWithoutPropertiesLoose$3(_ref8, _excluded7);

    if (process.env.NODE_ENV !== "production" && !value) {
      throw Error("A ListboxOption must have a value prop.");
    }

    var _React$useContext5 = React.useContext(ListboxContext),
        highlightedOptionRef = _React$useContext5.highlightedOptionRef,
        selectedOptionRef = _React$useContext5.selectedOptionRef,
        send = _React$useContext5.send,
        isExpanded = _React$useContext5.isExpanded,
        onValueChange = _React$useContext5.onValueChange,
        state = _React$useContext5.state,
        _React$useContext5$st = _React$useContext5.stateData,
        listboxValue = _React$useContext5$st.value,
        navigationValue = _React$useContext5$st.navigationValue;

    var _React$useState = React.useState(labelProp),
        labelState = _React$useState[0],
        setLabel = _React$useState[1];

    var label = labelProp || labelState || "";
    var ownRef = React.useRef(null);

    var _useStatefulRefValue = useStatefulRefValue(ownRef, null),
        element = _useStatefulRefValue[0],
        handleRefSet = _useStatefulRefValue[1];

    var descendant = React.useMemo(function () {
      return {
        element: element,
        value: value,
        label: label,
        disabled: !!disabled
      };
    }, [disabled, element, label, value]);
    useDescendant(descendant, ListboxDescendantContext, indexProp); // After the ref is mounted to the DOM node, we check to see if we have an
    // explicit label prop before looking for the node's textContent for
    // typeahead functionality.

    var getLabelFromDomNode = React.useCallback(function (node) {
      if (!labelProp && node) {
        setLabel(function (prevState) {
          if (node.textContent && prevState !== node.textContent) {
            return node.textContent;
          }

          return prevState || "";
        });
      }
    }, [labelProp]);
    var isHighlighted = navigationValue ? navigationValue === value : false;
    var isSelected = listboxValue === value;
    var ref = useComposedRefs(getLabelFromDomNode, forwardedRef, handleRefSet, isSelected ? selectedOptionRef : null, isHighlighted ? highlightedOptionRef : null);

    function handleMouseEnter() {
      send({
        type: ListboxEvents.OptionMouseEnter,
        value: value,
        disabled: !!disabled
      });
    }

    function handleTouchStart() {
      send({
        type: ListboxEvents.OptionTouchStart,
        value: value,
        disabled: !!disabled
      });
    }

    function handleMouseLeave() {
      send({
        type: ListboxEvents.ClearNavSelection
      });
    }

    function handleMouseDown(event) {
      // Prevent blur event from firing and bubbling to the popover
      if (!isRightClick(event.nativeEvent)) {
        event.preventDefault();
        send({
          type: ListboxEvents.OptionMouseDown
        });
      }
    }

    function handleMouseUp(event) {
      if (!isRightClick(event.nativeEvent)) {
        send({
          type: ListboxEvents.OptionMouseUp,
          value: value,
          callback: onValueChange,
          disabled: !!disabled
        });
      }
    }

    function handleClick(event) {
      // Generally an option will be selected on mouseup, but in case this isn't
      // handled correctly by the device (whether because it's a touch/pen or
      // virtual click event) we want to handle selection on a full click event
      // just in case. This should address issues with screenreader selection,
      // but this needs more robust testing.
      if (!isRightClick(event.nativeEvent)) {
        send({
          type: ListboxEvents.OptionClick,
          value: value,
          callback: onValueChange,
          disabled: !!disabled
        });
      }
    }

    function handleMouseMove() {
      // We don't really *need* these guards since we put all of our transition
      // logic in the state machine, but in this case it seems wise not to
      // needlessly run our transitions every time the user's mouse moves. Seems
      // like a lot. 🙃
      if (state === ListboxStates.Open || navigationValue !== value) {
        send({
          type: ListboxEvents.OptionMouseMove,
          value: value,
          disabled: !!disabled
        });
      }
    }

    return /*#__PURE__*/React.createElement(Comp // In a single-select listbox, the selected option has `aria-selected`
    // set to `true`.
    // https://www.w3.org/TR/wai-aria-practices-1.2/#Listbox
    , _extends$4({
      "aria-selected": (isExpanded ? isHighlighted : isSelected) || undefined // Applicable to all host language elements regardless of whether a
      // `role` is applied.
      // https://www.w3.org/WAI/PF/aria/states_and_properties#global_states_header
      ,
      "aria-disabled": disabled || undefined // Each option in the listbox has role `option` and is a DOM descendant
      // of the element with role `listbox`.
      // https://www.w3.org/TR/wai-aria-practices-1.2/#Listbox
      ,
      role: "option"
    }, props, {
      ref: ref,
      id: useOptionId(value),
      "data-reach-listbox-option": "",
      "data-current-nav": isHighlighted ? "" : undefined,
      "data-current-selected": isSelected ? "" : undefined,
      "data-label": label,
      "data-value": value,
      onClick: composeEventHandlers(onClick, handleClick),
      onMouseDown: composeEventHandlers(onMouseDown, handleMouseDown),
      onMouseEnter: composeEventHandlers(onMouseEnter, handleMouseEnter),
      onMouseLeave: composeEventHandlers(onMouseLeave, handleMouseLeave),
      onMouseMove: composeEventHandlers(onMouseMove, handleMouseMove),
      onMouseUp: composeEventHandlers(onMouseUp, handleMouseUp),
      onTouchStart: composeEventHandlers(onTouchStart, handleTouchStart)
    }), children);
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxOption.displayName = "ListboxOption";
    ListboxOption.propTypes = {
      disabled: propTypes.bool,
      label: propTypes.string,
      value: propTypes.string.isRequired
    };
  }
  /**
   * @see Docs https://reach.tech/listbox#listboxoption-props
   */


  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxGroup
   *
   * A group of related listbox options.
   *
   * @see Docs https://reach.tech/listbox#listboxgroup
   */
  var ListboxGroup = /*#__PURE__*/React.forwardRef(function ListboxGroup(_ref9, forwardedRef) {
    var _ref9$as = _ref9.as,
        Comp = _ref9$as === void 0 ? "div" : _ref9$as,
        label = _ref9.label,
        children = _ref9.children,
        props = _objectWithoutPropertiesLoose$3(_ref9, _excluded8);

    var _React$useContext6 = React.useContext(ListboxContext),
        listboxId = _React$useContext6.listboxId;

    var labelId = makeId("label", useId(props.id), listboxId);
    return /*#__PURE__*/React.createElement(ListboxGroupContext.Provider, {
      value: {
        labelId: labelId
      }
    }, /*#__PURE__*/React.createElement(Comp // Refers to the element containing the option group label
    // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-grouped.html
    , _extends$4({
      "aria-labelledby": labelId // Identifies a group of related options
      // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-grouped.html
      ,
      role: "group"
    }, props, {
      "data-reach-listbox-group": "",
      ref: forwardedRef
    }), label && /*#__PURE__*/React.createElement(ListboxGroupLabel, null, label), children));
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxGroup.displayName = "ListboxGroup";
    ListboxGroup.propTypes = {
      label: /*#__PURE__*/propTypes.oneOfType([propTypes.string, propTypes.element])
    };
  }
  /**
   * @see Docs https://reach.tech/listbox#listboxgroup-props
   */


  ////////////////////////////////////////////////////////////////////////////////

  /**
   * ListboxGroupLabel
   *
   * @see Docs https://reach.tech/listbox#listboxgrouplabel
   */
  var ListboxGroupLabel = /*#__PURE__*/React.forwardRef(function ListboxGroupLabel(_ref10, forwardedRef) {
    var _ref10$as = _ref10.as,
        Comp = _ref10$as === void 0 ? "span" : _ref10$as,
        props = _objectWithoutPropertiesLoose$3(_ref10, _excluded9);

    var _React$useContext7 = React.useContext(ListboxGroupContext),
        labelId = _React$useContext7.labelId;

    return /*#__PURE__*/React.createElement(Comp // See examples
    // https://www.w3.org/TR/wai-aria-practices-1.2/examples/listbox/listbox-grouped.html
    , _extends$4({
      role: "presentation"
    }, props, {
      ref: forwardedRef,
      "data-reach-listbox-group-label": "",
      id: labelId
    }));
  });

  if (process.env.NODE_ENV !== "production") {
    ListboxGroupLabel.displayName = "ListboxGroupLabel";
    ListboxGroupLabel.propTypes = {};
  }


  function isListboxExpanded(state) {
    return [ListboxStates.Navigating, ListboxStates.Open, ListboxStates.Dragging, ListboxStates.Interacting].includes(state);
  }

  function useKeyDown() {
    var _React$useContext9 = React.useContext(ListboxContext),
        send = _React$useContext9.send,
        listboxDisabled = _React$useContext9.disabled,
        onValueChange = _React$useContext9.onValueChange,
        _React$useContext9$st = _React$useContext9.stateData,
        navigationValue = _React$useContext9$st.navigationValue,
        typeaheadQuery = _React$useContext9$st.typeaheadQuery;

    var options = useDescendants(ListboxDescendantContext);
    var stableOnValueChange = useStableCallback(onValueChange);
    React.useEffect(function () {
      if (typeaheadQuery) {
        send({
          type: ListboxEvents.UpdateAfterTypeahead,
          query: typeaheadQuery,
          callback: stableOnValueChange
        });
      }

      var timeout = window.setTimeout(function () {
        if (typeaheadQuery != null) {
          send({
            type: ListboxEvents.ClearTypeahead
          });
        }
      }, 1000);
      return function () {
        window.clearTimeout(timeout);
      };
    }, [stableOnValueChange, send, typeaheadQuery]);
    var index = options.findIndex(function (_ref11) {
      var value = _ref11.value;
      return value === navigationValue;
    });
    var handleKeyDown = composeEventHandlers(function (event) {
      var key = event.key;
      var isSearching = isString(key) && key.length === 1;
      var navOption = options.find(function (option) {
        return option.value === navigationValue;
      });

      switch (key) {
        case "Enter":
          send({
            type: ListboxEvents.KeyDownEnter,
            value: navigationValue,
            callback: onValueChange,
            disabled: !!(navOption != null && navOption.disabled || listboxDisabled)
          });
          return;

        case " ":
          // Prevent browser from scrolling down
          event.preventDefault();
          send({
            type: ListboxEvents.KeyDownSpace,
            value: navigationValue,
            callback: onValueChange,
            disabled: !!(navOption != null && navOption.disabled || listboxDisabled)
          });
          return;

        case "Escape":
          send({
            type: ListboxEvents.KeyDownEscape
          });
          return;

        case "Tab":
          var eventType = event.shiftKey ? ListboxEvents.KeyDownShiftTab : ListboxEvents.KeyDownTab;
          send({
            type: eventType
          });
          return;

        default:
          if (isSearching) {
            send({
              type: ListboxEvents.KeyDownSearch,
              query: key,
              disabled: listboxDisabled
            });
          }

          return;
      }
    }, useDescendantKeyDown(ListboxDescendantContext, {
      currentIndex: index,
      orientation: "vertical",
      key: "index",
      rotate: true,
      filter: function filter(option) {
        return !option.disabled;
      },
      callback: function callback(nextIndex) {
        send({
          type: ListboxEvents.KeyDownNavigate,
          value: options[nextIndex].value,
          disabled: listboxDisabled
        });
      }
    }));
    return handleKeyDown;
  }

  function useOptionId(value) {
    var _React$useContext10 = React.useContext(ListboxContext),
        listboxId = _React$useContext10.listboxId;

    return value ? makeId("option-" + value, listboxId) : undefined;
  }

  function popoverContainsEventTarget(popover, target) {
    return !!(popover && popover.contains(target));
  } ////////////////////////////////////////////////////////////////////////////////
  // Types


  function useControlledStateSync(controlPropValue, internalValue, send) {
    var _React$useRef = React.useRef(controlPropValue != null),
        isControlled = _React$useRef.current;

    if (isControlled && controlPropValue !== internalValue) {
      send();
    }
  } ////////////////////////////////////////////////////////////////////////////////

  var _templateObject$a, _templateObject2$7, _templateObject3$6, _templateObject4$4, _templateObject5$4;
  var StyledListboxButton = styled__default['default'](ListboxButton)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  height: 2rem;\n  min-width: 7rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 0.75rem;\n  ", ";\n  font-family: ", ";\n  border: 1px solid ", ";\n  border-radius: 0;\n  cursor: pointer;\n\n  &:focus {\n    outline: 1px solid ", ";\n    border-color: ", ";\n  }\n\n  &:focus:not(.focus-visible) {\n    outline: none;\n    border-color: ", ";\n  }\n"])), body30, primaryFont, colors.black, colors.brand, colors.brand, colors.black);
  var ButtonText = styled__default['default'].span(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-right: 0.75rem;\n"])));
  var StyledChevronIcon = styled__default['default'](ChevronDown)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  transform: rotate(0deg);\n  transition: all 300ms ease;\n\n  ", "[aria-expanded=\"true\"] & {\n    transform: rotate(180deg);\n  }\n"])), StyledListboxButton);
  var StyledListboxList = styled__default['default'](ListboxList)(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  margin: 0.5rem 0;\n  background: ", ";\n  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.25);\n  border: 1px solid transparent;\n  padding: 0.5rem 0;\n\n  &:focus {\n    outline: 1px solid ", ";\n    border-color: ", ";\n  }\n\n  &:focus:not(.focus-visible) {\n    outline: none;\n    border-color: transparent;\n  }\n"])), colors.white, colors.brand, colors.brand);
  var StyledListboxOption = styled__default['default'](ListboxOption)(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n  ", ";\n  padding: 0.25rem 0.75rem;\n  white-space: nowrap;\n  user-select: none;\n  cursor: pointer;\n\n  &[data-current-nav] {\n    color: ", ";\n  }\n\n  &[data-current-selected] {\n    font-weight: ", ";\n  }\n"])), body30, colors.brand, fontWeights.bold);

  var Listbox$1 = function Listbox(_ref) {
    var buttonContent = _ref.buttonContent,
        list = _ref.list,
        rest = _objectWithoutProperties(_ref, ["buttonContent", "list"]);

    return /*#__PURE__*/React__default['default'].createElement(ListboxInput, rest, function (_ref2) {
      var valueLabel = _ref2.valueLabel;
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(StyledListboxButton, {
        arrow: /*#__PURE__*/React__default['default'].createElement(StyledChevronIcon, null)
      }, /*#__PURE__*/React__default['default'].createElement(ButtonText, null, buttonContent || valueLabel)), /*#__PURE__*/React__default['default'].createElement(ListboxPopover, null, /*#__PURE__*/React__default['default'].createElement(StyledListboxList, null, list.map(function (option) {
        return /*#__PURE__*/React__default['default'].createElement(StyledListboxOption, {
          key: "listbox-option-".concat(option.value),
          value: option.value
        }, option.label);
      }))));
    });
  };

  Listbox$1.propTypes = {
    list: propTypes.arrayOf(propTypes.shape({
      /** Text label for action option */
      label: propTypes.string.isRequired,

      /** The option's value, which is passed to hidden input field */
      value: propTypes.oneOfType([propTypes.string, propTypes.bool, propTypes.number]).isRequired
    })).isRequired,

    /**
     * Text or content to be displayed on `Listbox`'s triggering button;
     * button will display the currently selected `value` if no `buttonContent` otherwise supplied
     */
    buttonContent: propTypes.oneOfType([propTypes.string, propTypes.element])
  };

  exports.AllTurtlesBadge = AllTurtlesBadge;
  exports.Button = Button$1;
  exports.ChevronDown = ChevronDown;
  exports.Footer = Footer;
  exports.GlobalStyle = GlobalStyle;
  exports.Globe = Globe;
  exports.GlobeAmericas = GlobeAmericas;
  exports.LanguageSelect = LanguageSelect;
  exports.Listbox = Listbox$1;
  exports.Logo = Logo;
  exports.MaxWidth = MaxWidth;
  exports.SelectCaret = SelectCaret;
  exports.SocialIcon = SocialIcon;
  exports.Spinner = Spinner;
  exports.Wordmark = Wordmark;
  exports.websiteUrl = websiteUrl;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
